import { j as _slicedToArray, g as _extends$c, a as _inherits, b as _createClass, c as _classCallCheck, d as _callSuper, e as _defineProperty, f as _objectSpread2, i as _toConsumableArray, _ as _taggedTemplateLiteral } from './_rollupPluginBabelHelpers-047e4aae.js';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import 'react-dom';
import './_rollupPluginBabelHelpers-b9ad31fa-7ae21c08.js';
import styled from 'styled-components';
import { u as useActivify, W as WithTooltip, T as Tooltip } from './withTooltip-92e0dfed.js';
import '@styled-system/space';
import '@styled-system/color';
import '@styled-system/border';
import '@styled-system/variant';
import '@styled-system/typography';
import { I as Icon } from './index-28a062d6-3659b895.js';
import './index-155df85b-a520c7f0.js';
import { B as Button } from './button-fb2021fd.js';
import { T as Text$1 } from './text-5e5c8ea1.js';
import '@styled-system/layout';
import '@styled-system/flexbox';
import '@styled-system/position';
import '@styled-system/shadow';
import { B as Box } from './box-e581bc98.js';
import { T as Text } from './index-5dfda37f-a2c0763c.js';
import { s as styleInject } from './style-inject.es-1f59c1d0.js';
import { G as convertFromActionables, I as convertToActionables, v as addLostKeys, o as getSize, p as getAspectRatio, q as convertFromCarouselItems, u as convertToCarouselItems, P as Portal, J as getFormIconUrl, T as TEXT_VALIDATION_REGEX, L as getFormattedDate, z as sortableHandle, M as FORM_ICON_LIST, R as RichText, N as FORM_FIELD_TYPES, y as sortableElement, O as convertFromFormHSL, Q as convertToFormHSL, x as sortableContainer, C as ConfirmationDialog, H as HSLWrapper, D as Drawer, w as arrayMove, U as EMAIL_VALIDATION_REGEX, d as remove, i as triggerMixPanelEvent, V as sendGoogleAnalyticsEvents, F as File, E as EmojiPicker, c as AddButton, j as isValidURL, k as isVideo, l as KEYS, g as getActionableSubtitle, S as Slider, W as convertFromHSL$7 } from './_converter-d0e3aa12.js';
import './constants-9315121a.js';
import { A as Accordion, R as RephraseBotResponses } from './index-30009c89.js';
import { C as Checkbox, D as Dropdown } from './dropdown-75073a0f.js';
import { T as ToastMessage } from './toastMessage-bc50b53b.js';
import { R as Radio } from './radio-958150e9.js';
import { D as DateInput } from './date-10cb8bbb.js';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var ErrorCross = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M16 16H2V2h14v14zM0 0v18h18V0H0zm14 12.59L12.59 14 9 10.41 5.41 14 4 12.59 7.59 9 4 5.41 5.41 4 9 7.59 12.59 4 14 5.41 10.41 9 14 12.59z",
  fill: "#D91E2D"
})));

var convertFromHSL = function convertFromHSL(HSL) {
  var component = {
    botSays: HSL.text || undefined,
    voiceSays: HSL.voice_text,
    type: HSL.type,
    autoOpenMic: HSL.mic_auto_open,
    _originalHSL: HSL
  };
  component.actionables = convertFromActionables(HSL);
  return component;
};
var convertToHSL = function convertToHSL(component) {
  var HSL = {
    text: component.botSays,
    type: component.type,
    voice_text: component.voiceSays,
    mic_auto_open: component.autoOpenMic,
    data: {}
  };
  HSL.data.items = convertToActionables(component);
  HSL = addLostKeys(HSL, component._originalHSL);
  return HSL;
};

var convertFromHSL$1 = function convertFromHSL(HSL) {
  HSL.data = HSL.data || {};
  var component = {
    botSays: HSL.text,
    type: HSL.type,
    size: getSize(HSL.data.width),
    aspectRatio: getAspectRatio(HSL.data.image_aspect_ratio),
    activeCarouselElementIndex: 0,
    accordionActive: false,
    _originalHSL: HSL
  };
  component.items = convertFromCarouselItems(HSL);
  return component;
};
var convertToHSL$1 = function convertToHSL(component) {
  var HSL = {
    text: component.botSays,
    type: component.type,
    data: {
      image_aspect_ratio: component.aspectRatio.value,
      width: component.size.value
    }
  };
  HSL.data.items = convertToCarouselItems(component);
  HSL = addLostKeys(HSL, component._originalHSL);
  return HSL;
};

function _extends$1() { _extends$1 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }
var PlaceholderIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1({
  width: "53",
  height: "45",
  viewBox: "0 0 53 45",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Chat-Elements",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "mockup-25",
  transform: "translate(-229 -391)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-8",
  transform: "translate(62 80)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-5"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-8",
  transform: "translate(70 263)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-9",
  transform: "translate(97 48)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-166",
  fill: "#82959E",
  x: "0",
  y: "0",
  width: "53",
  height: "45",
  rx: "2"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle-167-Copy",
  fill: "#D5F1FF",
  d: "M48 24.207V6H5v14.557"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48 24.207V32H5V20.557c2.723-.91 5.76-1.668 9-2.057C26.5 17 29 21 38.5 23c2.855.601 6.208.976 9.5 1.207z",
  id: "Rectangle-167",
  fill: "#28CF82"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-84",
  fill: "#F98431",
  cx: "40",
  cy: "13",
  r: "3"
})))))))));

function _extends$2() { _extends$2 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }
var AddForm = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$2({
  width: "52",
  height: "64",
  viewBox: "0 0 52 64",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M44.832 64H3.536A3.536 3.536 0 010 60.464V3.536A3.536 3.536 0 013.536 0h41.296a3.536 3.536 0 013.536 3.536v56.928A3.536 3.536 0 0144.832 64z",
  fill: "#E0ECFC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.487 60.464V3.536A3.536 3.536 0 0112.023 0H3.537A3.536 3.536 0 000 3.536v56.928A3.536 3.536 0 003.537 64h8.486a3.536 3.536 0 01-3.536-3.536z",
  fill: "#C4DDFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42.623 18.21H25.464a1.131 1.131 0 01-1.131-1.132V15.12c0-.625.506-1.132 1.131-1.132h17.159c.625 0 1.131.507 1.131 1.132v1.958c0 .625-.506 1.131-1.131 1.131z",
  fill: "#BDD9FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.754 9.874H4.614a1.273 1.273 0 010-2.546h39.14a1.273 1.273 0 110 2.546zM21.657 17.37H4.614a1.273 1.273 0 010-2.546h17.043a1.273 1.273 0 010 2.546z",
  fill: "#2767D7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42.623 57.233H5.745a1.132 1.132 0 01-1.131-1.131v-9.236c0-.625.507-1.132 1.131-1.132h36.878c.625 0 1.131.507 1.131 1.132v9.236c0 .625-.506 1.132-1.131 1.132zM42.623 26.695H25.464a1.131 1.131 0 01-1.131-1.13v-1.96c0-.624.506-1.13 1.131-1.13h17.159c.625 0 1.131.506 1.131 1.13v1.96c0 .624-.506 1.13-1.131 1.13z",
  fill: "#BDD9FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.657 25.856H4.614a1.273 1.273 0 010-2.546h17.043a1.273 1.273 0 010 2.546z",
  fill: "#2767D7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42.623 35.18H25.464a1.132 1.132 0 01-1.131-1.132V32.09c0-.625.506-1.132 1.131-1.132h17.159c.625 0 1.131.507 1.131 1.132v1.958c0 .625-.506 1.132-1.131 1.132z",
  fill: "#BDD9FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.657 34.343H4.614a1.273 1.273 0 010-2.545h17.043a1.273 1.273 0 010 2.545zM43.754 41.415H4.614a1.273 1.273 0 110-2.546h39.14a1.273 1.273 0 010 2.546z",
  fill: "#2767D7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.779 27.808l-.684-.198c-.88-.253-1.335-1.366-1.015-2.486l3.157-11.05c.32-1.12 1.293-1.821 2.173-1.568l.684.197c.88.254 1.335 1.367 1.015 2.487l-3.157 11.05c-.32 1.12-1.292 1.821-2.173 1.568z",
  fill: "#FFC34C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36.993 42.325l-2.679 9.597.029.155.786 2.906c.095.349.448.453.708.208l2.285-2.148 2.679-9.596-3.808-1.122z",
  fill: "#FFEA63"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.934 52.525l-.028-.155 2.673-9.578-1.586-.468-2.679 9.597.029.155.786 2.906c.095.349.448.453.708.208l.653-.613-.556-2.052z",
  fill: "#FFD551"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.69 53.588l.362 1.308c.102.37.487.481.77.221l.997-.916-2.13-.613z",
  fill: "#A56021"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.117 50.282l-4.41-1.27c-.407-.117-.631-.578-.502-1.03L45.628 7.98c.492-1.722 2.145-2.758 3.693-2.312l.276.08c1.548.445 2.404 2.203 1.912 3.925L40.086 49.676c-.129.451-.563.723-.968.606z",
  fill: "#FFA730"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.372 49.747c-.406-.117-.63-.578-.501-1.03L48.293 8.714c.353-1.236 1.305-2.114 2.386-2.35a2.664 2.664 0 00-1.082-.618l-.276-.08c-1.548-.445-3.201.59-3.693 2.313L34.205 47.982c-.129.452.095.913.502 1.03l4.41 1.27a.69.69 0 00.205.026l-1.95-.561z",
  fill: "#E58D23"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50.136 14.544l-5.698-1.57a.778.778 0 01-.543-.957l.138-.502a.778.778 0 01.957-.543l5.698 1.57a.778.778 0 01.543.957l-.138.502a.778.778 0 01-.957.543z",
  fill: "#FFEA63"
}), /*#__PURE__*/React.createElement("path", {
  d: "M46.713 12.723l.102-.37c.124-.451.553-.726.958-.614l-2.8-.772c-.404-.111-.833.163-.957.614l-.102.37c-.125.45.103.906.508 1.018l2.799.772c-.405-.112-.632-.568-.508-1.018z",
  fill: "#FFD551"
}), /*#__PURE__*/React.createElement("path", {
  d: "M46.85 21.672a.849.849 0 01-.819-1.075l.47-1.705a.848.848 0 111.636.451l-.47 1.706a.849.849 0 01-.817.623zM43.475 33.917a.849.849 0 01-.819-1.075l2.721-9.87a.848.848 0 111.636.45l-2.72 9.871a.849.849 0 01-.818.624z",
  fill: "#FFC34C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45.676 60.116a.849.849 0 01-.849-.848v-22.5a.849.849 0 011.698 0v22.5c0 .468-.38.848-.85.848z",
  fill: "#FCF9DE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.614 7.328a1.273 1.273 0 000 2.546h3.872V7.328H4.614zM4.614 38.869a1.273 1.273 0 000 2.546h3.872v-2.546H4.614zM4.614 31.798a1.273 1.273 0 000 2.545h3.872v-2.545H4.614zM4.614 23.31a1.273 1.273 0 000 2.546h3.872V23.31H4.614zM4.614 14.824a1.273 1.273 0 000 2.546h3.872v-2.546H4.614z",
  fill: "#0D4CB9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.745 45.734c-.624 0-1.131.507-1.131 1.132v9.236c0 .625.507 1.132 1.131 1.132h2.741v-11.5h-2.74zM13.135 5.885a2.144 2.144 0 100-4.288 2.144 2.144 0 000 4.288z",
  fill: "#74CADC"
})));

function _extends$3() { _extends$3 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }
var AddFormField = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$3({
  width: "30",
  height: "20",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M9.9 4.5H8.1v3.6H4.5v1.8h3.6v3.6h1.8V9.9h3.6V8.1H9.9V4.5zM9 0C4.032 0 0 4.032 0 9s4.032 9 9 9 9-4.032 9-9-4.032-9-9-9zm0 16.2c-3.969 0-7.2-3.231-7.2-7.2 0-3.969 3.231-7.2 7.2-7.2 3.969 0 7.2 3.231 7.2 7.2 0 3.969-3.231 7.2-7.2 7.2z",
  fill: "#0E4498"
})));

function _extends$4() { _extends$4 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }
var NoIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$4({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-4.42 3.58-8 8-8 1.85 0 3.55.63 4.9 1.69L5.69 16.9A7.902 7.902 0 014 12zm8 8c-1.85 0-3.55-.63-4.9-1.69L18.31 7.1A7.902 7.902 0 0120 12c0 4.42-3.58 8-8 8z",
  fill: "#DA251C"
})));

/**
 * This code is taken from relement's usePositioner hook.
 * We want to show tooltip/popup just above the view which is clicked.
 * So this function calculates the coordinates of the position at which we want to show popup.
 * @param {object} attachTo element which is clicked and around which we want to show popup.
 * @param {object} attachee popup view
 */
function usePositioner(_ref) {
  var attachTo = _ref.attachTo,
    attachee = _ref.attachee;
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  useEffect(function () {
    if (!attachTo.current || !attachee.current) return;
    var rect = attachTo.current.getBoundingClientRect();
    var tooltipRect = attachee.current.getBoundingClientRect();
    var coordinates = {};

    // Here we're checking if we've space to show the popup 
    // in the TOP. Else we'll show it in bottom.
    if (rect.top > tooltipRect.height + 10) {
      coordinates.top = rect.top - tooltipRect.height - 10;
      coordinates.position = "TOP";
    } else {
      coordinates.top = rect.bottom + 10;
      coordinates.position = "BOTTOM";
    }
    coordinates.left = rect.left - tooltipRect.width / 2 + rect.width / 2;
    var leftDiff = rect.left + rect.width / 2 - tooltipRect.width / 2 - 8;
    var rightDiff = window.innerWidth - (rect.left + rect.width / 2 + tooltipRect.width / 2) - 8;
    if (leftDiff < 0) {
      coordinates.left -= leftDiff;
    } else {
      leftDiff = 0;
    }
    if (rightDiff < 0) {
      coordinates.left += rightDiff;
    } else {
      rightDiff = 0;
    }
    setValue(coordinates);
  }, [attachee.current, attachTo.current]);
  return value;
}

var css_248z = ".PopupList_modalWrapper__3HDKR {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1099999999999; }\n\n.PopupList_tooltip__G0m9V {\n  opacity: 0;\n  position: absolute;\n  z-index: 2;\n  filter: drop-shadow(rgba(0, 0, 0, 0.5) 0px 0px 1px);\n  transition: 0.1s ease-in-out;\n  transform: translate3d(0, 4px, 0); }\n  .PopupList_tooltipActive__32sUh {\n    opacity: 1;\n    transform: translate3d(0, 0, 0); }\n  .PopupList_tooltipArrowTop__3UPdc {\n    position: absolute;\n    left: 50%;\n    margin-left: -6px;\n    border: 6px solid;\n    border-top-color: white;\n    border-right-color: transparent !important;\n    border-bottom-color: transparent !important;\n    border-left-color: transparent !important;\n    top: 100%;\n    margin-top: 0; }\n  .PopupList_tooltipArrowBottom__3XYRg {\n    position: absolute;\n    left: 50%;\n    margin-left: -6px;\n    border: 6px solid;\n    border-top-color: transparent !important;\n    border-right-color: transparent !important;\n    border-bottom-color: white;\n    border-left-color: transparent !important;\n    margin-top: -12px;\n    top: 0; }\n  .PopupList_tooltipCross__3k73- {\n    right: 0;\n    padding: 14px;\n    position: absolute; }\n  .PopupList_tooltipContent__3ZOuy {\n    max-width: 320px;\n    min-width: 320px;\n    max-height: 254px;\n    border-radius: 3px;\n    padding: 8px 0;\n    color: black;\n    background-color: white;\n    overflow-y: auto;\n    overflow-x: hidden; }\n    .PopupList_tooltipContent__3ZOuy.PopupList_bottom__1gbLG {\n      margin-top: -8px; }\n    .PopupList_tooltipContentNoneOption__1agN1 {\n      display: flex;\n      line-height: 24px;\n      padding: 8px 16px; }\n      .PopupList_tooltipContentNoneOptionIcon__7dSYg {\n        margin-right: 16px; }\n      .PopupList_tooltipContentNoneOption__1agN1 span {\n        font-size: 14px;\n        color: #DA251C; }\n      .PopupList_tooltipContentNoneOption__1agN1:hover {\n        background-color: #f1f0f0; }\n    .PopupList_tooltipContentItem__1PNZ3 {\n      display: flex;\n      font-size: 14px;\n      line-height: 24px;\n      padding: 8px 16px; }\n      .PopupList_tooltipContentItem__1PNZ3 img {\n        margin-right: 16px; }\n      .PopupList_tooltipContentItem__1PNZ3:hover {\n        background-color: #f1f0f0; }\n";
var styles = {"modalWrapper":"PopupList_modalWrapper__3HDKR","tooltip":"PopupList_tooltip__G0m9V","tooltipActive":"PopupList_tooltipActive__32sUh","tooltipArrowTop":"PopupList_tooltipArrowTop__3UPdc","tooltipArrowBottom":"PopupList_tooltipArrowBottom__3XYRg","tooltipCross":"PopupList_tooltipCross__3k73-","tooltipContent":"PopupList_tooltipContent__3ZOuy","bottom":"PopupList_bottom__1gbLG","tooltipContentNoneOption":"PopupList_tooltipContentNoneOption__1agN1","tooltipContentNoneOptionIcon":"PopupList_tooltipContentNoneOptionIcon__7dSYg","tooltipContentItem":"PopupList_tooltipContentItem__1PNZ3"};
styleInject(css_248z);

var modalRoot = document.getElementById("portal-root");
if (!modalRoot) {
  modalRoot = document.createElement("div");
  modalRoot.setAttribute("id", "portal-root");
  document.body.appendChild(modalRoot);
}

/**
 * A simple modal view which will be used as picker for form field type and form field icons.
 */
function PopupList(_ref) {
  var attachTo = _ref.attachTo,
    onSelect = _ref.onSelect,
    onClose = _ref.onClose,
    list = _ref.list,
    showNone = _ref.showNone,
    active = _ref.active;
  var tooltipRef = React.useRef();
  var coordinates = usePositioner({
    attachTo: attachTo,
    attachee: tooltipRef,
    offset: undefined
  });
  var _useActivify = useActivify(active),
    enabled = _useActivify.enabled,
    visible = _useActivify.visible;

  /**
   * This method renders an optional None option
   * for the case where user do not want to select any option.
   * If user select this option, undefined will be set as value
   * to clear any previous value.
   */
  var renderNoneOption = function renderNoneOption() {
    if (!showNone) return null;
    return /*#__PURE__*/React.createElement("div", {
      className: styles.tooltipContentNoneOption,
      onClick: function onClick() {
        return onSelect(undefined);
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      src: NoIcon,
      className: styles.tooltipContentNoneOptionIcon
    }), /*#__PURE__*/React.createElement("span", null, "No Icon"));
  };
  if (!attachTo || !enabled) return null;
  var tooltipClass = visible ? styles.tooltipActive : "";
  var arrowClass = coordinates.position === "TOP" ? styles.tooltipArrowTop : styles.tooltipArrowBottom;
  return /*#__PURE__*/React.createElement(Portal, {
    node: document && document.getElementById("portal-root")
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.modalWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles.tooltip, " ").concat(tooltipClass),
    ref: tooltipRef,
    style: {
      left: coordinates.left,
      top: coordinates.top
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: arrowClass
  }), /*#__PURE__*/React.createElement(Icon, {
    src: "closeV2",
    className: styles.tooltipCross,
    onClick: onClose
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.tooltipContent
  }, renderNoneOption(), list.map(function (item) {
    return /*#__PURE__*/React.createElement("div", {
      className: styles.tooltipContentItem,
      onClick: function onClick() {
        return onSelect(item);
      }
    }, /*#__PURE__*/React.createElement("img", {
      src: getFormIconUrl(item.icon)
    }), /*#__PURE__*/React.createElement("span", null, item.name));
  })))));
}
PopupList.propTypes = {
  attachTo: PropTypes.object,
  active: PropTypes.bool,
  onSelect: PropTypes.func,
  showNone: PropTypes.bool,
  list: PropTypes.arrayOf({
    name: PropTypes.string,
    icon: PropTypes.string
  }),
  onClose: PropTypes.func
};
PopupList.__docgenInfo = {
  "description": "A simple modal view which will be used as picker for form field type and form field icons.",
  "methods": [],
  "displayName": "PopupList",
  "props": {
    "attachTo": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    },
    "active": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "onSelect": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "showNone": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "list": {
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "custom",
          "raw": "{\n  name: PropTypes.string,\n  icon: PropTypes.string,\n}"
        }
      },
      "required": false,
      "description": ""
    },
    "onClose": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    }
  }
};

function _extends$5() { _extends$5 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }
var Reorder = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$5({
  width: "10",
  height: "16",
  viewBox: "0 0 10 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M4 14c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zM2 6C.9 6 0 6.9 0 8s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6C.9 0 0 .9 0 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z",
  fill: "#595959"
})));

function _extends$6() { _extends$6 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }
var Delete = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$6({
  width: "12",
  height: "16",
  viewBox: "0 0 12 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M.857 14.222C.857 15.2 1.63 16 2.571 16H9.43c.942 0 1.714-.8 1.714-1.778V3.556H.857v10.666zm1.714-8.889H9.43v8.89H2.57v-8.89zM9 .89L8.143 0H3.857L3 .889H0v1.778h12V.889H9z",
  fill: "#595959"
})));

var css_248z$1 = ".FormFieldItem_fieldContainer__2S4sM {\n  border: 1px solid #d9d9d9;\n  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);\n  border-radius: 4px;\n  margin: 16px;\n  background-color: white;\n  position: relative; }\n  .FormFieldItem_fieldContainer__2S4sM .FormFieldItem_header__2SDzB {\n    padding: 12px 12px 0 12px;\n    display: flex; }\n    .FormFieldItem_fieldContainer__2S4sM .FormFieldItem_headerType__2do0c {\n      font-weight: 600;\n      font-size: 12px;\n      line-height: 16px;\n      letter-spacing: 0.05em;\n      color: #858585; }\n    .FormFieldItem_fieldContainer__2S4sM .FormFieldItem_headerDrag__2m_el {\n      right: 26px;\n      margin-right: 12px;\n      height: 16px;\n      width: 10px;\n      position: absolute; }\n    .FormFieldItem_fieldContainer__2S4sM .FormFieldItem_headerDelete__2Hcho {\n      right: 0;\n      margin-right: 14px;\n      height: 16px;\n      width: 12px;\n      position: absolute; }\n      .FormFieldItem_fieldContainer__2S4sM .FormFieldItem_headerDelete__2Hcho svg:hover path {\n        fill: #DA251C; }\n  .FormFieldItem_fieldContainer__2S4sM .FormFieldItem_defaultField__2jT6_ {\n    margin: 10px 12px 0 12px; }\n  .FormFieldItem_fieldContainer__2S4sM .FormFieldItem_field__2qUjO {\n    margin: 10px 12px 0 12px;\n    height: 38px;\n    border: 1px solid #D9D9D9;\n    border-radius: 4px; }\n    .FormFieldItem_fieldContainer__2S4sM .FormFieldItem_field__2qUjO:hover {\n      border: 1px solid #6FB2FF;\n      border-radius: 4px; }\n    .FormFieldItem_fieldContainer__2S4sM .FormFieldItem_fieldHint__nd3_K {\n      outline: none;\n      border: none;\n      font-size: 14px;\n      margin-left: 10px;\n      margin-top: 2px;\n      width: 220px; }\n      .FormFieldItem_fieldContainer__2S4sM .FormFieldItem_fieldHint__nd3_K::placeholder {\n        color: #858585; }\n    .FormFieldItem_fieldContainer__2S4sM .FormFieldItem_fieldIcon__2hk4d {\n      display: flex;\n      padding: 7px; }\n      .FormFieldItem_fieldContainer__2S4sM .FormFieldItem_fieldIconChangeButton__7F7Ax {\n        margin-left: 5px;\n        margin-top: 6px;\n        width: 14px;\n        height: 14px; }\n        .FormFieldItem_fieldContainer__2S4sM .FormFieldItem_fieldIconChangeButton__7F7Ax svg path {\n          fill: #595959; }\n        .FormFieldItem_fieldContainer__2S4sM .FormFieldItem_fieldIconChangeButton__7F7Ax svg:hover path {\n          fill: #1DA92A; }\n  .FormFieldItem_fieldContainer__2S4sM .FormFieldItem_mandatory__3sJXr {\n    display: flex;\n    margin-top: 16px; }\n    .FormFieldItem_fieldContainer__2S4sM .FormFieldItem_mandatoryCheckbox__326Rb {\n      margin: 0 5px 0 12px; }\n    .FormFieldItem_fieldContainer__2S4sM .FormFieldItem_mandatory__3sJXr svg {\n      margin-top: 3px; }\n  .FormFieldItem_fieldContainer__2S4sM .FormFieldItem_setEntity__3I600 {\n    margin: 16px 12px 0 12px; }\n    .FormFieldItem_fieldContainer__2S4sM .FormFieldItem_setEntity__3I600-label {\n      color: black !important;\n      font-size: 14px;\n      font-weight: 500;\n      margin-top: -3px;\n      padding-right: 4px; }\n    .FormFieldItem_fieldContainer__2S4sM .FormFieldItem_setEntity__3I600-input {\n      height: 36px;\n      border-radius: 4px; }\n      .FormFieldItem_fieldContainer__2S4sM .FormFieldItem_setEntity__3I600-input-input {\n        font-size: 14px; }\n  .FormFieldItem_fieldContainer__2S4sM .FormFieldItem_additionalOption__3a3w8 {\n    margin: 13px; }\n    .FormFieldItem_fieldContainer__2S4sM .FormFieldItem_additionalOption__3a3w8-label {\n      color: black;\n      font-size: 14px;\n      font-weight: 500; }\n    .FormFieldItem_fieldContainer__2S4sM .FormFieldItem_additionalOption__3a3w8-textinput {\n      margin: 0px;\n      height: 36px;\n      border-radius: 4px; }\n  .FormFieldItem_fieldContainer__2S4sM .FormFieldItem_advanceOption__2bIek {\n    margin-top: 16px;\n    padding: 0 12px; }\n    .FormFieldItem_fieldContainer__2S4sM .FormFieldItem_advanceOptionHeader__3hO2y {\n      padding: 14px 0px;\n      font-weight: 500;\n      font-size: 16px;\n      line-height: 20px;\n      color: #000000;\n      display: flex; }\n      .FormFieldItem_fieldContainer__2S4sM .FormFieldItem_advanceOptionHeaderIcon__38NhB {\n        right: 0;\n        position: absolute; }\n    .FormFieldItem_fieldContainer__2S4sM .FormFieldItem_advanceOption__2bIek-body {\n      padding-bottom: 12px; }\n    .FormFieldItem_fieldContainer__2S4sM .FormFieldItem_advanceOption__2bIek .FormFieldItem_validations__3xvTO .FormFieldItem_heading__2bRVB {\n      font-weight: 500;\n      font-size: 16px;\n      line-height: 20px;\n      margin-top: 6px;\n      margin-bottom: 10px;\n      color: #000000; }\n    .FormFieldItem_fieldContainer__2S4sM .FormFieldItem_advanceOption__2bIek .FormFieldItem_validations__3xvTO .FormFieldItem_defaultValidationRadio__3WUPj-text {\n      color: #333333;\n      font-weight: 600;\n      font-size: 16px;\n      line-height: 22px; }\n    .FormFieldItem_fieldContainer__2S4sM .FormFieldItem_advanceOption__2bIek .FormFieldItem_validations__3xvTO .FormFieldItem_defaultValidationList__1wVFD-options {\n      margin-left: 26px;\n      display: block; }\n    .FormFieldItem_fieldContainer__2S4sM .FormFieldItem_advanceOption__2bIek .FormFieldItem_validations__3xvTO .FormFieldItem_defaultValidationList__1wVFD-option {\n      margin-top: 6px; }\n      .FormFieldItem_fieldContainer__2S4sM .FormFieldItem_advanceOption__2bIek .FormFieldItem_validations__3xvTO .FormFieldItem_defaultValidationList__1wVFD-option-text {\n        font-size: 14px;\n        line-height: 19px;\n        color: #333333; }\n    .FormFieldItem_fieldContainer__2S4sM .FormFieldItem_advanceOption__2bIek .FormFieldItem_validations__3xvTO .FormFieldItem_fixedLengthCheckbox__1lpnw {\n      margin-left: 26px;\n      margin-top: 6px; }\n      .FormFieldItem_fieldContainer__2S4sM .FormFieldItem_advanceOption__2bIek .FormFieldItem_validations__3xvTO .FormFieldItem_fixedLengthCheckbox__1lpnw-text {\n        font-size: 14px;\n        line-height: 19px;\n        color: #333333; }\n    .FormFieldItem_fieldContainer__2S4sM .FormFieldItem_advanceOption__2bIek .FormFieldItem_validations__3xvTO .FormFieldItem_fixedLengthInput__1-xsn {\n      margin-left: 14px; }\n      .FormFieldItem_fieldContainer__2S4sM .FormFieldItem_advanceOption__2bIek .FormFieldItem_validations__3xvTO .FormFieldItem_fixedLengthInput__1-xsn-textinput {\n        height: 36px;\n        border-radius: 4px; }\n    .FormFieldItem_fieldContainer__2S4sM .FormFieldItem_advanceOption__2bIek .FormFieldItem_validations__3xvTO .FormFieldItem_customValidationRadio__1qn_L {\n      margin-top: 14px; }\n      .FormFieldItem_fieldContainer__2S4sM .FormFieldItem_advanceOption__2bIek .FormFieldItem_validations__3xvTO .FormFieldItem_customValidationRadio__1qn_L-text {\n        color: #333333;\n        font-weight: 600;\n        font-size: 16px;\n        line-height: 22px; }\n    .FormFieldItem_fieldContainer__2S4sM .FormFieldItem_advanceOption__2bIek .FormFieldItem_validations__3xvTO .FormFieldItem_customValidationInput__1LiNA {\n      margin-left: 14px; }\n      .FormFieldItem_fieldContainer__2S4sM .FormFieldItem_advanceOption__2bIek .FormFieldItem_validations__3xvTO .FormFieldItem_customValidationInput__1LiNA-textinput {\n        height: 36px;\n        border-radius: 4px; }\n    .FormFieldItem_fieldContainer__2S4sM .FormFieldItem_advanceOption__2bIek .FormFieldItem_validations__3xvTO .FormFieldItem_numberValidationRadio__2PEMl {\n      margin-top: 8px; }\n    .FormFieldItem_fieldContainer__2S4sM .FormFieldItem_advanceOption__2bIek .FormFieldItem_validations__3xvTO .FormFieldItem_numberValidationInput__2Qz01 {\n      margin-left: 14px; }\n      .FormFieldItem_fieldContainer__2S4sM .FormFieldItem_advanceOption__2bIek .FormFieldItem_validations__3xvTO .FormFieldItem_numberValidationInput__2Qz01-input {\n        font-size: 14px;\n        line-height: 19px;\n        color: #333333; }\n      .FormFieldItem_fieldContainer__2S4sM .FormFieldItem_advanceOption__2bIek .FormFieldItem_validations__3xvTO .FormFieldItem_numberValidationInput__2Qz01-textinput {\n        height: 36px;\n        border-radius: 4px; }\n    .FormFieldItem_fieldContainer__2S4sM .FormFieldItem_advanceOption__2bIek .FormFieldItem_validations__3xvTO .FormFieldItem_dateValidationCheckbox__1Z6ZU {\n      margin-top: 8px; }\n      .FormFieldItem_fieldContainer__2S4sM .FormFieldItem_advanceOption__2bIek .FormFieldItem_validations__3xvTO .FormFieldItem_dateValidationCheckbox__1Z6ZU-text {\n        font-size: 14px;\n        line-height: 19px;\n        color: #333333 !important; }\n    .FormFieldItem_fieldContainer__2S4sM .FormFieldItem_advanceOption__2bIek .FormFieldItem_validations__3xvTO .FormFieldItem_dateValidationInput__2Uk1z {\n      margin-left: 28px;\n      margin-top: 6px; }\n      .FormFieldItem_fieldContainer__2S4sM .FormFieldItem_advanceOption__2bIek .FormFieldItem_validations__3xvTO .FormFieldItem_dateValidationInput__2Uk1z-input {\n        border: 1px solid #ddd;\n        box-sizing: border-box;\n        height: 36px;\n        border-radius: 4px; }\n        .FormFieldItem_fieldContainer__2S4sM .FormFieldItem_advanceOption__2bIek .FormFieldItem_validations__3xvTO .FormFieldItem_dateValidationInput__2Uk1z-input input {\n          font-size: 14px; }\n      .FormFieldItem_fieldContainer__2S4sM .FormFieldItem_advanceOption__2bIek .FormFieldItem_validations__3xvTO .FormFieldItem_dateValidationInput__2Uk1z-label {\n        color: black;\n        font-size: 14px;\n        font-weight: 500; }\n    .FormFieldItem_fieldContainer__2S4sM .FormFieldItem_advanceOption__2bIek .FormFieldItem_validations__3xvTO .FormFieldItem_errorMessageInput__h57kb {\n      margin-top: 16px;\n      margin-bottom: 8px; }\n      .FormFieldItem_fieldContainer__2S4sM .FormFieldItem_advanceOption__2bIek .FormFieldItem_validations__3xvTO .FormFieldItem_errorMessageInput__h57kb-label {\n        font-weight: 500;\n        font-size: 16px;\n        line-height: 20px;\n        color: #000000; }\n      .FormFieldItem_fieldContainer__2S4sM .FormFieldItem_advanceOption__2bIek .FormFieldItem_validations__3xvTO .FormFieldItem_errorMessageInput__h57kb-textinput {\n        margin: 0;\n        border-radius: 4px;\n        height: 36px; }\n      .FormFieldItem_fieldContainer__2S4sM .FormFieldItem_advanceOption__2bIek .FormFieldItem_validations__3xvTO .FormFieldItem_errorMessageInput__h57kb-input {\n        font-size: 14px; }\n";
var styles$1 = {"fieldContainer":"FormFieldItem_fieldContainer__2S4sM","header":"FormFieldItem_header__2SDzB","headerType":"FormFieldItem_headerType__2do0c","headerDrag":"FormFieldItem_headerDrag__2m_el","headerDelete":"FormFieldItem_headerDelete__2Hcho","defaultField":"FormFieldItem_defaultField__2jT6_","field":"FormFieldItem_field__2qUjO","fieldHint":"FormFieldItem_fieldHint__nd3_K","fieldIcon":"FormFieldItem_fieldIcon__2hk4d","fieldIconChangeButton":"FormFieldItem_fieldIconChangeButton__7F7Ax","mandatory":"FormFieldItem_mandatory__3sJXr","mandatoryCheckbox":"FormFieldItem_mandatoryCheckbox__326Rb","setEntity":"FormFieldItem_setEntity__3I600","additionalOption":"FormFieldItem_additionalOption__3a3w8","advanceOption":"FormFieldItem_advanceOption__2bIek","advanceOptionHeader":"FormFieldItem_advanceOptionHeader__3hO2y","advanceOptionHeaderIcon":"FormFieldItem_advanceOptionHeaderIcon__38NhB","validations":"FormFieldItem_validations__3xvTO","heading":"FormFieldItem_heading__2bRVB","defaultValidationRadio":"FormFieldItem_defaultValidationRadio__3WUPj","defaultValidationList":"FormFieldItem_defaultValidationList__1wVFD","fixedLengthCheckbox":"FormFieldItem_fixedLengthCheckbox__1lpnw","fixedLengthInput":"FormFieldItem_fixedLengthInput__1-xsn","customValidationRadio":"FormFieldItem_customValidationRadio__1qn_L","customValidationInput":"FormFieldItem_customValidationInput__1LiNA","numberValidationRadio":"FormFieldItem_numberValidationRadio__2PEMl","numberValidationInput":"FormFieldItem_numberValidationInput__2Qz01","dateValidationCheckbox":"FormFieldItem_dateValidationCheckbox__1Z6ZU","dateValidationInput":"FormFieldItem_dateValidationInput__2Uk1z","errorMessageInput":"FormFieldItem_errorMessageInput__h57kb"};
styleInject(css_248z$1);

var validations = {
  text: [{
    label: "Default Validation",
    component: Radio.Item,
    props: function props(field, styles, _onChange) {
      return {
        value: field.isDefaultValidation,
        prefixClassName: styles.defaultValidationRadio,
        onChange: function onChange(value) {
          if (value) {
            // clear old values
            _onChange("regex", undefined);
            _onChange("isDefaultValidation", true);
            _onChange("isCustomValidation", false);
          }
        }
      };
    }
  }, {
    component: Radio,
    props: function props(field, styles, _onChange2) {
      return {
        value: {
          value: field.regex
        },
        optionKey: "value",
        invisible: !field.isDefaultValidation,
        prefixClassName: styles.defaultValidationList,
        onChange: function onChange(option) {
          return _onChange2("regex", option.value);
        },
        options: TEXT_VALIDATION_REGEX
      };
    }
  }, {
    label: "Fixed Length",
    component: Checkbox.Item,
    props: function props(field, styles, _onChange3) {
      return {
        value: field.isFixedLengthValidation,
        invisible: !field.isDefaultValidation,
        prefixClassName: styles.fixedLengthCheckbox,
        onChange: function onChange(value) {
          return _onChange3("isFixedLengthValidation", value);
        }
      };
    }
  }, {
    component: Text,
    props: function props(field, styles, _onChange4, errors) {
      return {
        value: field.fixedLength,
        invisible: !field.isFixedLengthValidation || !field.isDefaultValidation,
        prefixClassName: styles.fixedLengthInput,
        onChange: function onChange(value) {
          return _onChange4("fixedLength", value);
        },
        error: errors.fixedLength,
        placeholder: "E.g 120 characters"
      };
    }
  }, {
    label: "Custom Validation",
    component: Radio.Item,
    props: function props(field, styles, _onChange5) {
      return {
        value: field.isCustomValidation,
        prefixClassName: styles.customValidationRadio,
        onChange: function onChange(value) {
          if (value) {
            // clear old values
            _onChange5("regex", undefined);
            _onChange5("isFixedLengthValidation", false);
            _onChange5("fixedLength", undefined);
            _onChange5("isCustomValidation", true);
            _onChange5("isDefaultValidation", false);
          }
        }
      };
    }
  }, {
    component: Text,
    props: function props(field, styles, _onChange6) {
      return {
        value: field.regex,
        invisible: !field.isCustomValidation,
        prefixClassName: styles.customValidationInput,
        onChange: function onChange(value) {
          return _onChange6("regex", value);
        },
        placeholder: "Enter regex pattern"
      };
    }
  }],
  number: [{
    label: "Fixed Length",
    component: Radio.Item,
    props: function props(field, styles, _onChange7) {
      return {
        value: field.isFixedLengthValidation,
        prefixClassName: styles.numberValidationRadio,
        onChange: function onChange(value) {
          if (value) {
            _onChange7("isFixedLengthValidation", true);
            _onChange7("isRangeValidation", false);
            // clear old values
            _onChange7("rangeStart", undefined);
            _onChange7("rangeEnd", undefined);
          }
        }
      };
    }
  }, {
    component: Text,
    props: function props(field, styles, _onChange8, errors) {
      return {
        value: field.fixedLength,
        invisible: !field.isFixedLengthValidation,
        prefixClassName: styles.numberValidationInput,
        error: errors.fixedLength,
        onChange: function onChange(value) {
          return _onChange8("fixedLength", value);
        },
        placeholder: "E.g 120 characters"
      };
    }
  }, {
    label: "Range",
    component: Radio.Item,
    props: function props(field, styles, _onChange9) {
      return {
        value: field.isRangeValidation,
        prefixClassName: styles.numberValidationRadio,
        onChange: function onChange(value) {
          if (value) {
            _onChange9("isRangeValidation", true);
            _onChange9("isFixedLengthValidation", false);
            _onChange9("fixedLength", undefined);
          }
        }
      };
    }
  }, {
    component: Text,
    props: function props(field, styles, _onChange10) {
      return {
        value: field.rangeStart,
        invisible: !field.isRangeValidation,
        prefixClassName: styles.numberValidationInput,
        onChange: function onChange(value) {
          return _onChange10("rangeStart", value);
        },
        placeholder: "Define minimum allowed digits"
      };
    }
  }, {
    component: Text,
    props: function props(field, styles, _onChange11) {
      return {
        value: field.rangeEnd,
        invisible: !field.isRangeValidation,
        prefixClassName: styles.numberValidationInput,
        onChange: function onChange(value) {
          return _onChange11("rangeEnd", value);
        },
        placeholder: "Define maximum allowed digits"
      };
    }
  }],
  date: [{
    label: "Starts On",
    component: Checkbox.Item,
    props: function props(field, styles, _onChange12) {
      return {
        value: field.isStartDateValidation,
        prefixClassName: styles.dateValidationCheckbox,
        onChange: function onChange(value) {
          _onChange12("isStartDateValidation", value);
          if (value) {
            // set current date
            _onChange12("startDate", getFormattedDate(new Date()));
          } else {
            // clear old values
            _onChange12("startDate", undefined);
          }
        }
      };
    }
  }, {
    component: DateInput,
    props: function props(field, styles, _onChange13) {
      return {
        value: field.startDate,
        invisible: !field.isStartDateValidation,
        prefixClassName: styles.dateValidationInput,
        onChange: function onChange(date) {
          _onChange13("startDate", getFormattedDate(date));
        }
      };
    }
  }, {
    label: "Ends On",
    component: Checkbox.Item,
    props: function props(field, styles, _onChange14) {
      return {
        value: field.isEndDateValidation,
        prefixClassName: styles.dateValidationCheckbox,
        onChange: function onChange(value) {
          _onChange14("isEndDateValidation", value);
          if (value) {
            // set current date
            _onChange14("endDate", getFormattedDate(new Date()));
          } else {
            // clear old values
            _onChange14("endDate", undefined);
          }
        }
      };
    }
  }, {
    component: DateInput,
    props: function props(field, styles, _onChange15) {
      return {
        value: field.endDate,
        invisible: !field.isEndDateValidation,
        prefixClassName: styles.dateValidationInput,
        onChange: function onChange(date) {
          _onChange15("endDate", getFormattedDate(date));
        }
      };
    }
  }]
};

var DragHandle = sortableHandle(function () {
  return /*#__PURE__*/React.createElement(Icon, {
    src: Reorder,
    className: styles$1.headerDrag
  });
});
var getPlaceholderTextForDefaultField = function getPlaceholderTextForDefaultField(fieldType) {
  var fields = FORM_FIELD_TYPES.filter(function (field) {
    return field.type === fieldType;
  });
  if (fields.length && fields[0].defaultFieldPlaceholder) return fields[0].defaultFieldPlaceholder;
  return "Type here";
};
function FormFieldItem(_ref) {
  var field = _ref.field,
    fieldIndex = _ref.fieldIndex,
    entities = _ref.entities,
    _onChange = _ref.onChange,
    onDeleteField = _ref.onDeleteField,
    fieldErrors = _ref.fieldErrors,
    entitySearchURL = _ref.entitySearchURL,
    jsonPickerButton = _ref.jsonPickerButton,
    displayGlobalConstantSelect = _ref.displayGlobalConstantSelect,
    globalConstantsURL = _ref.globalConstantsURL;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showAccordian = _useState2[0],
    setShowAccordian = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showIconPicker = _useState4[0],
    setShowIconPicker = _useState4[1];
  var addButtonRef = /*#__PURE__*/React.createRef();
  var errors = fieldErrors || {};
  var hasErrors = Object.keys(errors).length > 0;
  var handleOnChnage = function handleOnChnage(key, value) {
    _onChange(fieldIndex, key, value);
  };
  var renderAdvanceOptionHeader = function renderAdvanceOptionHeader() {
    return /*#__PURE__*/React.createElement("div", {
      className: styles$1.advanceOptionHeader
    }, "Advanced Options", /*#__PURE__*/React.createElement(Icon, {
      src: "angle-down",
      className: styles$1.advanceOptionHeaderIcon
    }));
  };

  /**
   * This method render validation inputs according
   * to the type of form field.
   */
  var renderValidations = function renderValidations() {
    var validationList = validations[field.type];
    if (!validationList) return null;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: styles$1.heading
    }, "Validation"), validations[field.type].map(function (input) {
      var Input = input.component;
      var inputProps = input.props(field, styles$1, handleOnChnage, errors);
      if (inputProps.invisible) return null;
      return /*#__PURE__*/React.createElement(Input, _extends$c({}, inputProps, {
        label: input.label
      }));
    }));
  };

  /**
   * This method is triggered when ever user change the form icon.
   * @param {object} item this contains the selected icon or will be undefined if no icon is selected.
   */
  var handleIconChange = function handleIconChange(item) {
    if (item) {
      _onChange(fieldIndex, "icon", item.icon);
    } else {
      _onChange(fieldIndex, "icon", undefined);
    }
    setShowIconPicker(false);
  };

  /**
   * This will render error message inputs.
   * This will be visible always irrespective of field type.
   */
  var renderErrorMessageField = function renderErrorMessageField() {
    return /*#__PURE__*/React.createElement(Text, {
      label: "Error Message",
      value: field.errorMessage,
      prefixClassName: styles$1.errorMessageInput,
      className: styles$1.errorMessageInput,
      placeholder: "Write a short error message here...",
      onChange: function onChange(value) {
        return _onChange(fieldIndex, "errorMessage", value);
      }
    });
  };

  /**
   * This methods renders validation and error message inputs for the form field.
   */
  var renderAdvanceOptions = function renderAdvanceOptions() {
    return /*#__PURE__*/React.createElement(Accordion.Item, {
      active: showAccordian,
      prefixClassName: styles$1.advanceOption,
      onChange: function onChange() {
        return setShowAccordian(!showAccordian);
      },
      renderHeader: renderAdvanceOptionHeader
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$1.validations
    }, renderValidations(), renderErrorMessageField()));
  };
  var containerStyle = hasErrors ? {
    borderColor: '#DA251C'
  } : {};
  return /*#__PURE__*/React.createElement("div", {
    className: styles$1.fieldContainer,
    style: containerStyle
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$1.header
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$1.headerType
  }, "FIELD TYPE - ", field.type.toUpperCase()), /*#__PURE__*/React.createElement(DragHandle, null), /*#__PURE__*/React.createElement(Icon, {
    src: Delete,
    className: styles$1.headerDelete,
    onClick: function onClick() {
      return onDeleteField(fieldIndex);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: styles$1.field
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$1.fieldIcon
  }, field.icon && /*#__PURE__*/React.createElement("img", {
    src: getFormIconUrl(field.icon ? field.icon : "form_text")
  }), /*#__PURE__*/React.createElement(WithTooltip, {
    tooltip: "More Icons"
  }, /*#__PURE__*/React.createElement(Icon, {
    src: AddFormField,
    innerRef: addButtonRef,
    onClick: function onClick() {
      return setShowIconPicker(true);
    },
    className: styles$1.fieldIconChangeButton
  })), /*#__PURE__*/React.createElement(PopupList, {
    list: FORM_ICON_LIST,
    attachTo: addButtonRef,
    showNone: true,
    active: showIconPicker,
    onSelect: handleIconChange,
    onClose: function onClose() {
      return setShowIconPicker(false);
    }
  }), /*#__PURE__*/React.createElement("input", {
    type: "text",
    onChange: function onChange(d) {
      return _onChange(fieldIndex, "hint", d.target.value);
    },
    className: styles$1.fieldHint,
    placeholder: "Hint text...",
    value: field.hint
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles$1.mandatory
  }, /*#__PURE__*/React.createElement(Checkbox.Item, {
    label: "Mandatory",
    value: field.required,
    className: styles$1.mandatoryCheckbox,
    onChange: function onChange(e) {
      return _onChange(fieldIndex, "required", e);
    }
  }), /*#__PURE__*/React.createElement(WithTooltip, {
    tooltip: 'A field is  mandatory if it’s corresponding "Set Entity" is mandatory.',
    tooltipPosition: "BOTTOM"
  }, /*#__PURE__*/React.createElement(Icon, {
    src: "info",
    size: "small"
  }))), (field.type === "picker" || field.type === "multiPicker") && /*#__PURE__*/React.createElement(Text, {
    error: errors.errorMessage,
    label: "Picker Options",
    placeholder: field.type === "multiPicker" ? "Enter comma seperated options (max 10 options allowed)" : "Enter comma seperated options",
    prefixClassName: styles$1.additionalOption,
    value: field.options,
    onChange: function onChange(value) {
      return _onChange(fieldIndex, "options", value);
    }
  }), field.type === "search" && /*#__PURE__*/React.createElement(Text, {
    label: "API URL",
    prefixClassName: styles$1.additionalOption,
    placeholder: "Paste API link here",
    value: field.searchSource,
    onChange: function onChange(value) {
      return _onChange(fieldIndex, "searchSource", value);
    }
  }), field.type !== "search" && /*#__PURE__*/React.createElement("div", {
    className: styles$1.defaultField
  }, /*#__PURE__*/React.createElement(RichText, {
    className: "input-margin",
    value: field.preFilledValue,
    onChange: function onChange(value) {
      return _onChange(fieldIndex, "preFilledValue", value);
    },
    placeholder: getPlaceholderTextForDefaultField(field.type),
    label: "Prefilled Values",
    multiline: true,
    withHeader: true,
    entitySearchURL: entitySearchURL,
    jsonPickerButton: jsonPickerButton,
    displayGlobalConstantSelect: displayGlobalConstantSelect,
    globalConstantsURL: globalConstantsURL
  })), /*#__PURE__*/React.createElement(Dropdown, {
    placeholder: "Select an Entity",
    prefixClassName: styles$1.setEntity,
    label: "Set Entity",
    options: entities,
    error: errors.key,
    optionKey: "title",
    tooltip: "The entity to be set by this field once the form is submitted.",
    value: field.key,
    onChange: function onChange(option) {
      _onChange(fieldIndex, "key", option.title);
      _onChange(fieldIndex, "required", option.mandatory);
    }
  }), renderAdvanceOptions());
}
FormFieldItem.propTypes = {
  field: PropTypes.object,
  fieldIndex: PropTypes.number,
  entities: PropTypes.array,
  onChange: PropTypes.func,
  onDeleteField: PropTypes.func,
  fieldErrors: PropTypes.object
};
FormFieldItem.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "FormFieldItem",
  "props": {
    "field": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    },
    "fieldIndex": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "entities": {
      "type": {
        "name": "array"
      },
      "required": false,
      "description": ""
    },
    "onChange": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onDeleteField": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "fieldErrors": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    }
  }
};

var SortableFormFieldItem = sortableElement(FormFieldItem);
function FormFieldsView(_ref) {
  var fields = _ref.fields,
    entities = _ref.entities,
    onChange = _ref.onChange,
    onDeleteField = _ref.onDeleteField,
    fieldsErrors = _ref.fieldsErrors,
    entitySearchURL = _ref.entitySearchURL,
    jsonPickerButton = _ref.jsonPickerButton,
    displayGlobalConstantSelect = _ref.displayGlobalConstantSelect,
    globalConstantsURL = _ref.globalConstantsURL;
  return /*#__PURE__*/React.createElement("div", null, fields.map(function (field, index) {
    return /*#__PURE__*/React.createElement(SortableFormFieldItem, {
      index: index,
      onDeleteField: onDeleteField,
      fieldIndex: index,
      entities: entities,
      field: field,
      fieldErrors: fieldsErrors[index],
      onChange: onChange,
      entitySearchURL: entitySearchURL,
      jsonPickerButton: jsonPickerButton,
      displayGlobalConstantSelect: displayGlobalConstantSelect,
      globalConstantsURL: globalConstantsURL
    });
  }));
}
FormFieldsView.propTypes = {
  onDeleteField: PropTypes.func,
  onChange: PropTypes.func,
  fields: PropTypes.array,
  entities: PropTypes.array,
  fieldsErrors: PropTypes.array
};
FormFieldsView.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "FormFieldsView",
  "props": {
    "onDeleteField": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onChange": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "fields": {
      "type": {
        "name": "array"
      },
      "required": false,
      "description": ""
    },
    "entities": {
      "type": {
        "name": "array"
      },
      "required": false,
      "description": ""
    },
    "fieldsErrors": {
      "type": {
        "name": "array"
      },
      "required": false,
      "description": ""
    }
  }
};

var css_248z$2 = ".DrawerHeader_drawerHeader__Win3x {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px;\n  border-bottom: 1px solid #eee; }\n\n.DrawerHeader_leftColumn__3DjqF,\n.DrawerHeader_rightColumn__tei2q {\n  display: flex;\n  align-items: center; }\n\n.DrawerHeader_icon__11zqF {\n  margin-right: 8px;\n  margin-left: 14px;\n  cursor: pointer;\n  opacity: 0.7; }\n  .DrawerHeader_icon__11zqF:hover {\n    opacity: 1; }\n\n.DrawerHeader_doneButton__1QL4h {\n  margin-right: 12px; }\n\n.DrawerHeader_copyButton__1ndKL {\n  width: auto;\n  color: #000;\n  font-size: 14px;\n  border-radius: 5px;\n  transition: 0.2s ease-out;\n  padding: 4px; }\n  .DrawerHeader_copyButton__1ndKL:before {\n    content: 'COPY JSON';\n    font-size: 12px;\n    white-space: nowrap;\n    position: relative;\n    width: 1px;\n    visibility: hidden; }\n  .DrawerHeader_copyButton__1ndKL:hover {\n    background-color: #eee; }\n    .DrawerHeader_copyButton__1ndKL:hover:before {\n      visibility: visible;\n      padding: 0 6px;\n      width: 64px; }\n";
var styles$2 = {"drawerHeader":"DrawerHeader_drawerHeader__Win3x","leftColumn":"DrawerHeader_leftColumn__3DjqF","rightColumn":"DrawerHeader_rightColumn__tei2q","icon":"DrawerHeader_icon__11zqF","doneButton":"DrawerHeader_doneButton__1QL4h","copyButton":"DrawerHeader_copyButton__1ndKL"};
styleInject(css_248z$2);

var DrawerHeader = function DrawerHeader(_ref) {
  var onClose = _ref.onClose,
    onCopy = _ref.onCopy,
    onDone = _ref.onDone;
  return /*#__PURE__*/React.createElement("div", {
    className: styles$2.drawerHeader
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$2.leftColumn
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onDone,
    className: styles$2.doneButton
  }, "Done"), "Form Builder"), /*#__PURE__*/React.createElement("div", {
    className: styles$2.rightColumn
  }, /*#__PURE__*/React.createElement(Icon, {
    onClick: onCopy,
    className: styles$2.copyButton,
    src: "synonym_duplicate"
  }), /*#__PURE__*/React.createElement(Icon, {
    onClick: onClose,
    className: styles$2.icon,
    src: "close"
  })));
};
DrawerHeader.propTypes = {
  onClose: PropTypes.func,
  onCopy: PropTypes.func,
  onDone: PropTypes.func
};
DrawerHeader.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "DrawerHeader",
  "props": {
    "onClose": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onCopy": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onDone": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    }
  }
};

var convertFromHSL$2 = function convertFromHSL(HSL) {
  var component = {
    title: HSL.title,
    subtitle: HSL.subtitle,
    type: HSL.type,
    preSubmitText: HSL.pre_submit_text || null,
    postSubmitText: HSL.post_submit_text || null,
    showCustomSubmitInputs: HSL.pre_submit_text || HSL.post_submit_text,
    errors: {},
    fieldsErrors: []
  };
  component.fields = convertFromFormHSL(HSL);
  return component;
};
var convertToHSL$2 = function convertToHSL(component) {
  var HSL = {
    title: component.title,
    subtitle: component.subtitle,
    type: component.type,
    pre_submit_text: component.preSubmitText,
    post_submit_text: component.postSubmitText,
    // This help us to identify that the form HSL is build from bot builder not admin tools.
    from_bot_builder: true
  };
  HSL.fields = convertToFormHSL(component);
  return HSL;
};

var GA = {
  CATEGORIES: {
    FORMS: 'FORMS'
  },
  ACTIONS: {
    FORM_ICON: 'FORM_ICON',
    FORM_SUBMIT_TEXT: 'FORM_SUBMIT_TEXT'
  },
  LABEL: {
    HAVE_ICONS: 'HAVE_ICONS',
    NO_ICONS: 'NO_ICONS',
    DEFAULT_TEXT: 'DEFAULT_TEXT'
  }
};

var css_248z$3 = ".HSLForms_form__3F6HA {\n  background: #fafafa;\n  height: 100%;\n  overflow: auto; }\n  .HSLForms_formHeader__3yWoY {\n    border: 1px solid #f2f2f2;\n    background-color: white; }\n    .HSLForms_formHeaderTitle__axbkO {\n      margin: 16px; }\n      .HSLForms_formHeaderTitle__axbkO input {\n        font-size: 14px; }\n    .HSLForms_formHeaderSubtitle__f0e8u {\n      margin: 16px; }\n      .HSLForms_formHeaderSubtitle__f0e8u textarea {\n        line-height: 20px;\n        min-height: 100px;\n        max-height: 100px;\n        font-size: 14px; }\n  .HSLForms_formBody__ikWBG {\n    padding-bottom: 100px;\n    background: #fafafa;\n    overflow: auto; }\n    .HSLForms_formBodyNoFieldView__2TDPi {\n      height: 100%;\n      background: #fafafa;\n      padding-top: 56px; }\n      .HSLForms_formBodyNoFieldViewIcon__305zy {\n        margin: 0 auto;\n        width: 144px;\n        height: 144px;\n        background: #e5e5e547;\n        border-radius: 72px;\n        align-content: center;\n        display: flex;\n        flex-wrap: wrap;\n        justify-content: center; }\n      .HSLForms_formBodyNoFieldViewMessage__3yhF8 {\n        margin: 20px 57px;\n        text-align: center; }\n    .HSLForms_formBodyAddFieldButton__3bQTB {\n      cursor: pointer;\n      width: 125px;\n      display: flex;\n      color: #0e4498;\n      font-weight: 600;\n      font-size: 16px;\n      line-height: 22px;\n      margin-top: 16px; }\n    .HSLForms_formBodySubmitButtonCheckbox__1Ciya {\n      margin-left: 16px;\n      margin-top: 14px; }\n      .HSLForms_formBodySubmitButtonCheckbox__1Ciya-text {\n        font-weight: 500;\n        font-size: 16px;\n        line-height: 22px;\n        color: #000000; }\n    .HSLForms_formBodySubmitButtonInputs__2jALU {\n      margin-left: 22px;\n      margin-right: 8px; }\n      .HSLForms_formBodySubmitButtonInputs__2jALU-textinput {\n        border: 1px solid #bdbdbd;\n        box-sizing: border-box;\n        height: 36px;\n        border-radius: 4px; }\n      .HSLForms_formBodySubmitButtonInputs__2jALU-label {\n        margin-left: 20px; }\n      .HSLForms_formBodySubmitButtonInputs__2jALU input {\n        font-size: 14px; }\n\n.HSLForms_preview__e7Xek {\n  position: relative;\n  background: #ffffff;\n  border: 1px solid #dddddd;\n  box-sizing: border-box;\n  border-radius: 4px;\n  max-width: 298px;\n  min-width: 298px; }\n  .HSLForms_previewError__sAvdm {\n    border: 1px solid #ef8b93; }\n  .HSLForms_previewForm__26ZF- {\n    padding: 14px;\n    min-height: 25px; }\n    .HSLForms_previewFormTitle__2tPBG {\n      color: #000000;\n      font-weight: 600;\n      font-size: 16px;\n      line-height: 22px; }\n    .HSLForms_previewFormSubtitle__4Sulw {\n      margin-top: 4px;\n      color: #595959;\n      font-size: 14px;\n      line-height: 20px; }\n    .HSLForms_previewFormFields__3_zHU {\n      margin-top: 16px; }\n      .HSLForms_previewFormFieldsItem__h49pM {\n        min-height: 36px;\n        margin-bottom: 8px;\n        background: #ffffff;\n        border: 1px solid #bdbdbd;\n        box-sizing: border-box;\n        border-radius: 4px;\n        padding: 6px;\n        font-size: 14px;\n        display: flex; }\n        .HSLForms_previewFormFieldsItem__h49pM span {\n          font-size: 14px;\n          line-height: 24px;\n          color: #a6a6a6;\n          margin-left: 8px; }\n  .HSLForms_previewSubmitButton__2rNDe {\n    min-height: 42px;\n    background: #fafafa;\n    padding: 12px;\n    border-top: 1px solid #dddddd;\n    box-sizing: border-box;\n    border-radius: 0px 0px 5px 5px;\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 17px;\n    text-align: center;\n    color: #d9d9d9; }\n\n.HSLForms_sortableElement__BhpXT {\n  z-index: 10002;\n  box-shadow: 0 10px 30px rgba(1, 1, 1, 0.1); }\n\n.HSLForms_overlay__ucZ98 {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  bottom: 0;\n  cursor: not-allowed; }\n";
var styles$3 = {"form":"HSLForms_form__3F6HA","formHeader":"HSLForms_formHeader__3yWoY","formHeaderTitle":"HSLForms_formHeaderTitle__axbkO","formHeaderSubtitle":"HSLForms_formHeaderSubtitle__f0e8u","formBody":"HSLForms_formBody__ikWBG","formBodyNoFieldView":"HSLForms_formBodyNoFieldView__2TDPi","formBodyNoFieldViewIcon":"HSLForms_formBodyNoFieldViewIcon__305zy","formBodyNoFieldViewMessage":"HSLForms_formBodyNoFieldViewMessage__3yhF8","formBodyAddFieldButton":"HSLForms_formBodyAddFieldButton__3bQTB","formBodySubmitButtonCheckbox":"HSLForms_formBodySubmitButtonCheckbox__1Ciya","formBodySubmitButtonInputs":"HSLForms_formBodySubmitButtonInputs__2jALU","preview":"HSLForms_preview__e7Xek","previewError":"HSLForms_previewError__sAvdm","previewForm":"HSLForms_previewForm__26ZF-","previewFormTitle":"HSLForms_previewFormTitle__2tPBG","previewFormSubtitle":"HSLForms_previewFormSubtitle__4Sulw","previewFormFields":"HSLForms_previewFormFields__3_zHU","previewFormFieldsItem":"HSLForms_previewFormFieldsItem__h49pM","previewSubmitButton":"HSLForms_previewSubmitButton__2rNDe","sortableElement":"HSLForms_sortableElement__BhpXT","overlay":"HSLForms_overlay__ucZ98"};
styleInject(css_248z$3);

var _dec, _dec2, _dec3, _class;
var SortableFormFieldsView = sortableContainer(FormFieldsView);
var HSLForms = (_dec = ToastMessage(), _dec2 = ConfirmationDialog(), _dec3 = HSLWrapper(), _dec(_class = _dec2(_class = _dec3(_class = /*#__PURE__*/function (_React$Component) {
  function HSLForms(_props) {
    var _this;
    _classCallCheck(this, HSLForms);
    _this = _callSuper(this, HSLForms, [_props]);
    _defineProperty(_this, "emptyField", {
      autoFill: null,
      autoFillSource: null,
      hint: "",
      icon: null,
      key: "",
      fixedLength: null,
      options: null,
      order: 1,
      searchPlaceholder: null,
      searchSource: null,
      type: "text",
      regex: "^(.|\\n)*$",
      errorMessage: "",
      required: false,
      rangeStart: undefined,
      rangeEnd: undefined,
      startDate: undefined,
      endDate: undefined,
      isDefaultValidation: true,
      isCustomValidation: false,
      isFixedLengthValidation: false,
      isRangeValidation: false,
      isStartDateValidation: false,
      isEndDateValidation: false,
      preFilledValue: null
    });
    _defineProperty(_this, "initialState", {
      type: "FORM",
      title: "",
      subtitle: "",
      preSubmitText: null,
      postSubmitText: null,
      fields: [],
      errors: {},
      fieldsErrors: [],
      hasErrors: false
    });
    _defineProperty(_this, "reset", function (nextProps, shouldAssignStateDirectly) {
      var props = nextProps || _this.props || {};
      var value = props.value ? convertFromHSL$2(props.value) : _objectSpread2({}, _this.initialState);
      if (shouldAssignStateDirectly) {
        _this.state = value;
        _this.props.onStateChange();
      } else {
        _this.setState(value);
      }
    });
    _defineProperty(_this, "_renderDrawer", function () {
      if (_this.props.state) return null;
      return /*#__PURE__*/React.createElement(Drawer, {
        zIndex: 10001,
        placement: "RIGHT",
        active: _this.props.drawerActive,
        noDisable: _this.state.hasErrors // Restrict the drawer from dismissing if any errors.
        ,
        onClose: _this._save,
        width: 400
      }, /*#__PURE__*/React.createElement(DrawerHeader, {
        onCopy: _this._copy,
        onDone: _this._save,
        onClose: _this._showConfirmationDialog
      }), /*#__PURE__*/React.createElement("div", {
        className: styles$3.formBody
      }, _this._renderFormHeader(), _this._renderFormBody()));
    });
    _defineProperty(_this, "_openDrawer", function () {
      var _this$props$value = _this.props.value,
        value = _this$props$value === void 0 ? {} : _this$props$value;
      if (value.supported_response === false) {
        return;
      }
      if (_this.props.readOnly) {
        _this._copy();
        return;
      }
      _this.props.activateDrawer();
    });
    /**
     * This methods renders the live preview of form HSL.
     */
    _defineProperty(_this, "_renderForm", function () {
      var _this$props$value2 = _this.props.value,
        value = _this$props$value2 === void 0 ? {} : _this$props$value2;
      var errorClass = "";
      if (value.supported_response === false) {
        errorClass = styles$3.previewError;
      }
      return /*#__PURE__*/React.createElement("div", {
        onClick: _this._openDrawer,
        className: "".concat(styles$3.preview, " ").concat(errorClass)
      }, /*#__PURE__*/React.createElement("div", {
        className: styles$3.previewForm
      }, /*#__PURE__*/React.createElement("div", {
        className: styles$3.previewFormTitle
      }, _this.state.title), /*#__PURE__*/React.createElement("div", {
        className: styles$3.previewFormSubtitle
      }, _this.state.subtitle), /*#__PURE__*/React.createElement("div", {
        className: styles$3.previewFormFields
      }, _this.state.fields.map(function (field) {
        return /*#__PURE__*/React.createElement("div", {
          className: styles$3.previewFormFieldsItem
        }, field.icon && /*#__PURE__*/React.createElement("img", {
          src: getFormIconUrl(field.icon)
        }), /*#__PURE__*/React.createElement(Text$1, {
          variant: "body.md",
          color: "grey.deep"
        }, field.preFilledValue && field.preFilledValue.trim().length ? field.preFilledValue : field.hint));
      }))), /*#__PURE__*/React.createElement("div", {
        className: styles$3.previewSubmitButton
      }, _this.state.preSubmitText || "Submit"), errorClass && /*#__PURE__*/React.createElement("div", {
        className: styles$3.overlay
      }));
    });
    _defineProperty(_this, "_renderFormHeader", function () {
      return /*#__PURE__*/React.createElement("div", {
        className: styles$3.formHeader
      }, /*#__PURE__*/React.createElement(Text, {
        label: "Form Title",
        className: styles$3.formHeaderTitle,
        onChange: function onChange(value) {
          return _this._setState({
            title: value,
            changed: true
          });
        },
        value: _this.state.title
      }), /*#__PURE__*/React.createElement(Text, {
        label: "Form Description",
        className: styles$3.formHeaderSubtitle,
        multiline: true,
        onChange: function onChange(value) {
          return _this._setState({
            subtitle: value,
            changed: true
          });
        },
        value: _this.state.subtitle
      }));
    });
    /**
     * This method renders the custom submit button inputs if the user has opted for it.
     */
    _defineProperty(_this, "_renderCustomSubmitButtonView", function () {
      var _this$state = _this.state,
        errors = _this$state.errors,
        showCustomSubmitInputs = _this$state.showCustomSubmitInputs,
        preSubmitText = _this$state.preSubmitText,
        postSubmitText = _this$state.postSubmitText;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Checkbox.Item, {
        prefixClassName: styles$3.formBodySubmitButtonCheckbox,
        label: "Add Custom Submit Button Text",
        value: showCustomSubmitInputs,
        onChange: function onChange(value) {
          return _this.setState({
            showCustomSubmitInputs: value,
            preSubmitText: null,
            postSubmitText: null
          });
        }
      }), showCustomSubmitInputs && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
        prefixClassName: styles$3.formBodySubmitButtonInputs,
        value: preSubmitText,
        error: errors && errors.preSubmitText,
        placeholder: "Add before Submit Text, e.g. \u2018Send\u2019",
        onChange: function onChange(value) {
          return _this._setState({
            preSubmitText: value,
            changed: true
          });
        }
      }), /*#__PURE__*/React.createElement(Text, {
        value: postSubmitText,
        error: errors && errors.postSubmitText,
        prefixClassName: styles$3.formBodySubmitButtonInputs,
        placeholder: "Add after Submit Text, e.g. \u2018Sent\u2019",
        onChange: function onChange(value) {
          return _this.setState({
            postSubmitText: value
          });
        }
      })));
    });
    /**
     * This method renders sortable form fields, add field button and custom submit button view.
     */
    _defineProperty(_this, "_renderFormBody", function () {
      return /*#__PURE__*/React.createElement("div", {
        className: styles$3.formBody
      }, _this.state.fields.length > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SortableFormFieldsView, {
        fields: _this.state.fields,
        entities: _this.props.entities,
        onChange: _this._handleFieldChange,
        onDeleteField: _this._handleDeleteField,
        fieldsErrors: _this.state.fieldsErrors,
        lockAxis: "y",
        useDragHandle: true,
        lockToContainerEdges: true,
        helperClass: styles$3.sortableElement,
        onSortEnd: _this._onSortEnd,
        entitySearchURL: _this.props.entitySearchURL,
        jsonPickerButton: _this.props.jsonPickerButton,
        displayGlobalConstantSelect: _this.props.displayGlobalConstantSelect,
        globalConstantsURL: _this.props.globalConstantsURL
      }), _this._renderAddFieldButton(), _this._renderCustomSubmitButtonView()) : _this._renderNoFieldView());
    });
    /**
     * This methods first validate the form data and then form fields data
     * and then put these errors in respective error arrays.
     */
    _defineProperty(_this, "_validate", function () {
      var errors = {};
      var hasErrors = false;
      var _this$state2 = _this.state,
        showCustomSubmitInputs = _this$state2.showCustomSubmitInputs,
        fields = _this$state2.fields,
        preSubmitText = _this$state2.preSubmitText,
        postSubmitText = _this$state2.postSubmitText;
      if (showCustomSubmitInputs && fields.length > 0) {
        // custom submit button is selected button use has not filled the value
        if (!preSubmitText || !preSubmitText.trim()) {
          errors.preSubmitText = "Pre Submit text can't be empty.";
          hasErrors = true;
        }
        if (!postSubmitText || !postSubmitText.trim()) {
          errors.postSubmitText = "Post Submit text can't be empty.";
          hasErrors = true;
        }
      }
      var fieldsErrors = fields.map(function (field) {
        var fieldErrors = {};
        if (!field.key) {
          // No entity is selected
          fieldErrors.key = "Please select an entity.";
          hasErrors = true;
        }
        if (field.type === "multiPicker" && (field.options || "").split(",").length > 10) {
          fieldErrors.errorMessage = "Max 10 options are allowed.";
          hasErrors = true;
        }
        if (field.isFixedLengthValidation && !field.fixedLength) {
          // Fixed length is selected but user has not filed value.
          fieldErrors.fixedLength = "Define character length.";
          hasErrors = true;
        }
        return fieldErrors;
      });
      _this.setState({
        errors: errors,
        hasErrors: hasErrors,
        fieldsErrors: fieldsErrors
      });
      if (hasErrors) {
        _this.props.activateToastMessage("Looks like one or more fields are incomplete. Please fill in all the mandatory info in order to move forward.");
      }
      return !hasErrors;
    });
    /**
     * This method sorts the field list after Drag N Drop gesture.
     */
    _defineProperty(_this, "_onSortEnd", function (_ref) {
      var oldIndex = _ref.oldIndex,
        newIndex = _ref.newIndex;
      _this._setState(function (_ref2) {
        var fields = _ref2.fields;
        return {
          fields: arrayMove(fields, oldIndex, newIndex),
          changed: true
        };
      });
    });
    /**
     * This method updates the state whenever somthing is changed in form's field.
     * @param {number} index index of form field changed
     * @param {*} key key that is changed in field
     * @param {*} value nre value for the key
     */
    _defineProperty(_this, "_handleFieldChange", function (index, key, value) {
      var fields = _this.state.fields;
      fields[index][key] = value;
      if (key === "isFixedLengthValidation" && !value) fields[index].fixedLength = null;
      _this._setState({
        fields: fields,
        changed: true
      });
    });
    /**
     * This method renders no field added view.
     */
    _defineProperty(_this, "_renderNoFieldView", function () {
      return /*#__PURE__*/React.createElement("div", {
        className: styles$3.formBodyNoFieldView
      }, /*#__PURE__*/React.createElement("div", {
        className: styles$3.formBodyNoFieldViewIcon
      }, /*#__PURE__*/React.createElement(AddForm, null)), /*#__PURE__*/React.createElement("div", {
        className: styles$3.formBodyNoFieldViewMessage
      }, " ", "Start building your form by adding fields to it!", " "), _this._renderAddFieldButton());
    });
    /**
     * This method renders add field button. This method will open PopupList,
     * from which user can select desired field type.
     */
    _defineProperty(_this, "_renderAddFieldButton", function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: styles$3.formBodyAddFieldButton,
        onClick: _this._showAddFieldPopup,
        style: {
          margin: _this.state.fields.length > 0 ? "12px" : "0 auto"
        },
        ref: _this._addFieldfRef
      }, /*#__PURE__*/React.createElement(AddFormField, null), " Add a Field"), /*#__PURE__*/React.createElement(PopupList, {
        list: FORM_FIELD_TYPES,
        attachTo: _this._addFieldfRef,
        onClose: _this._closeAddFieldPopup,
        onSelect: _this._handleAddField,
        active: _this.state.showAddFieldPopup
      }));
    });
    /**
     * This method will add a new field in the form HSL.
     * @param {object} item selected field type.
     */
    _defineProperty(_this, "_handleAddField", function (item) {
      var fields = _this.state.fields;
      var newIndex = fields.length + 1;
      var newField = _objectSpread2(_objectSpread2({}, _this.emptyField), {}, {
        type: item.type,
        icon: item.icon,
        order: newIndex
      });
      if (item.type === "email") {
        // If field type is email, add email validation.
        newField.regex = EMAIL_VALIDATION_REGEX;
      }
      fields.push(newField);
      _this._setState({
        fields: fields,
        changed: true
      });
      _this._closeAddFieldPopup();
    });
    /**
     * This method deletes a field from the form HSL. It'll
     * show a confirmation popup and will delete field once
     * user accepts the confirmation.
     * @param {number} fieldIndex index of field that needs to be deleted
     */
    _defineProperty(_this, "_handleDeleteField", function (fieldIndex) {
      _this._setState({
        deleteFieldIndex: fieldIndex,
        changed: true
      });
      _this.props.activateConfirmationDialog({
        title: "Delete Field",
        message: "Are you sure you want to delete this field?",
        positiveText: "Delete",
        negativeText: "Not Now",
        themed: true
      }, function (isConfirmed) {
        if (isConfirmed) {
          var fields = remove(_this.state.fields, fieldIndex);
          _this._setState({
            fields: fields,
            changed: true
          });
        }
      });
    });
    _defineProperty(_this, "_showAddFieldPopup", function () {
      _this.setState({
        showAddFieldPopup: true
      });
    });
    _defineProperty(_this, "_closeAddFieldPopup", function () {
      _this.setState({
        showAddFieldPopup: false
      });
    });
    _defineProperty(_this, "_save", function (e) {
      if (_this._validate()) {
        var _this$props;
        _this._sendAnalytics();
        _this.props.onSave(convertToHSL$2(_this.state), e);
        var hslElementAction = (_this$props = _this.props) !== null && _this$props !== void 0 && (_this$props = _this$props.value) !== null && _this$props !== void 0 && _this$props.isNew ? "Create" : "Edit";
        triggerMixPanelEvent(_this.state.type, hslElementAction);
      }
    });
    /**
     * This method sends 2 analytics events.
     * 1. If custom submit buttons is selected or not.
     * 2. If any 1 field is using icons or not.
     */
    _defineProperty(_this, "_sendAnalytics", function () {
      var submitButtonLabel = _this.state.showCustomSubmitInputs ? "".concat(_this.preSubmitText, "::").concat(_this.postSubmitText) : GA.LABEL.DEFAULT_TEXT;
      sendGoogleAnalyticsEvents({
        eventCategory: GA.CATEGORIES.FORMS,
        eventAction: GA.ACTIONS.FORM_SUBMIT_TEXT,
        eventLabel: submitButtonLabel,
        eventValue: 0
      });
      var hasIcon = _this.state.fields.some(function (field) {
        return field.icon !== undefined;
      });
      sendGoogleAnalyticsEvents({
        eventCategory: GA.CATEGORIES.FORMS,
        eventAction: GA.ACTIONS.FORM_ICON,
        eventLabel: hasIcon ? GA.LABEL.HAVE_ICONS : GA.LABEL.NO_ICONS,
        eventValue: 0
      });
    });
    _defineProperty(_this, "_copy", function () {
      if (_this._validate()) {
        _this.props.copyToClipboard(convertToHSL$2(_this.state));
      }
    });
    _defineProperty(_this, "_setState", function (state) {
      _this.setState(state, _this.props.onStateChange);
    });
    _defineProperty(_this, "_showConfirmationDialog", function () {
      if (!_this.state.changed) {
        _this.props.deactivateDrawer();
      } else {
        _this.props.activateConfirmationDialog({
          themed: true
        }, function (isConfirmed) {
          if (isConfirmed) {
            _this.props.deactivateDrawer();
            _this.setState({
              changed: false
            });
          }
        });
      }
    });
    _this._addFieldfRef = /*#__PURE__*/React.createRef();
    _this.state = _objectSpread2(_objectSpread2({}, _this.initialState), {}, {
      showAddFieldPopup: false,
      deleteFieldIndex: undefined,
      showCustomSubmitInputs: false
    });
    if (_props.state) _this.state = _props.state;else _this.reset(_props, true);
    return _this;
  }
  _inherits(HSLForms, _React$Component);
  return _createClass(HSLForms, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.state) this.setState(nextProps.state);
      if (this.props.value !== nextProps.value) this.reset(nextProps);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        onClick: this._openDrawer
      }, this._renderForm()), this._renderDrawer());
    }
  }]);
}(React.Component)) || _class) || _class) || _class);
HSLForms.propTypes = {
  activateConfirmationDialog: PropTypes.func,
  activateDrawer: PropTypes.func,
  copyToClipboard: PropTypes.func,
  deactivateDrawer: PropTypes.func,
  drawerActive: PropTypes.bool,
  entities: PropTypes.array,
  onSave: PropTypes.func,
  onStateChange: PropTypes.func,
  readOnly: PropTypes.bool,
  state: PropTypes.object,
  value: PropTypes.object,
  entitySearchURL: PropTypes.shape({
    map: PropTypes.string,
    search: PropTypes.string
  }),
  jsonPickerButton: PropTypes.element
};
HSLForms.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "reset",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "nextProps",
      "type": null
    }, {
      "name": "shouldAssignStateDirectly",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_renderDrawer",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_openDrawer",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_renderForm",
    "docblock": "This methods renders the live preview of form HSL.",
    "modifiers": [],
    "params": [],
    "returns": null,
    "description": "This methods renders the live preview of form HSL."
  }, {
    "name": "_renderFormHeader",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_renderCustomSubmitButtonView",
    "docblock": "This method renders the custom submit button inputs if the user has opted for it.",
    "modifiers": [],
    "params": [],
    "returns": null,
    "description": "This method renders the custom submit button inputs if the user has opted for it."
  }, {
    "name": "_renderFormBody",
    "docblock": "This method renders sortable form fields, add field button and custom submit button view.",
    "modifiers": [],
    "params": [],
    "returns": null,
    "description": "This method renders sortable form fields, add field button and custom submit button view."
  }, {
    "name": "_validate",
    "docblock": "This methods first validate the form data and then form fields data\nand then put these errors in respective error arrays.",
    "modifiers": [],
    "params": [],
    "returns": null,
    "description": "This methods first validate the form data and then form fields data\nand then put these errors in respective error arrays."
  }, {
    "name": "_onSortEnd",
    "docblock": "This method sorts the field list after Drag N Drop gesture.",
    "modifiers": [],
    "params": [{
      "name": "{ oldIndex, newIndex }"
    }],
    "returns": null,
    "description": "This method sorts the field list after Drag N Drop gesture."
  }, {
    "name": "_handleFieldChange",
    "docblock": "This method updates the state whenever somthing is changed in form's field.\n@param {number} index index of form field changed\n@param {*} key key that is changed in field\n@param {*} value nre value for the key",
    "modifiers": [],
    "params": [{
      "name": "index",
      "description": "index of form field changed",
      "type": {
        "name": "number"
      },
      "optional": false
    }, {
      "name": "key",
      "description": "key that is changed in field",
      "type": {
        "name": "mixed"
      },
      "optional": false
    }, {
      "name": "value",
      "description": "nre value for the key",
      "type": {
        "name": "mixed"
      },
      "optional": false
    }],
    "returns": null,
    "description": "This method updates the state whenever somthing is changed in form's field."
  }, {
    "name": "_renderNoFieldView",
    "docblock": "This method renders no field added view.",
    "modifiers": [],
    "params": [],
    "returns": null,
    "description": "This method renders no field added view."
  }, {
    "name": "_renderAddFieldButton",
    "docblock": "This method renders add field button. This method will open PopupList,\nfrom which user can select desired field type.",
    "modifiers": [],
    "params": [],
    "returns": null,
    "description": "This method renders add field button. This method will open PopupList,\nfrom which user can select desired field type."
  }, {
    "name": "_handleAddField",
    "docblock": "This method will add a new field in the form HSL.\n@param {object} item selected field type.",
    "modifiers": [],
    "params": [{
      "name": "item",
      "description": "selected field type.",
      "type": {
        "name": "object"
      },
      "optional": false
    }],
    "returns": null,
    "description": "This method will add a new field in the form HSL."
  }, {
    "name": "_handleDeleteField",
    "docblock": "This method deletes a field from the form HSL. It'll\nshow a confirmation popup and will delete field once\nuser accepts the confirmation.\n@param {number} fieldIndex index of field that needs to be deleted",
    "modifiers": [],
    "params": [{
      "name": "fieldIndex",
      "description": "index of field that needs to be deleted",
      "type": {
        "name": "number"
      },
      "optional": false
    }],
    "returns": null,
    "description": "This method deletes a field from the form HSL. It'll\nshow a confirmation popup and will delete field once\nuser accepts the confirmation."
  }, {
    "name": "_showAddFieldPopup",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_closeAddFieldPopup",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_save",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "e",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_sendAnalytics",
    "docblock": "This method sends 2 analytics events.\n1. If custom submit buttons is selected or not.\n2. If any 1 field is using icons or not.",
    "modifiers": [],
    "params": [],
    "returns": null,
    "description": "This method sends 2 analytics events.\n1. If custom submit buttons is selected or not.\n2. If any 1 field is using icons or not."
  }, {
    "name": "_copy",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_setState",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "state",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_showConfirmationDialog",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "HSLForms",
  "props": {
    "activateConfirmationDialog": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "activateDrawer": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "copyToClipboard": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "deactivateDrawer": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "drawerActive": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "entities": {
      "type": {
        "name": "array"
      },
      "required": false,
      "description": ""
    },
    "onSave": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onStateChange": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "readOnly": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "state": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    },
    "value": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    },
    "entitySearchURL": {
      "type": {
        "name": "shape",
        "value": {
          "map": {
            "name": "string",
            "required": false
          },
          "search": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": false,
      "description": ""
    },
    "jsonPickerButton": {
      "type": {
        "name": "element"
      },
      "required": false,
      "description": ""
    }
  }
};

function _extends$7() { _extends$7 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }
var InfoIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$7({
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M7.2 4h1.6v1.6H7.2V4zm0 3.2h1.6V12H7.2V7.2zM8 0C3.584 0 0 3.584 0 8s3.584 8 8 8 8-3.584 8-8-3.584-8-8-8zm0 14.4A6.408 6.408 0 011.6 8c0-3.528 2.872-6.4 6.4-6.4 3.528 0 6.4 2.872 6.4 6.4 0 3.528-2.872 6.4-6.4 6.4z",
  fill: "#858585"
})));

var css_248z$4 = ".WhatsappActionable_header__2kj16 {\n  display: flex;\n  align-items: center;\n  gap: \"12px\"; }\n  .WhatsappActionable_headerTitle__3Nxj8 {\n    font-size: 12px;\n    font-weight: 600;\n    color: #858585;\n    margin-left: 12px; }\n\n.WhatsappActionable_bodyText__1UZS1 {\n  margin: 12px 0;\n  word-break: break-all;\n  font-size: 16px; }\n\n.WhatsappActionable_badge__hCsdB {\n  background-color: #EFEFEF;\n  padding: 6px 8px;\n  border-radius: 20px;\n  margin-right: 8px;\n  font-size: 14px; }\n";
var styles$4 = {"header":"WhatsappActionable_header__2kj16","headerTitle":"WhatsappActionable_headerTitle__3Nxj8","bodyText":"WhatsappActionable_bodyText__1UZS1","badge":"WhatsappActionable_badge__hCsdB"};
styleInject(css_248z$4);

var WhatsappActionable = function WhatsappActionable(_ref) {
  var icon = _ref.icon,
    title = _ref.title,
    text = _ref.text,
    data = _ref.data;
  var renderHeader = function renderHeader() {
    return /*#__PURE__*/React.createElement("div", {
      className: styles$4.header
    }, icon, /*#__PURE__*/React.createElement("div", {
      className: styles$4.headerTitle
    }, title.toUpperCase()));
  };
  var renderBody = function renderBody() {
    return text ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: styles$4.bodyText
    }, text), /*#__PURE__*/React.createElement("div", null, data.map(function (item) {
      return /*#__PURE__*/React.createElement("span", {
        className: styles$4.badge
      }, item);
    }))) : null;
  };
  return /*#__PURE__*/React.createElement("div", null, renderHeader(), renderBody());
};
WhatsappActionable.propTypes = {
  icon: PropTypes.func,
  title: PropTypes.string,
  text: PropTypes.string,
  data: PropTypes.array
};
WhatsappActionable.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "WhatsappActionable",
  "props": {
    "icon": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "title": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "text": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "data": {
      "type": {
        "name": "array"
      },
      "required": false,
      "description": ""
    }
  }
};

function _extends$8() { _extends$8 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }
var ReplyButtonIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$8({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("rect", {
  x: "1.5",
  y: "1.5",
  width: "21",
  height: "21",
  rx: "1.5",
  stroke: "#BFEFD3",
  strokeWidth: "3"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6ECD95",
  d: "M4.5 4.5h3v3h-3zM4.5 10.5h3v3h-3zM4.5 16.5h3v3h-3zM9.5 4.5h10v3h-10zM9.5 10.5h10v3h-10zM9.5 16.5h10v3h-10z"
})));

var css_248z$5 = ".DrawerHeader_drawerHeader__2V0ED {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px;\n  border-bottom: 1px solid #eee; }\n\n.DrawerHeader_leftColumn__3gWLP,\n.DrawerHeader_rightColumn__3cYvM {\n  display: flex;\n  align-items: center; }\n\n.DrawerHeader_icon__kptyn {\n  margin-right: 8px;\n  margin-left: 14px;\n  cursor: pointer;\n  opacity: 0.7; }\n  .DrawerHeader_icon__kptyn:hover {\n    opacity: 1; }\n\n.DrawerHeader_doneButton__vVL0b {\n  margin-right: 12px; }\n\n.DrawerHeader_copyButton__3xDGO {\n  width: auto;\n  color: #000;\n  font-size: 14px;\n  border-radius: 5px;\n  transition: 0.2s ease-out;\n  padding: 4px; }\n  .DrawerHeader_copyButton__3xDGO:before {\n    content: 'COPY JSON';\n    font-size: 12px;\n    white-space: nowrap;\n    position: relative;\n    width: 1px;\n    visibility: hidden; }\n  .DrawerHeader_copyButton__3xDGO:hover {\n    background-color: #eee; }\n    .DrawerHeader_copyButton__3xDGO:hover:before {\n      visibility: visible;\n      padding: 0 6px;\n      width: 64px; }\n";
var styles$5 = {"drawerHeader":"DrawerHeader_drawerHeader__2V0ED","leftColumn":"DrawerHeader_leftColumn__3gWLP","rightColumn":"DrawerHeader_rightColumn__3cYvM","icon":"DrawerHeader_icon__kptyn","doneButton":"DrawerHeader_doneButton__vVL0b","copyButton":"DrawerHeader_copyButton__3xDGO"};
styleInject(css_248z$5);

var DrawerHeader$1 = function DrawerHeader(_ref) {
  var onClose = _ref.onClose,
    onCopy = _ref.onCopy,
    onDone = _ref.onDone,
    label = _ref.label;
  return /*#__PURE__*/React.createElement("div", {
    className: styles$5.drawerHeader
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$5.leftColumn
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onDone,
    className: styles$5.doneButton
  }, "Done"), label), /*#__PURE__*/React.createElement("div", {
    className: styles$5.rightColumn
  }, /*#__PURE__*/React.createElement(Icon, {
    onClick: onCopy,
    className: styles$5.copyButton,
    src: "synonym_duplicate"
  }), /*#__PURE__*/React.createElement(Icon, {
    onClick: onClose,
    className: styles$5.icon,
    src: "close"
  })));
};
DrawerHeader$1.propTypes = {
  onClose: PropTypes.func,
  onCopy: PropTypes.func,
  onDone: PropTypes.func
};
DrawerHeader$1.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "DrawerHeader",
  "props": {
    "onClose": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onCopy": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onDone": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    }
  }
};

var HEADER_TYPES = {
  none: "None",
  text: "Text",
  document: "Document",
  image: "Image",
  video: "Video"
};
var LIMITS = {
  MAX_REPLY_BUTTONS: 3,
  MAX_LIST_ITEMS: 10,
  MAX_SECTION_ITEMS: 30,
  BUTTON_TITLE_TEXT: 20,
  HEADER_TEXT: 60,
  FILE_SIZE: 10,
  BODY_TEXT: 1024,
  LIST_SECTION_TITLE: 24,
  LIST_ITEM_DESCRIPTION: 72,
  PAYLOAD: 256,
  CATALOG_ID: 500,
  ITEM_ID: 500
};
var WHATSAPP_PREVIEWS = {
  list: "https://toolassets.haptikapi.com/mogambo/images/whatsapp_list.png",
  text_no_header: "https://toolassets.haptikapi.com/mogambo/images/whatsapp_text_preview_no_header.png",
  text: "https://toolassets.haptikapi.com/mogambo/images/whatsapp_text_preview.png",
  media: "https://toolassets.haptikapi.com/mogambo/images/whatsapp_media_preview.png",
  single_plm: "https://toolassets.haptikapi.com/mogambo/images/whatsapp_single_plm.png",
  multi_plm: "https://toolassets.haptikapi.com/mogambo/images/whatsapp_multi_plm.png"
};

function capitalizeFirstLetter(string) {
  return string ? string.charAt(0).toUpperCase() + string.slice(1) : "";
}
var convertFromHSL$3 = function convertFromHSL(HSL) {
  var header_type = capitalizeFirstLetter(HSL.header_type);
  var component = {
    headerType: {
      text: header_type
    },
    headerTypeValue: header_type,
    headerText: HSL.header,
    file: HSL.header,
    bodyText: HSL.text,
    footerText: HSL.footer,
    _originalHSL: HSL,
    buttons: HSL.buttons_with_id || []
  };
  return component;
};
var convertToHSL$3 = function convertToHSL(component) {
  var _component$headerType;
  var header = ["Document", "Image"].includes(component.headerTypeValue) ? component.file : component.headerText;
  var HSL = {
    type: "WHATSAPP_INTERACTIVE_BUTTON",
    text: component.bodyText,
    header: header,
    header_type: (_component$headerType = component.headerTypeValue) === null || _component$headerType === void 0 ? void 0 : _component$headerType.toLowerCase(),
    footer: component.footerText,
    buttons_with_id: component.buttons
  };
  return HSL;
};

var Container = styled.div({
  paddingTop: 16,
  paddingBottom: 16,
  overflowY: "auto"
});
var ButtonContainer = styled.div({});
var DragButton = styled.div({
  position: "absolute",
  right: "28px",
  top: "0px",
  cursor: "pointer"
});
var ProductList = styled.div({
  border: function border(props) {
    return "1px solid ".concat(props.theme.colors.grey.haptik);
  },
  borderRadius: function borderRadius(props) {
    return "".concat(props.theme.radii.sm, "px");
  },
  padding: "16px",
  background: "#fafafa",
  marginTop: "8px"
});
var Label = styled.div({
  background: "#FFF0D3",
  border: "1px solid #FFD37B",
  boxSizing: "border-box",
  borderRadius: "2px",
  padding: "12px",
  fontFamily: "Noto Sans",
  fontSize: "14px",
  color: "#F6A400"
});
var ItemLabel = styled.div({
  background: "#FFF0D3",
  border: "1px solid #FFD37B",
  boxSizing: "border-box",
  borderRadius: "2px",
  padding: "12px",
  fontFamily: "Noto Sans",
  fontSize: "14px",
  color: "#F6A400"
});
var ButtonWrapper = styled.section({
  width: 300,
  border: "1px solid #EEEEEE",
  borderRadius: 4,
  backgroundColor: "#FEFEFE",
  padding: "16px 12px",
  cursor: "pointer"
});
var FormContainer = styled.div({
  padding: "0 16px"
});
var DeleteBtn = styled.a({
  position: "absolute",
  right: function right(props) {
    return "".concat(props.right || 5, "px");
  },
  top: function top(props) {
    return "".concat(props.top || 0, "px");
  }
});
var FormDropdown = styled(Dropdown)({
  color: "#000",
  span: {
    color: "#000"
  }
});
var FormTextInput = styled(Text)({
  span: {
    fontFamily: '"Proxima Nova",sans-serif'
  },
  marginTop: 16
});
var FormTextArea = styled(Text)({
  marginTop: 16,
  textArea: {
    minHeight: 110
  },
  span: {
    fontFamily: '"Proxima Nova",sans-serif'
  }
});
var IconWrapper = styled.div({
  textAlign: "center"
});
var ReplyIcon = styled.svg({
  width: 46,
  height: 48,
  marginBottom: 22
});
var ReplyText = styled(Text$1)({
  display: "block"
});
var ActionableWrapper = styled.div({
  position: "relative"
});
var FileInput = styled(File)({
  marginTop: 16,
  marginBottom: 0
});
var InfoIconWrapper = styled(Icon)({
  marginLeft: 8
});
var StyledAccordionItem = styled(Accordion.Item)({
  backgroundColor: "#FAFAFA",
  border: function border(props) {
    return "1px solid ".concat(props.theme.colors.grey.haptik);
  },
  marginTop: function marginTop(props) {
    return "".concat(props.theme.space.md, "px");
  },
  borderRadius: function borderRadius(props) {
    return "".concat(props.theme.radii.sm, "px");
  },
  paddingBottom: function paddingBottom(props) {
    return "".concat(props.theme.space.lg, "px");
  },
  ".accordion-padding-head": {
    padding: function padding(props) {
      return "".concat(props.theme.space.lg, "px");
    }
  },
  ".accordion-padding-body": {
    padding: function padding(props) {
      return "".concat(props.theme.space.lg, "px");
    },
    paddingTop: 0
  }
});
var SectionTitleWrapper = styled.div({
  position: "relative",
  top: function top(props) {
    return "".concat(props.top || 0, "px");
  }
});
var SectionItemsWrapper = styled.div({
  paddingLeft: function paddingLeft(props) {
    return "".concat(props.theme.space.lg, "px");
  }
});
var SectionItemTitleWrapper = styled.div({
  position: "relative",
  marginTop: function marginTop(props) {
    return "".concat(props.theme.space.md, "px");
  },
  marginBottom: "-10px"
});

var _dec$1, _dec2$1, _dec3$1, _dec4, _class$1;
var HEADERTYPES = [{
  text: HEADER_TYPES.none
}, {
  text: HEADER_TYPES.text
}, {
  text: HEADER_TYPES.document
}, {
  text: HEADER_TYPES.image
}, {
  text: HEADER_TYPES.video
}];
var ReplyButton = (_dec$1 = ToastMessage(), _dec2$1 = EmojiPicker(), _dec3$1 = ConfirmationDialog(), _dec4 = HSLWrapper(), _dec$1(_class$1 = _dec2$1(_class$1 = _dec3$1(_class$1 = _dec4(_class$1 = /*#__PURE__*/function (_React$Component) {
  function ReplyButton(_props) {
    var _this;
    _classCallCheck(this, ReplyButton);
    _this = _callSuper(this, ReplyButton, [_props]);
    _defineProperty(_this, "initialState", {
      type: "BUTTON",
      buttons: [{
        title: "",
        id: ""
      }],
      headerType: {
        text: HEADER_TYPES.none
      },
      headerTypeValue: HEADER_TYPES.none,
      headerText: "",
      bodyText: "",
      footerText: "",
      file: ""
    });
    _defineProperty(_this, "_renderBody", function () {
      var buttonsLength = _this.state.buttons && _this.state.buttons.length;
      var data = buttonsLength > 1 ? ["".concat(buttonsLength, " buttons")] : ["".concat(buttonsLength, " button")];
      var renderPreview = function renderPreview(type, style) {
        if (type === "Text") {
          return /*#__PURE__*/React.createElement("img", {
            src: WHATSAPP_PREVIEWS.text,
            style: style
          });
        }
        if (type === "None") {
          return /*#__PURE__*/React.createElement("img", {
            src: WHATSAPP_PREVIEWS.text_no_header,
            style: style
          });
        }
        return /*#__PURE__*/React.createElement("img", {
          src: WHATSAPP_PREVIEWS.media,
          style: style
        });
      };
      return _this.props.isPopupElement ? renderPreview(_this.state.headerTypeValue, {
        width: "100%",
        height: "auto"
      }) : /*#__PURE__*/React.createElement(WhatsappActionable, {
        icon: /*#__PURE__*/React.createElement(ReplyButtonIcon, null),
        title: "Whatsapp Reply Button",
        text: _this.state.bodyText,
        data: buttonsLength ? data : []
      });
    });
    _defineProperty(_this, "_save", function (e) {
      var _this$props;
      var _this$state = _this.state,
        headerType = _this$state.headerType,
        headerTypeValue = _this$state.headerTypeValue,
        headerText = _this$state.headerText,
        bodyText = _this$state.bodyText,
        footerText = _this$state.footerText,
        buttons = _this$state.buttons,
        file = _this$state.file;
      var errors = {};
      if (!headerType || !headerTypeValue) {
        errors.headerType = "Please select header type";
      }
      if (headerTypeValue === "Text" || headerTypeValue === "Video") {
        if (!headerText) {
          errors.headerText = headerTypeValue === "Video" ? "Please enter video url" : "Please enter header text";
        } else if (headerTypeValue === "Text" && headerText.length > LIMITS.HEADER_TEXT) {
          errors.headerText = "Exceeding character limit. Max limit is ".concat(LIMITS.HEADER_TEXT);
        }
      } else if (headerTypeValue === "Image" || headerTypeValue === "Document") {
        if (!file) {
          errors.file = "Please upload a file";
        }
      }
      if (!bodyText) {
        errors.bodyText = "Please enter body text";
      } else if (bodyText.length > LIMITS.BODY_TEXT) {
        errors.bodyText = "Exceeding character limit. Max limit is ".concat(LIMITS.BODY_TEXT);
      }
      if (footerText && footerText.length > LIMITS.HEADER_TEXT) {
        errors.footerText = "Exceeding character limit. Max limit is ".concat(LIMITS.HEADER_TEXT);
      }
      var buttonErrors = {};
      buttons.forEach(function (button, i) {
        var _buttonErrors$i;
        if (!button.title) {
          buttonErrors[i] = _objectSpread2(_objectSpread2({}, buttonErrors[i]), {}, {
            title: "Please enter button text"
          });
        } else if (button.title && button.title.length > LIMITS.BUTTON_TITLE_TEXT) {
          buttonErrors[i] = _objectSpread2(_objectSpread2({}, buttonErrors[i]), {}, {
            title: "Exceeding character limit. Max limit is ".concat(LIMITS.BUTTON_TITLE_TEXT)
          });
        }
        if (button.id && button.id.length > LIMITS.PAYLOAD) {
          buttonErrors[i] = _objectSpread2(_objectSpread2({}, buttonErrors[i]), {}, {
            id: "Exceeding character limit. Max limit is ".concat(LIMITS.PAYLOAD)
          });
        }
        if (button.id && !((_buttonErrors$i = buttonErrors[i]) !== null && _buttonErrors$i !== void 0 && _buttonErrors$i.id) && button.id.indexOf("haptik_") === 0) {
          buttonErrors[i] = _objectSpread2(_objectSpread2({}, buttonErrors[i]), {}, {
            id: "Cannot start with haptik_"
          });
        }
      });
      var buttonIdArr = buttons.map(function (item) {
        return item.id;
      });
      var buttonIdErrIndex = "";
      var isDuplicateButtonId = buttonIdArr.some(function (item, idx) {
        if (buttonIdArr.indexOf(item) !== idx && item) {
          buttonIdErrIndex = idx;
          return true;
        }
      });
      var buttonErrorsVals = Object.values(buttonErrors);
      var buttonIdErrorExists = buttonErrorsVals.some(function (item, idx) {
        if (item.id) {
          return true;
        }
      });
      if (isDuplicateButtonId && !buttonIdErrorExists) {
        buttonErrors[buttonIdErrIndex] = _objectSpread2(_objectSpread2({}, buttonErrors[buttonIdErrIndex]), {}, {
          id: "Cannot have duplicate values"
        });
      }
      if (Object.values(buttonErrors).length) {
        errors.buttons = buttonErrors;
      }
      _this.setState({
        errors: errors
      });
      if (Object.values(errors).length === 0) {
        _this.props.onSave(convertToHSL$3(_this.state), e);
      }
      var hslElementAction = (_this$props = _this.props) !== null && _this$props !== void 0 && _this$props.isNew ? "Create" : "Edit";
      triggerMixPanelEvent("Whatsapp Reply Button", hslElementAction);
    });
    _defineProperty(_this, "_copy", function () {
      _this.props.copyToClipboard(convertToHSL$3(_this.state));
    });
    _defineProperty(_this, "_onHeaderTypeChange", function (val) {
      _this._setState({
        headerType: val,
        headerTypeValue: val.text,
        headerText: "",
        file: ""
      });
    });
    _defineProperty(_this, "_onFileInputChange", function (val) {
      _this._setState({
        file: val,
        errors: _objectSpread2(_objectSpread2({}, _this.state.errors), {}, {
          file: null
        })
      });
    });
    _defineProperty(_this, "_setState", function (state) {
      _this.setState(state, _this.props.onStateChange);
    });
    _defineProperty(_this, "_deleteButton", function (index, e) {
      if (e) e.stopPropagation();
      if (_this.state.buttons.length - 1 < 1) {
        _this.props.activateToastMessage("You need to have at least 1 button");
      } else {
        var buttons = _this.state.buttons;
        buttons = buttons.filter(function (_, i) {
          return i !== index;
        });
        _this._setState({
          buttons: buttons,
          changed: true
        });
      }
    });
    _defineProperty(_this, "_editButtonText", function (index, value, key) {
      var buttons = _this.state.buttons;
      var editedButton = _objectSpread2({}, buttons[index]);
      editedButton[key] = value;
      buttons[index] = editedButton;
      _this._setState({
        buttons: buttons,
        changed: true
      });
    });
    _defineProperty(_this, "_blurButtonText", function (index, e, key) {
      var value = e.target.value;
      var buttons = _this.state.buttons;
      var editedButton = _objectSpread2({}, buttons[index]);
      editedButton[key] = value.trim();
      buttons[index] = editedButton;
      _this._setState({
        buttons: buttons,
        changed: true
      });
    });
    _defineProperty(_this, "_addButton", function (e) {
      if (e) e.stopPropagation();
      if (_this.state.buttons.length + 1 > LIMITS.MAX_REPLY_BUTTONS) {
        _this.props.activateToastMessage("You can't have more than ".concat(LIMITS.MAX_REPLY_BUTTONS, " buttons"));
      } else {
        var newItem = {
          title: "",
          id: ""
        };
        var buttons = _this.state.buttons;
        buttons.push(newItem);
        _this._setState({
          buttons: buttons,
          changed: true
        });
      }
    });
    _defineProperty(_this, "_renderButtons", function () {
      var _this$state2;
      if ((_this$state2 = _this.state) !== null && _this$state2 !== void 0 && _this$state2.buttons) {
        return _this.state.buttons.map(function (button, i) {
          var _this$state$errors, _this$state$errors2, _this$state$errors3, _this$state$errors4;
          return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ActionableWrapper, null, /*#__PURE__*/React.createElement(FormTextInput, {
            themed: true,
            value: button.title,
            placeholder: "Enter button text",
            onChange: function onChange(value) {
              return _this._editButtonText(i, value, "title");
            },
            onBlur: function onBlur(e) {
              return _this._blurButtonText(i, e, "title");
            },
            label: "Button ".concat(i + 1),
            error: ((_this$state$errors = _this.state.errors) === null || _this$state$errors === void 0 ? void 0 : _this$state$errors.buttons) && ((_this$state$errors2 = _this.state.errors) === null || _this$state$errors2 === void 0 || (_this$state$errors2 = _this$state$errors2.buttons[i]) === null || _this$state$errors2 === void 0 ? void 0 : _this$state$errors2.title) || null
          }), i > 0 && /*#__PURE__*/React.createElement(DeleteBtn, {
            onClick: function onClick(e) {
              return _this._deleteButton(i, e);
            },
            href: "javascript:void(0)"
          }, /*#__PURE__*/React.createElement("svg", {
            width: "18",
            height: "18",
            viewBox: "0 0 18 18",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, /*#__PURE__*/React.createElement("path", {
            d: "M4.83329 8.1665V9.83317H13.1666V8.1665H4.83329ZM8.99996 0.666504C4.39996 0.666504 0.666626 4.39984 0.666626 8.99984C0.666626 13.5998 4.39996 17.3332 8.99996 17.3332C13.6 17.3332 17.3333 13.5998 17.3333 8.99984C17.3333 4.39984 13.6 0.666504 8.99996 0.666504ZM8.99996 15.6665C5.32496 15.6665 2.33329 12.6748 2.33329 8.99984C2.33329 5.32484 5.32496 2.33317 8.99996 2.33317C12.675 2.33317 15.6666 5.32484 15.6666 8.99984C15.6666 12.6748 12.675 15.6665 8.99996 15.6665Z",
            fill: "#858585"
          })))), /*#__PURE__*/React.createElement(FormTextInput, {
            themed: true,
            value: button.id,
            placeholder: "Enter button payload (optional)",
            onChange: function onChange(val) {
              return _this._editButtonText(i, val, "id");
            },
            onBlur: function onBlur(e) {
              return _this._blurButtonText(i, e, "id");
            },
            error: ((_this$state$errors3 = _this.state.errors) === null || _this$state$errors3 === void 0 ? void 0 : _this$state$errors3.buttons) && ((_this$state$errors4 = _this.state.errors) === null || _this$state$errors4 === void 0 || (_this$state$errors4 = _this$state$errors4.buttons[i]) === null || _this$state$errors4 === void 0 ? void 0 : _this$state$errors4.id) || null
          }));
        });
      }
    });
    _defineProperty(_this, "_handleTextChange", function (id, value) {
      _this._setState(_defineProperty({}, id, value));
    });
    _defineProperty(_this, "_handleTextBlur", function (e, key) {
      var value = e.target.value;
      _this._setState(_defineProperty({}, key, value.trim()));
    });
    _defineProperty(_this, "_renderFileInput", function () {
      var _this$state$errors7;
      var headerTypeValue = _this.state.headerTypeValue;
      var ACCEPT_FILES_MAP = {
        Document: ".pdf",
        Image: ".jpeg, .jpg, .png"
      };
      if (["Document", "Image"].includes(_this.state.headerTypeValue)) {
        var _this$state$errors5, _this$state$errors6;
        var ACCEPT_FILES = ACCEPT_FILES_MAP[_this.state.headerTypeValue];
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FileInput, {
          type: ACCEPT_FILES,
          value: _this.state.file,
          onChange: function onChange(val) {
            _this._onFileInputChange(val);
          },
          source: 0
        }), ((_this$state$errors5 = _this.state.errors) === null || _this$state$errors5 === void 0 ? void 0 : _this$state$errors5.file) && /*#__PURE__*/React.createElement(Text$1, {
          variant: "h4.semi-bold",
          color: "red.haptik"
        }, (_this$state$errors6 = _this.state.errors) === null || _this$state$errors6 === void 0 ? void 0 : _this$state$errors6.file));
      }
      return /*#__PURE__*/React.createElement(FormTextInput, {
        themed: true,
        label: headerTypeValue === "Video" ? "Video URL" : "Header text",
        placeholder: headerTypeValue === "Video" ? "Enter Video URL" : "Enter header text",
        onBlur: function onBlur(e) {
          return _this._handleTextBlur(e, "headerText");
        },
        error: ((_this$state$errors7 = _this.state.errors) === null || _this$state$errors7 === void 0 ? void 0 : _this$state$errors7.headerText) || null,
        value: _this.state.headerText,
        onChange: function onChange(val) {
          return _this._handleTextChange("headerText", val);
        }
      });
    });
    _defineProperty(_this, "_openDrawer", function () {
      _this.props.activateDrawer();
    });
    _defineProperty(_this, "_closeDrawer", function () {
      _this.setState({
        errors: {}
      }, function () {
        _this.props.deactivateDrawer();
      });
    });
    _defineProperty(_this, "reset", function (nextProps, shouldAssignStateDirectly) {
      var props = nextProps || _this.props || {};
      var value = props.value && !props.value.isNew ? convertFromHSL$3(props.value) : _objectSpread2({}, _this.initialState);
      if (shouldAssignStateDirectly) {
        _this.state = value;
        _this.props.onStateChange();
      } else {
        _this._setState(value);
      }
    });
    _defineProperty(_this, "_renderDrawer", function () {
      var _this$state$errors8, _this$state$errors9, _this$state$errors10;
      if (_this.props.state) return null;
      var placeholderText = "Enter body text";
      return /*#__PURE__*/React.createElement(Drawer, {
        themed: true,
        zIndex: 10001,
        placement: "RIGHT",
        active: _this.props.drawerActive,
        onClose: _this._save,
        width: 400
      }, /*#__PURE__*/React.createElement(DrawerHeader$1, {
        onCopy: _this._copy,
        label: "Whatsapp Reply Button",
        onDone: _this._save,
        onClose: _this._closeDrawer
      }), /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(FormContainer, null, /*#__PURE__*/React.createElement(FormDropdown, {
        themed: true,
        label: "Header type",
        placeholder: "Select Header Type",
        value: _this.state.headerType,
        error: ((_this$state$errors8 = _this.state.errors) === null || _this$state$errors8 === void 0 ? void 0 : _this$state$errors8.headerType) || null,
        options: HEADERTYPES,
        onChange: _this._onHeaderTypeChange
      }), _this._renderFileInput(), /*#__PURE__*/React.createElement(FormTextArea, {
        themed: true,
        label: "Body Text",
        placeholder: placeholderText,
        error: ((_this$state$errors9 = _this.state.errors) === null || _this$state$errors9 === void 0 ? void 0 : _this$state$errors9.bodyText) || null,
        value: _this.state.bodyText,
        onChange: function onChange(val) {
          return _this._handleTextChange("bodyText", val);
        },
        onBlur: function onBlur(e) {
          return _this._handleTextBlur(e, "bodyText");
        },
        multiline: true
      }), _this.props.isRephraseEnabled && /*#__PURE__*/React.createElement(RephraseBotResponses, {
        baseUrl: _this.props.baseUrl,
        botResponse: _this.state.bodyText,
        onChange: function onChange(val) {
          return _this._handleTextChange("bodyText", val);
        },
        isSeparate: true
      }), /*#__PURE__*/React.createElement(FormTextInput, {
        themed: true,
        value: _this.state.footerText,
        onChange: function onChange(val) {
          return _this._handleTextChange("footerText", val);
        },
        onBlur: function onBlur(e) {
          return _this._handleTextBlur(e, "footerText");
        },
        placeholder: "Enter footer text (optional)",
        error: ((_this$state$errors10 = _this.state.errors) === null || _this$state$errors10 === void 0 ? void 0 : _this$state$errors10.footerText) || null,
        label: "Footer text"
      }), _this._renderButtons()), /*#__PURE__*/React.createElement(AddButton, {
        isV2: true,
        onClick: _this._addButton
      }, /*#__PURE__*/React.createElement(Box, {
        padding: "0",
        backgroundColor: "none",
        alignItems: "center"
      }, /*#__PURE__*/React.createElement(Text$1, {
        color: "blue.haptik",
        variant: "h3.semi-bold"
      }, "Add Button"), /*#__PURE__*/React.createElement(Tooltip, {
        themed: true,
        tooltip: "You can add maximum up to ".concat(LIMITS.MAX_REPLY_BUTTONS, " buttons"),
        position: "TOP",
        size: "large"
      }, /*#__PURE__*/React.createElement(InfoIconWrapper, {
        size: Icon.SIZES.SMALL,
        src: InfoIcon
      }))))));
    });
    _this.state = _objectSpread2(_objectSpread2({}, _this.initialState), {}, {
      errors: {}
    });
    if (_props.state) _this.state = _props.state;else _this.reset(_props, true);
    return _this;
  }
  _inherits(ReplyButton, _React$Component);
  return _createClass(ReplyButton, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.state) this.setState(nextProps.state);
      if (!this.props.value && nextProps.value) this.reset(nextProps);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ButtonWrapper, null, /*#__PURE__*/React.createElement("div", {
        onClick: this._openDrawer
      }, this._renderBody()), this._renderDrawer()));
    }
  }]);
}(React.Component)) || _class$1) || _class$1) || _class$1) || _class$1);
ReplyButton.propTypes = {
  activateDrawer: PropTypes.func,
  activateToastMessage: PropTypes.func,
  drawerActive: PropTypes.bool,
  onSave: PropTypes.func,
  onStateChange: PropTypes.func,
  state: PropTypes.object,
  value: PropTypes.object,
  isPopupElement: PropTypes.bool,
  isRephraseEnabled: PropTypes.bool,
  baseUrl: PropTypes.string
};
ReplyButton.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "_renderBody",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_save",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "e",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_copy",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_onHeaderTypeChange",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "val",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_onFileInputChange",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "val",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_setState",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "state",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_deleteButton",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "index",
      "type": null
    }, {
      "name": "e",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_editButtonText",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "index",
      "type": null
    }, {
      "name": "value",
      "type": null
    }, {
      "name": "key",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_blurButtonText",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "index",
      "type": null
    }, {
      "name": "e",
      "type": null
    }, {
      "name": "key",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_addButton",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "e",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_renderButtons",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_handleTextChange",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "id",
      "type": null
    }, {
      "name": "value",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_handleTextBlur",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "e",
      "type": null
    }, {
      "name": "key",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_renderFileInput",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_openDrawer",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_closeDrawer",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "reset",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "nextProps",
      "type": null
    }, {
      "name": "shouldAssignStateDirectly",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_renderDrawer",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "ReplyButton",
  "props": {
    "activateDrawer": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "activateToastMessage": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "drawerActive": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "onSave": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onStateChange": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "state": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    },
    "value": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    },
    "isPopupElement": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "isRephraseEnabled": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "baseUrl": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};

function _extends$9() { _extends$9 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }
var ListButtonIcon = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$9({
  width: "22",
  height: "24",
  viewBox: "0 0 22 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.2.016L4.813 0l-.316.01C1.99.165.003 2.19 0 4.67v11.225l.01.308c.163 2.439 2.248 4.369 4.796 4.369h8.97l-1.982 1.838-.116.129a.883.883 0 00.113 1.187c.39.364 1.023.365 1.415.003l4-3.709.116-.128a.883.883 0 00-.114-1.188l-4-3.736-.138-.108a1.057 1.057 0 00-1.276.105l-.116.129a.883.883 0 00.113 1.187l2.589 2.42H4.806l-.278-.013c-1.462-.136-2.606-1.334-2.606-2.793V4.673l.014-.27C2.077 2.98 3.31 1.869 4.809 1.87l12.39.016.276.013c1.461.138 2.603 1.335 2.603 2.793v4.396l.015.168a.955.955 0 00.946.768c.53 0 .961-.42.961-.936V4.693l-.01-.308C21.827 1.948 19.746.02 17.2.016z",
  fill: "#BFEFD3"
}), /*#__PURE__*/React.createElement("rect", {
  x: "4.594",
  y: "5.5",
  width: "13.271",
  height: "2",
  rx: "1",
  fill: "#6ECD95"
}), /*#__PURE__*/React.createElement("rect", {
  x: "4.594",
  y: "9",
  width: "13.271",
  height: "2",
  rx: "1",
  fill: "#6ECD95"
})));

var convertFromHSL$4 = function convertFromHSL(HSL) {
  var activeSections = {};
  var itemCount = 0;
  HSL.sections.forEach(function (_, i) {
    var _$buttons;
    activeSections[i] = i === 0 ? true : false;
    itemCount += (_ === null || _ === void 0 || (_$buttons = _.buttons) === null || _$buttons === void 0 ? void 0 : _$buttons.length) || 0;
  });
  var component = {
    type: "WHATSAPP_INTERACTIVE_LIST",
    text: HSL.text,
    header: HSL.header,
    footer: HSL.footer,
    button_text: HSL.button_text,
    sections: HSL.sections,
    activeSections: activeSections,
    itemCount: itemCount,
    errors: {},
    accordionActive: true,
    _originalHSL: HSL
  };
  return component;
};
var convertToHSL$4 = function convertToHSL(component) {
  var HSL = {
    type: "WHATSAPP_INTERACTIVE_LIST",
    text: component.text,
    header: component.header,
    footer: component.footer,
    button_text: component.button_text,
    sections: component.sections
  };
  return HSL;
};

var _dec$2, _dec2$2, _dec3$2, _dec4$1, _class$2;
var buttonObj = {
  title: "",
  description: "",
  id: ""
};
var sectionObj = {
  title: "",
  buttons: [buttonObj]
};
var List = (_dec$2 = ToastMessage(), _dec2$2 = EmojiPicker(), _dec3$2 = ConfirmationDialog(), _dec4$1 = HSLWrapper(), _dec$2(_class$2 = _dec2$2(_class$2 = _dec3$2(_class$2 = _dec4$1(_class$2 = /*#__PURE__*/function (_React$Component) {
  function List(_props) {
    var _this;
    _classCallCheck(this, List);
    _this = _callSuper(this, List, [_props]);
    _defineProperty(_this, "initialState", {
      type: "WHATSAPP_INTERACTIVE_LIST",
      text: "",
      header: "",
      footer: "",
      button_text: "",
      sections: [sectionObj],
      activeSections: {
        0: true
      },
      itemCount: 1,
      errors: {},
      accordionActive: true
    });
    _defineProperty(_this, "reset", function (nextProps, shouldAssignStateDirectly) {
      var props = nextProps || _this.props || {};
      var value = props.value && !props.value.isNew ? convertFromHSL$4(props.value) : _objectSpread2({}, _this.initialState);
      if (shouldAssignStateDirectly) {
        _this.state = value;
        _this.props.onStateChange();
      } else {
        _this._setState(value);
      }
    });
    _defineProperty(_this, "_setState", function (state) {
      _this.setState(state, _this.props.onStateChange);
    });
    _defineProperty(_this, "_save", function (e) {
      var _this$props;
      var _this$state = _this.state,
        header = _this$state.header,
        text = _this$state.text,
        button_text = _this$state.button_text,
        footer = _this$state.footer,
        sections = _this$state.sections;
      var errors = {};
      if (header && header.length > LIMITS.HEADER_TEXT) {
        errors.header = "Exceeding character limit. Max limit is ".concat(LIMITS.HEADER_TEXT);
      }
      if (!text) {
        errors.text = "Please enter body text";
      } else if (text.length > LIMITS.BODY_TEXT) {
        errors.text = "Exceeding character limit. Max limit is ".concat(LIMITS.BODY_TEXT);
      }
      if (button_text && button_text.length > LIMITS.BUTTON_TITLE_TEXT) {
        errors.button_text = "Exceeding character limit. Max limit is ".concat(LIMITS.BUTTON_TITLE_TEXT);
      }
      if (footer && footer.length > LIMITS.HEADER_TEXT) {
        errors.footer = "Exceeding character limit. Max limit is ".concat(LIMITS.HEADER_TEXT);
      }
      var sectionErrors = {};
      sections.forEach(function (section, i) {
        var sectionItemErrors = {};
        if (section.title.length > LIMITS.LIST_SECTION_TITLE) {
          sectionErrors[i] = {
            title: "Exceeding character limit. Max limit is ".concat(LIMITS.LIST_SECTION_TITLE)
          };
        }
        if (section !== null && section !== void 0 && section.buttons) section.buttons.forEach(function (button, j) {
          if (!button.title) {
            sectionItemErrors[j] = {
              title: "Please enter item title"
            };
          } else if (button.title.length > LIMITS.LIST_SECTION_TITLE) {
            sectionItemErrors[j] = {
              title: "Exceeding character limit. Max limit is ".concat(LIMITS.LIST_SECTION_TITLE)
            };
          }
          if (button.description && button.description.length > LIMITS.LIST_ITEM_DESCRIPTION) {
            sectionItemErrors[j] = _objectSpread2(_objectSpread2({}, sectionItemErrors[j]), {}, {
              description: "Exceeding character limit. Max limit is ".concat(LIMITS.LIST_ITEM_DESCRIPTION)
            });
          }
          if (button.id && button.id.length > LIMITS.PAYLOAD) {
            sectionItemErrors[j] = _objectSpread2(_objectSpread2({}, sectionItemErrors[j]), {}, {
              id: "Exceeding character limit. Max limit is ".concat(LIMITS.PAYLOAD)
            });
          }
        });
        var buttonsIdArr = section.buttons.map(function (item) {
          return item.id.replace(/\s+$/, "");
        });
        var buttonIdErrIndex = "";
        var isDuplicateButtonId = buttonsIdArr.some(function (item, idx) {
          if (buttonsIdArr.indexOf(item) !== idx && item) {
            buttonIdErrIndex = idx;
            return true;
          }
        });
        var buttonErrorsVals = Object.values(sectionItemErrors);
        var buttonIdErrorExists = buttonErrorsVals.some(function (item, idx) {
          if (item.id) {
            return true;
          }
        });
        if (isDuplicateButtonId && !buttonIdErrorExists) {
          sectionItemErrors[buttonIdErrIndex] = _objectSpread2(_objectSpread2({}, sectionItemErrors[buttonIdErrIndex]), {}, {
            id: "Cannot have duplicate values"
          });
        }
        if (Object.values(sectionItemErrors).length) {
          sectionErrors[i] = _objectSpread2(_objectSpread2({}, sectionErrors[i]), {}, {
            buttons: sectionItemErrors
          });
        }
      });
      if (Object.values(sectionErrors).length) {
        errors.sections = sectionErrors;
      }
      _this.setState({
        errors: errors
      });
      if (Object.values(errors).length === 0) {
        _this.props.onSave(convertToHSL$4(_this.state), e);
      }
      var hslElementAction = (_this$props = _this.props) !== null && _this$props !== void 0 && _this$props.isNew ? "Create" : "Edit";
      triggerMixPanelEvent("Whatsapp List", hslElementAction);
    });
    _defineProperty(_this, "_openDrawer", function () {
      _this.props.activateDrawer();
    });
    _defineProperty(_this, "_closeDrawer", function () {
      _this.props.deactivateDrawer();
    });
    _defineProperty(_this, "_copy", function () {
      _this.props.copyToClipboard(convertToHSL$4(_this.state));
    });
    _defineProperty(_this, "_renderBody", function () {
      var sectionCount = _this.state.sections.length > 1 ? "".concat(_this.state.sections.length, " sections") : "".concat(_this.state.sections.length, " section");
      var itemCount = _this.state.itemCount > 1 ? "".concat(_this.state.itemCount, " items") : "".concat(_this.state.itemCount, " item");
      return !_this.props.isPopupElement ? /*#__PURE__*/React.createElement(WhatsappActionable, {
        icon: /*#__PURE__*/React.createElement(ListButtonIcon, null),
        title: "Whatsapp List Button",
        text: _this.state.text,
        data: [sectionCount, itemCount]
      }) : /*#__PURE__*/React.createElement("img", {
        src: WHATSAPP_PREVIEWS.list,
        style: {
          width: "100%",
          height: "auto"
        }
      });
    });
    _defineProperty(_this, "_renderAccordionHeader", function (i) {
      return /*#__PURE__*/React.createElement(Box, {
        padding: "16px",
        position: "relative",
        paddingBottom: "0",
        backgroundColor: "none",
        justifyContent: "space-between",
        alignItems: "center"
      }, /*#__PURE__*/React.createElement(SectionTitleWrapper, {
        top: _this.state.activeSections[i] ? 15 : 0
      }, /*#__PURE__*/React.createElement(Text$1, {
        variant: "h3.semi-bold"
      }, "Section Title")), i > 0 && /*#__PURE__*/React.createElement(DeleteBtn, {
        onClick: function onClick(e) {
          return _this._deleteSection(i, e);
        },
        href: "javascript:void(0)",
        top: 20,
        right: 50
      }, /*#__PURE__*/React.createElement("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React.createElement("path", {
        d: "M4.83329 8.1665V9.83317H13.1666V8.1665H4.83329ZM8.99996 0.666504C4.39996 0.666504 0.666626 4.39984 0.666626 8.99984C0.666626 13.5998 4.39996 17.3332 8.99996 17.3332C13.6 17.3332 17.3333 13.5998 17.3333 8.99984C17.3333 4.39984 13.6 0.666504 8.99996 0.666504ZM8.99996 15.6665C5.32496 15.6665 2.33329 12.6748 2.33329 8.99984C2.33329 5.32484 5.32496 2.33317 8.99996 2.33317C12.675 2.33317 15.6666 5.32484 15.6666 8.99984C15.6666 12.6748 12.675 15.6665 8.99996 15.6665Z",
        fill: "#858585"
      }))), /*#__PURE__*/React.createElement(Icon, {
        src: "angle-down"
      }));
    });
    _defineProperty(_this, "_toggleSection", function (i) {
      var activeSections = _objectSpread2({}, _this.state.activeSections);
      activeSections[i] = !activeSections[i];
      _this._setState({
        activeSections: activeSections
      });
    });
    _defineProperty(_this, "_onSectionDataChange", function (i, val, id) {
      var sections = JSON.parse(JSON.stringify(_toConsumableArray(_this.state.sections)));
      sections[i][id] = val;
      _this._setState({
        sections: sections
      });
    });
    _defineProperty(_this, "_onSectionDataBlur", function (i, e, id) {
      var value = e.target.value;
      var sections = JSON.parse(JSON.stringify(_toConsumableArray(_this.state.sections)));
      sections[i][id] = value.trim();
      _this._setState({
        sections: sections
      });
    });
    _defineProperty(_this, "_onItemFieldChange", function (i, j, val, id) {
      var sections = JSON.parse(JSON.stringify(_toConsumableArray(_this.state.sections)));
      var buttons = sections[i].buttons;
      buttons[j][id] = val;
      sections[i].buttons = buttons;
      _this._setState({
        sections: sections
      });
    });
    _defineProperty(_this, "_onItemFieldBlur", function (i, j, e, id) {
      var value = e.target.value;
      var sections = JSON.parse(JSON.stringify(_toConsumableArray(_this.state.sections)));
      var buttons = sections[i].buttons;
      buttons[j][id] = value.trim();
      sections[i].buttons = buttons;
      _this._setState({
        sections: sections
      });
    });
    _defineProperty(_this, "_addItem", function (i) {
      if (_this.state.itemCount + 1 > LIMITS.MAX_LIST_ITEMS) {
        _this.props.activateToastMessage("You can't have more than ".concat(LIMITS.MAX_LIST_ITEMS, " items across all sections"));
      } else {
        var sections = JSON.parse(JSON.stringify(_toConsumableArray(_this.state.sections)));
        sections[i].buttons.push(buttonObj);
        _this._setState({
          sections: sections,
          itemCount: _this.state.itemCount + 1
        });
      }
    });
    _defineProperty(_this, "_deleteItem", function (i, j, e) {
      if (e) e.stopPropagation();
      if (_this.state.sections[i].buttons.length - 1 === 0) {
        _this.props.activateToastMessage("You need to have at least 1 button");
      } else {
        var sections = _this.state.sections;
        var buttons = _this.state.sections[i].buttons;
        buttons = buttons.filter(function (_, k) {
          return k !== j;
        });
        sections[i].buttons = buttons;
        _this._setState({
          sections: sections,
          itemCount: _this.state.itemCount - 1
        });
      }
    });
    _defineProperty(_this, "_addSection", function () {
      if (_this.state.itemCount + 1 > LIMITS.MAX_LIST_ITEMS) {
        _this.props.activateToastMessage("You can't have more than ".concat(LIMITS.MAX_LIST_ITEMS, " items across all sections"));
        return;
      }
      if (_this.state.sections.length + 1 > LIMITS.MAX_LIST_ITEMS) {
        _this.props.activateToastMessage("You can't have more than ".concat(LIMITS.MAX_LIST_ITEMS, " sections"));
      } else {
        var sections = JSON.parse(JSON.stringify(_toConsumableArray(_this.state.sections)));
        sections.push(sectionObj);
        var activeSections = _objectSpread2({}, _this.state.activeSections);
        activeSections[_this.state.sections.length] = true;
        _this._setState({
          activeSections: activeSections,
          sections: sections,
          itemCount: _this.state.itemCount + 1
        });
      }
    });
    _defineProperty(_this, "_deleteSection", function (i, e) {
      if (e) e.stopPropagation();
      if (_this.state.sections.length - 1 === 0) {
        _this.props.activateToastMessage("You need to have at least 1 section");
      } else {
        var sections = _this.state.sections;
        var items = _this.state.sections[i].buttons;
        sections = sections.filter(function (_, k) {
          return k !== i;
        });
        _this._setState({
          sections: sections,
          itemCount: _this.state.itemCount - items.length
        });
      }
    });
    _defineProperty(_this, "_handleTextBlur", function (e, key) {
      var value = e.target.value;
      _this._setState(_defineProperty({}, key, value.trim()));
    });
    _defineProperty(_this, "_renderDrawer", function () {
      var _this$state$errors, _this$state$errors2, _this$state$errors3, _this$state$errors4;
      if (_this.props.state) return null;
      var placeholderText = "Enter body text";
      return /*#__PURE__*/React.createElement(Drawer, {
        themed: true,
        zIndex: 10001,
        placement: "RIGHT",
        active: _this.props.drawerActive,
        onClose: _this._save,
        width: 400
      }, /*#__PURE__*/React.createElement(DrawerHeader$1, {
        onCopy: _this._copy,
        label: "Whatsapp List",
        onDone: _this._save,
        onClose: _this._closeDrawer
      }), /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(FormContainer, null, /*#__PURE__*/React.createElement(FormTextInput, {
        themed: true,
        value: _this.state.header,
        onChange: function onChange(val) {
          return _this._setState({
            header: val
          });
        },
        onBlur: function onBlur(e) {
          return _this._handleTextBlur(e, "header");
        },
        placeholder: "Enter header text",
        error: ((_this$state$errors = _this.state.errors) === null || _this$state$errors === void 0 ? void 0 : _this$state$errors.header) || null,
        label: "Header text"
      }), /*#__PURE__*/React.createElement(FormTextArea, {
        themed: true,
        label: "Body Text",
        value: _this.state.text,
        placeholder: placeholderText,
        onChange: function onChange(val) {
          return _this._setState({
            text: val
          });
        },
        onBlur: function onBlur(e) {
          return _this._handleTextBlur(e, "text");
        },
        error: ((_this$state$errors2 = _this.state.errors) === null || _this$state$errors2 === void 0 ? void 0 : _this$state$errors2.text) || null,
        multiline: true
      }), _this.props.isRephraseEnabled && /*#__PURE__*/React.createElement(RephraseBotResponses, {
        baseUrl: _this.props.baseUrl,
        botResponse: _this.state.text,
        onChange: function onChange(val) {
          return _this._setState({
            text: val
          });
        },
        isSeparate: true
      }), /*#__PURE__*/React.createElement(FormTextInput, {
        themed: true,
        value: _this.state.button_text,
        onChange: function onChange(val) {
          return _this._setState({
            button_text: val
          });
        },
        onBlur: function onBlur(e) {
          return _this._handleTextBlur(e, "button_text");
        },
        placeholder: "Enter button text",
        error: ((_this$state$errors3 = _this.state.errors) === null || _this$state$errors3 === void 0 ? void 0 : _this$state$errors3.button_text) || null,
        label: "Button text"
      }), /*#__PURE__*/React.createElement(FormTextInput, {
        themed: true,
        value: _this.state.footer,
        onChange: function onChange(val) {
          return _this._setState({
            footer: val
          });
        },
        onBlur: function onBlur(e) {
          return _this._handleTextBlur(e, "footer");
        },
        placeholder: "Enter footer text (optional)",
        error: ((_this$state$errors4 = _this.state.errors) === null || _this$state$errors4 === void 0 ? void 0 : _this$state$errors4.footer) || null,
        label: "Footer text"
      }), /*#__PURE__*/React.createElement(Box, {
        padding: "0",
        marginTop: 20,
        backgroundColor: "none",
        alignItems: "center"
      }, /*#__PURE__*/React.createElement(Text$1, {
        variant: "h3.semi-bold"
      }, "Section(s)"), /*#__PURE__*/React.createElement(Tooltip, {
        themed: true,
        tooltip: "You can add maximum up to ".concat(LIMITS.MAX_LIST_ITEMS, " sections"),
        position: "TOP",
        size: "large"
      }, /*#__PURE__*/React.createElement(InfoIconWrapper, {
        size: Icon.SIZES.SMALL,
        src: InfoIcon
      }))), _this.state.sections.map(function (section, i) {
        var _this$state$errors5, _this$state$errors6, _section$buttons;
        return /*#__PURE__*/React.createElement(StyledAccordionItem, {
          key: i,
          active: _this.state.activeSections[i],
          onChange: function onChange() {
            return _this._toggleSection(i);
          },
          renderHeader: _this._renderAccordionHeader(i),
          prefixClassName: "accordion-padding"
        }, /*#__PURE__*/React.createElement(FormTextInput, {
          themed: true,
          value: section.title,
          onChange: function onChange(val) {
            return _this._onSectionDataChange(i, val, "title");
          },
          onBlur: function onBlur(e) {
            return _this._onSectionDataBlur(i, e, "title");
          },
          placeholder: "Enter section title here",
          error: ((_this$state$errors5 = _this.state.errors) === null || _this$state$errors5 === void 0 ? void 0 : _this$state$errors5.sections) && ((_this$state$errors6 = _this.state.errors) === null || _this$state$errors6 === void 0 || (_this$state$errors6 = _this$state$errors6.sections[i]) === null || _this$state$errors6 === void 0 ? void 0 : _this$state$errors6.title) || null
        }), /*#__PURE__*/React.createElement(SectionItemsWrapper, null, section === null || section === void 0 || (_section$buttons = section.buttons) === null || _section$buttons === void 0 ? void 0 : _section$buttons.map(function (button, j) {
          var _this$state$errors7, _this$state$errors8, _this$state$errors9, _this$state$errors10, _this$state$errors11, _this$state$errors12, _this$state$errors13, _this$state$errors14, _this$state$errors15;
          return /*#__PURE__*/React.createElement("div", {
            key: j
          }, /*#__PURE__*/React.createElement(SectionItemTitleWrapper, null, /*#__PURE__*/React.createElement(Text$1, {
            variant: "h3.semi-bold"
          }, "Item ", j + 1), j > 0 && /*#__PURE__*/React.createElement(DeleteBtn, {
            onClick: function onClick(e) {
              return _this._deleteItem(i, j, e);
            },
            href: "javascript:void(0)"
          }, /*#__PURE__*/React.createElement("svg", {
            width: "18",
            height: "18",
            viewBox: "0 0 18 18",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, /*#__PURE__*/React.createElement("path", {
            d: "M4.83329 8.1665V9.83317H13.1666V8.1665H4.83329ZM8.99996 0.666504C4.39996 0.666504 0.666626 4.39984 0.666626 8.99984C0.666626 13.5998 4.39996 17.3332 8.99996 17.3332C13.6 17.3332 17.3333 13.5998 17.3333 8.99984C17.3333 4.39984 13.6 0.666504 8.99996 0.666504ZM8.99996 15.6665C5.32496 15.6665 2.33329 12.6748 2.33329 8.99984C2.33329 5.32484 5.32496 2.33317 8.99996 2.33317C12.675 2.33317 15.6666 5.32484 15.6666 8.99984C15.6666 12.6748 12.675 15.6665 8.99996 15.6665Z",
            fill: "#858585"
          })))), /*#__PURE__*/React.createElement(FormTextInput, {
            themed: true,
            value: button.title,
            onChange: function onChange(val) {
              return _this._onItemFieldChange(i, j, val, "title");
            },
            onBlur: function onBlur(e) {
              return _this._onItemFieldBlur(i, j, e, "title");
            },
            placeholder: "Enter title for item ".concat(j + 1),
            error: ((_this$state$errors7 = _this.state.errors) === null || _this$state$errors7 === void 0 ? void 0 : _this$state$errors7.sections) && ((_this$state$errors8 = _this.state.errors) === null || _this$state$errors8 === void 0 || (_this$state$errors8 = _this$state$errors8.sections[i]) === null || _this$state$errors8 === void 0 ? void 0 : _this$state$errors8.buttons) && ((_this$state$errors9 = _this.state.errors) === null || _this$state$errors9 === void 0 || (_this$state$errors9 = _this$state$errors9.sections[i]) === null || _this$state$errors9 === void 0 || (_this$state$errors9 = _this$state$errors9.buttons[j]) === null || _this$state$errors9 === void 0 ? void 0 : _this$state$errors9.title) || null
          }), /*#__PURE__*/React.createElement(FormTextInput, {
            themed: true,
            value: button.description,
            onChange: function onChange(val) {
              return _this._onItemFieldChange(i, j, val, "description");
            },
            onBlur: function onBlur(e) {
              return _this._onItemFieldBlur(i, j, e, "description");
            },
            placeholder: "Enter description for item ".concat(j + 1, " (optional)"),
            error: ((_this$state$errors10 = _this.state.errors) === null || _this$state$errors10 === void 0 ? void 0 : _this$state$errors10.sections) && ((_this$state$errors11 = _this.state.errors) === null || _this$state$errors11 === void 0 || (_this$state$errors11 = _this$state$errors11.sections[i]) === null || _this$state$errors11 === void 0 ? void 0 : _this$state$errors11.buttons) && ((_this$state$errors12 = _this.state.errors) === null || _this$state$errors12 === void 0 || (_this$state$errors12 = _this$state$errors12.sections[i]) === null || _this$state$errors12 === void 0 || (_this$state$errors12 = _this$state$errors12.buttons[j]) === null || _this$state$errors12 === void 0 ? void 0 : _this$state$errors12.description) || null
          }), /*#__PURE__*/React.createElement(FormTextInput, {
            themed: true,
            value: button.id,
            onChange: function onChange(val) {
              return _this._onItemFieldChange(i, j, val, "id");
            },
            onBlur: function onBlur(e) {
              return _this._onItemFieldBlur(i, j, e, "id");
            },
            placeholder: "Enter payload for item ".concat(j + 1, " (optional)"),
            error: ((_this$state$errors13 = _this.state.errors) === null || _this$state$errors13 === void 0 ? void 0 : _this$state$errors13.sections) && ((_this$state$errors14 = _this.state.errors) === null || _this$state$errors14 === void 0 || (_this$state$errors14 = _this$state$errors14.sections[i]) === null || _this$state$errors14 === void 0 ? void 0 : _this$state$errors14.buttons) && ((_this$state$errors15 = _this.state.errors) === null || _this$state$errors15 === void 0 || (_this$state$errors15 = _this$state$errors15.sections[i]) === null || _this$state$errors15 === void 0 || (_this$state$errors15 = _this$state$errors15.buttons[j]) === null || _this$state$errors15 === void 0 ? void 0 : _this$state$errors15.id) || null
          }));
        }), /*#__PURE__*/React.createElement(AddButton, {
          isV2: true,
          onClick: function onClick() {
            return _this._addItem(i);
          }
        }, /*#__PURE__*/React.createElement(Box, {
          padding: "0",
          backgroundColor: "none",
          alignItems: "center"
        }, /*#__PURE__*/React.createElement(Text$1, {
          color: "blue.haptik",
          variant: "h3.semi-bold"
        }, "Add item"), /*#__PURE__*/React.createElement(Tooltip, {
          themed: true,
          tooltip: "You can add maximum up to ".concat(LIMITS.MAX_LIST_ITEMS, " items"),
          position: "TOP",
          size: "large"
        }, /*#__PURE__*/React.createElement(InfoIconWrapper, {
          size: Icon.SIZES.SMALL,
          src: InfoIcon
        }))))));
      }), /*#__PURE__*/React.createElement(AddButton, {
        isV2: true,
        onClick: function onClick() {
          return _this._addSection();
        }
      }, /*#__PURE__*/React.createElement(Box, {
        padding: "0",
        backgroundColor: "none",
        alignItems: "center"
      }, /*#__PURE__*/React.createElement(Text$1, {
        color: "blue.haptik",
        variant: "h3.semi-bold"
      }, "Add section"))))));
    });
    _this.state = _objectSpread2({}, _this.initialState);
    if (_props.state) _this.state = _props.state;else _this.reset(_props, true);
    return _this;
  }
  _inherits(List, _React$Component);
  return _createClass(List, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.state) this.setState(nextProps.state);
      if (!this.props.value && nextProps.value) this.reset(nextProps);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(ButtonWrapper, null, /*#__PURE__*/React.createElement("div", {
        onClick: this._openDrawer
      }, this._renderBody()), this._renderDrawer());
    }
  }]);
}(React.Component)) || _class$2) || _class$2) || _class$2) || _class$2);
List.propTypes = {
  activateDrawer: PropTypes.func,
  activateToastMessage: PropTypes.func,
  drawerActive: PropTypes.bool,
  onSave: PropTypes.func,
  onStateChange: PropTypes.func,
  state: PropTypes.object,
  value: PropTypes.object,
  isPopupElement: PropTypes.bool,
  isRephraseEnabled: PropTypes.bool,
  baseUrl: PropTypes.string
};
List.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "reset",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "nextProps",
      "type": null
    }, {
      "name": "shouldAssignStateDirectly",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_setState",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "state",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_save",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "e",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_openDrawer",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_closeDrawer",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_copy",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_renderBody",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_renderAccordionHeader",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "i",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_toggleSection",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "i",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_onSectionDataChange",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "i",
      "type": null
    }, {
      "name": "val",
      "type": null
    }, {
      "name": "id",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_onSectionDataBlur",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "i",
      "type": null
    }, {
      "name": "e",
      "type": null
    }, {
      "name": "id",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_onItemFieldChange",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "i",
      "type": null
    }, {
      "name": "j",
      "type": null
    }, {
      "name": "val",
      "type": null
    }, {
      "name": "id",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_onItemFieldBlur",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "i",
      "type": null
    }, {
      "name": "j",
      "type": null
    }, {
      "name": "e",
      "type": null
    }, {
      "name": "id",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_addItem",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "i",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_deleteItem",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "i",
      "type": null
    }, {
      "name": "j",
      "type": null
    }, {
      "name": "e",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_addSection",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_deleteSection",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "i",
      "type": null
    }, {
      "name": "e",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_handleTextBlur",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "e",
      "type": null
    }, {
      "name": "key",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_renderDrawer",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "List",
  "props": {
    "activateDrawer": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "activateToastMessage": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "drawerActive": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "onSave": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onStateChange": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "state": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    },
    "value": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    },
    "isPopupElement": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "isRephraseEnabled": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "baseUrl": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};

var css_248z$6 = ".HSL_text__3dSyT {\n  margin-bottom: 14px;\n  flex: 1;\n  position: relative;\n  max-width: 360px;\n  overflow: hidden;\n  font-family: \"Roboto\", serif; }\n\n.HSL_textWithMargin__1diJJ {\n  margin-right: 16px;\n  outline: none; }\n\n.HSL_textActive__3bT-D .HSL_textLabel__2CHUm {\n  color: #0e4498; }\n\n.HSL_textActive__3bT-D .HSL_textInputWrapper__318yO {\n  border-color: #0e4498;\n  background-color: rgba(14, 68, 152, 0.05); }\n\n.HSL_textError__tTecT .HSL_textLabel__2CHUm {\n  color: #f44336; }\n\n.HSL_textError__tTecT .HSL_textInputWrapper__318yO {\n  border-color: #f44336;\n  background-color: rgba(244, 67, 54, 0.05); }\n\n.HSL_textLabelWrapper__WNlrM {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n  justify-content: space-between; }\n  .HSL_textLabelWrapper__WNlrM span:nth-child(2) {\n    opacity: 0.5;\n    font-size: 10px;\n    transition: 0.2s ease-out;\n    cursor: pointer; }\n    .HSL_textLabelWrapper__WNlrM span:nth-child(2):hover {\n      opacity: 1; }\n\n.HSL_textLabel__2CHUm {\n  display: block;\n  color: #666;\n  font-size: 12px;\n  font-weight: 600;\n  margin-left: 2px;\n  transition: 0.2s ease-out;\n  margin-right: 8px; }\n\n.HSL_textHint__3zP_P {\n  display: block;\n  color: #999;\n  font-size: 13px;\n  font-weight: 400;\n  margin-bottom: 8px;\n  margin-left: 2px;\n  margin-top: -6px;\n  transition: 0.2s ease-out; }\n\n.HSL_inputWrapper__36cmC {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 0px; }\n  .HSL_inputWrapper__36cmC.HSL_last__y8Rqz {\n    margin-bottom: 0px; }\n\n.HSL_inputVariant__2aU_d {\n  position: relative;\n  font-size: 12px;\n  margin-bottom: 8px;\n  opacity: 0.8;\n  display: flex;\n  align-items: center;\n  color: #333; }\n  .HSL_inputVariant__2aU_d .HSL_inputVariantIcon__2pSrQ {\n    width: 14px;\n    height: 14px;\n    margin-right: 4px;\n    display: flex;\n    align-items: center;\n    justify-content: center; }\n  .HSL_inputVariant__2aU_d .HSL_inputVariantEndLine__1Fh1S {\n    position: relative;\n    height: 1px;\n    flex: 100;\n    margin-left: 8px;\n    margin-right: 8px;\n    top: 1px;\n    background-color: #ccc; }\n  .HSL_inputVariant__2aU_d .HSL_inputVariantStartLine__25V6H {\n    content: \"\";\n    height: 1px;\n    min-width: 8px;\n    margin-right: 8px;\n    background-color: #ccc; }\n  .HSL_inputVariant__2aU_d .HSL_inputVariantEndText__2w7Sj {\n    color: #666;\n    margin-right: 4px;\n    text-decoration: underline;\n    cursor: pointer; }\n\n.HSL_addVariant__34bdW {\n  position: relative;\n  font-size: 12px;\n  margin-bottom: 8px;\n  margin-top: 4px;\n  opacity: 0.8;\n  display: flex;\n  align-items: center;\n  color: #666;\n  font-weight: 700; }\n  .HSL_addVariant__34bdW .HSL_addVariantIcon__2OItJ {\n    width: 14px;\n    height: 14px;\n    margin-right: 4px;\n    display: flex;\n    align-items: center;\n    justify-content: center; }\n  .HSL_addVariant__34bdW .HSL_addVariantEndLine__AKNdS {\n    position: relative;\n    top: 1px;\n    height: 0px;\n    flex: 100;\n    min-width: 8px;\n    margin-left: 8px;\n    margin-right: 8px;\n    border-bottom: 1px dashed #ddd; }\n  .HSL_addVariant__34bdW .HSL_addVariantButton__2D4j7 {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    opacity: 0; }\n\n.HSL_textInputWrapper__318yO {\n  flex: 1;\n  transition: 0.2s ease-out;\n  cursor: pointer; }\n  .HSL_textInputWrapper__318yO.HSL_disabled__o8F4Y {\n    pointer-events: none;\n    background-color: #eee; }\n\n.HSL_textInputSubtext__1y5Ho {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin: 0 4px;\n  font-size: 12px;\n  position: absolute;\n  bottom: 0;\n  transform: translate3d(0, 100%, 0);\n  padding-top: 4px; }\n\n.HSL_textInputSubtextCount__12-8y {\n  opacity: 0.5; }\n\n.HSL_textInputSubtextError__2Isff {\n  color: #ff0c0c;\n  opacity: 0.8; }\n\n.HSL_addHSLButton__yid1T {\n  margin-bottom: 8px; }\n\n.HSL_reply__1EnPG {\n  position: relative;\n  z-index: 10000; }\n  .HSL_reply__1EnPG:hover .HSL_replyActions__abH9v {\n    opacity: 1;\n    transform: translate3d(-25px, -50%, 0); }\n    .HSL_reply__1EnPG:hover .HSL_replyActions__abH9v.HSL_isSorting__3Wj0z {\n      opacity: 0;\n      transform: translate3d(-100%, -50%, 0); }\n\n.HSL_replyActions__abH9v {\n  position: absolute;\n  top: 50%;\n  right: 0;\n  background-color: #fff;\n  box-shadow: 0 0px 12px rgba(0, 0, 0, 0.2);\n  transform: translate3d(0, -50%, 0);\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  overflow: hidden;\n  opacity: 0;\n  transform: translate3d(50%, -50%, 0);\n  transition: 0.2s ease-out;\n  z-index: 2;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n  pointer-events: none; }\n  .HSL_replyActions__abH9v .HSL_replyActionsIcon__2XNHl {\n    width: 32px;\n    height: 32px;\n    padding: 6px;\n    border-right: 1px solid #eee;\n    cursor: pointer;\n    box-sizing: border-box; }\n    .HSL_replyActions__abH9v .HSL_replyActionsIcon__2XNHl:hover {\n      background-color: #f5f5f5; }\n    .HSL_replyActions__abH9v .HSL_replyActionsIcon__2XNHl:not(:first-child) {\n      pointer-events: auto; }\n\n.HSL_settingsPopup__1QT-Z {\n  max-height: unset;\n  z-index: 10000;\n  pointer-events: auto; }\n\n.HSL_unsupported__2tNd_ {\n  display: flex;\n  align-items: center;\n  background-color: #fad8db;\n  width: 300px;\n  height: 50px;\n  border-radius: 2px;\n  padding: 10px;\n  box-sizing: border-box !important;\n  margin-bottom: 10px;\n  margin-top: -6px;\n  cursor: default; }\n  .HSL_unsupported_hsl__3P5_4 {\n    border: 1px solid #ef8b93; }\n  .HSL_unsupported_text__1B133 {\n    color: #d91e2d;\n    margin-left: 8px;\n    line-height: 18px;\n    font-size: 14px;\n    padding: 4px 0; }\n  .HSL_unsupported_icon__x4FBU {\n    align-self: flex-start; }\n";
var styles$6 = {"text":"HSL_text__3dSyT","textWithMargin":"HSL_textWithMargin__1diJJ","textActive":"HSL_textActive__3bT-D","textLabel":"HSL_textLabel__2CHUm","textInputWrapper":"HSL_textInputWrapper__318yO","textError":"HSL_textError__tTecT","textLabelWrapper":"HSL_textLabelWrapper__WNlrM","textHint":"HSL_textHint__3zP_P","inputWrapper":"HSL_inputWrapper__36cmC","last":"HSL_last__y8Rqz","inputVariant":"HSL_inputVariant__2aU_d","inputVariantIcon":"HSL_inputVariantIcon__2pSrQ","inputVariantEndLine":"HSL_inputVariantEndLine__1Fh1S","inputVariantStartLine":"HSL_inputVariantStartLine__25V6H","inputVariantEndText":"HSL_inputVariantEndText__2w7Sj","addVariant":"HSL_addVariant__34bdW","addVariantIcon":"HSL_addVariantIcon__2OItJ","addVariantEndLine":"HSL_addVariantEndLine__AKNdS","addVariantButton":"HSL_addVariantButton__2D4j7","disabled":"HSL_disabled__o8F4Y","textInputSubtext":"HSL_textInputSubtext__1y5Ho","textInputSubtextCount":"HSL_textInputSubtextCount__12-8y","textInputSubtextError":"HSL_textInputSubtextError__2Isff","addHSLButton":"HSL_addHSLButton__yid1T","reply":"HSL_reply__1EnPG","replyActions":"HSL_replyActions__abH9v","isSorting":"HSL_isSorting__3Wj0z","replyActionsIcon":"HSL_replyActionsIcon__2XNHl","settingsPopup":"HSL_settingsPopup__1QT-Z","unsupported":"HSL_unsupported__2tNd_","unsupported_hsl":"HSL_unsupported_hsl__3P5_4","unsupported_text":"HSL_unsupported_text__1B133","unsupported_icon":"HSL_unsupported_icon__x4FBU"};
styleInject(css_248z$6);

function _extends$a() { _extends$a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }
var MultiPLM = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$a({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("rect", {
  x: "1.5",
  y: "1.5",
  width: "21",
  height: "21",
  rx: "1.5",
  stroke: "#BFEFD3",
  strokeWidth: "3"
}), /*#__PURE__*/React.createElement("rect", {
  x: "9.5",
  y: "6",
  width: "5",
  height: "5",
  rx: "1",
  fill: "#6ECD95"
}), /*#__PURE__*/React.createElement("rect", {
  x: "9.5",
  y: "13",
  width: "5",
  height: "5",
  rx: "1",
  fill: "#6ECD95"
})));

var convertFromHSL$5 = function convertFromHSL(HSL) {
  var activeSections = {};
  var itemCount = 0;
  HSL.sections.forEach(function (_, i) {
    activeSections[i] = i === 0 ? true : false;
    itemCount += _.product_items.length;
  });
  var component = {
    type: "WHATSAPP_INTERACTIVE_PRODUCT_LIST",
    text: HSL.text,
    header: HSL.header,
    footer: HSL.footer,
    button_text: HSL.button_text,
    sections: HSL.sections,
    catalog_id: HSL.catalog_id,
    activeSections: activeSections,
    itemCount: itemCount,
    errors: {},
    accordionActive: true,
    _originalHSL: HSL
  };
  return component;
};
var convertToHSL$5 = function convertToHSL(component) {
  var HSL = {
    type: "WHATSAPP_INTERACTIVE_PRODUCT_LIST",
    text: component.text,
    catalog_id: component.catalog_id,
    header: component.header,
    footer: component.footer,
    button_text: component.button_text,
    sections: component.sections
  };
  return HSL;
};

var _dec$3, _dec2$3, _dec3$3, _dec4$2, _class$3;
var buttonObj$1 = {
  product_retailer_id: ""
};
var sectionObj$1 = {
  title: "",
  product_items: [buttonObj$1]
};
var WhatsAppPLM = (_dec$3 = ToastMessage(), _dec2$3 = EmojiPicker(), _dec3$3 = ConfirmationDialog(), _dec4$2 = HSLWrapper(), _dec$3(_class$3 = _dec2$3(_class$3 = _dec3$3(_class$3 = _dec4$2(_class$3 = /*#__PURE__*/function (_React$Component) {
  function WhatsAppPLM(_props) {
    var _this;
    _classCallCheck(this, WhatsAppPLM);
    _this = _callSuper(this, WhatsAppPLM, [_props]);
    _defineProperty(_this, "initialState", {
      type: "WHATSAPP_INTERACTIVE_PRODUCT_LIST",
      text: "",
      header: "",
      catalog_id: "",
      footer: "",
      sections: [sectionObj$1],
      activeSections: {
        0: true
      },
      itemCount: 1,
      errors: {},
      accordionActive: true
    });
    _defineProperty(_this, "reset", function (nextProps, shouldAssignStateDirectly) {
      var props = nextProps || _this.props || {};
      var value = props.value && !props.value.isNew ? convertFromHSL$5(props.value) : _objectSpread2({}, _this.initialState);
      if (shouldAssignStateDirectly) {
        _this.state = value;
        _this.props.onStateChange();
      } else {
        _this._setState(value);
      }
    });
    _defineProperty(_this, "_save", function (e) {
      var _this$props;
      var _this$state = _this.state,
        header = _this$state.header,
        text = _this$state.text,
        footer = _this$state.footer,
        sections = _this$state.sections,
        catalog_id = _this$state.catalog_id;
      var errors = {};
      if (!header) {
        errors.header = "Please enter header text";
      } else if (header.length > LIMITS.HEADER_TEXT) {
        errors.header = "Exceeding character limit. Max limit is ".concat(LIMITS.HEADER_TEXT);
      }
      if (!catalog_id) {
        errors.catalog_id = "Please enter Catalog ID";
      } else if (catalog_id.length > LIMITS.CATALOG_ID) {
        errors.catalog_id = "Exceeding character limit. Max limit is ".concat(LIMITS.CATALOG_ID);
      }
      if (!text) {
        errors.text = "Please enter body text";
      } else if (text.length > LIMITS.BODY_TEXT) {
        errors.text = "Exceeding character limit. Max limit is ".concat(LIMITS.BODY_TEXT);
      }
      if (footer && footer.length > LIMITS.HEADER_TEXT) {
        errors.footer = "Exceeding character limit. Max limit is ".concat(LIMITS.HEADER_TEXT);
      }
      var sectionErrors = {};
      sections.forEach(function (section, i) {
        var section_item_errors = {};
        if (!section.title) {
          sectionErrors[i] = {
            title: "Please enter section title"
          };
        } else if (section.title.length > LIMITS.LIST_SECTION_TITLE) {
          sectionErrors[i] = {
            title: "Exceeding character limit. Max limit is ".concat(LIMITS.LIST_SECTION_TITLE)
          };
        }
        section.product_items.forEach(function (button, j) {
          if (!button.product_retailer_id) {
            section_item_errors[j] = {
              product_retailer_id: "Please enter item ID"
            };
          } else if (button.product_retailer_id.length > LIMITS.ITEM_ID) {
            section_item_errors[j] = {
              product_retailer_id: "Exceeding character limit. Max limit is ".concat(LIMITS.ITEM_ID)
            };
          }
        });
        var buttonsIdArr = section.product_items.map(function (item) {
          return item.product_retailer_id.replace(/\s+$/, "");
        });
        var buttonIdErrIndex = "";
        var isDuplicateButtonId = buttonsIdArr.some(function (item, idx) {
          if (buttonsIdArr.indexOf(item) !== idx && item) {
            buttonIdErrIndex = idx;
            return true;
          }
        });
        var buttonErrorsVals = Object.values(section_item_errors);
        var buttonIdErrorExists = buttonErrorsVals.some(function (item, idx) {
          if (item.product_retailer_id) {
            return true;
          }
        });
        if (isDuplicateButtonId && !buttonIdErrorExists) {
          section_item_errors[buttonIdErrIndex] = _objectSpread2(_objectSpread2({}, section_item_errors[buttonIdErrIndex]), {}, {
            product_retailer_id: "Cannot have duplicate values"
          });
        }
        if (Object.values(section_item_errors).length) {
          sectionErrors[i] = _objectSpread2(_objectSpread2({}, sectionErrors[i]), {}, {
            product_items: section_item_errors
          });
        }
      });
      if (Object.values(sectionErrors).length) {
        errors.sections = sectionErrors;
      }
      _this.setState({
        errors: errors
      });
      if (Object.values(errors).length === 0) {
        _this.props.onSave(convertToHSL$5(_this.state), e);
      }
      var hslElementAction = (_this$props = _this.props) !== null && _this$props !== void 0 && _this$props.isNew ? "Create" : "Edit";
      triggerMixPanelEvent("Whatsapp Interactive Product List", hslElementAction);
    });
    _defineProperty(_this, "_openDrawer", function () {
      _this.props.activateDrawer();
    });
    _defineProperty(_this, "_closeDrawer", function () {
      _this.props.deactivateDrawer();
    });
    _defineProperty(_this, "_copy", function () {
      _this.props.copyToClipboard(convertToHSL$5(_this.state));
    });
    _defineProperty(_this, "_toggleSection", function (i) {
      var activeSections = _objectSpread2({}, _this.state.activeSections);
      activeSections[i] = !activeSections[i];
      _this.setState({
        activeSections: activeSections
      });
    });
    _defineProperty(_this, "_onSectionDataChange", function (i, val, id) {
      var sections = JSON.parse(JSON.stringify(_toConsumableArray(_this.state.sections)));
      sections[i][id] = val;
      _this.setState({
        sections: sections
      });
    });
    _defineProperty(_this, "_onSectionDataBlur", function (i, e, id) {
      var value = e.target.value;
      var sections = JSON.parse(JSON.stringify(_toConsumableArray(_this.state.sections)));
      sections[i][id] = value.trim();
      _this.setState({
        sections: sections
      });
    });
    _defineProperty(_this, "_onItemFieldChange", function (i, j, val, id) {
      var sections = JSON.parse(JSON.stringify(_toConsumableArray(_this.state.sections)));
      var product_items = sections[i].product_items;
      product_items[j][id] = val;
      sections[i].product_items = product_items;
      _this.setState({
        sections: sections
      });
    });
    _defineProperty(_this, "_onItemFieldBlur", function (i, j, e, id) {
      var value = e.target.value;
      var sections = JSON.parse(JSON.stringify(_toConsumableArray(_this.state.sections)));
      var product_items = sections[i].product_items;
      product_items[j][id] = value.trim();
      sections[i].product_items = product_items;
      _this.setState({
        sections: sections
      });
    });
    _defineProperty(_this, "_deleteItem", function (i, j, e) {
      if (e) e.stopPropagation();
      if (_this.state.sections[i].product_items.length - 1 === 0) {
        _this.props.activateToastMessage("You need to have at least 1 button");
      } else {
        var sections = _this.state.sections;
        var product_items = _this.state.sections[i].product_items;
        product_items = product_items.filter(function (_, k) {
          return k !== j;
        });
        sections[i].product_items = product_items;
        _this.setState({
          sections: sections,
          itemCount: _this.state.itemCount - 1
        });
      }
    });
    _defineProperty(_this, "_editItemText", function (index, value, key) {
      var items = _this.state.items;
      var editedItem = _objectSpread2({}, items[index]);
      editedItem[key] = value;
      items[index] = editedItem;
      _this.setState({
        items: items,
        changed: true
      });
    });
    _defineProperty(_this, "_blurItemText", function (index, e, key) {
      var value = e.target.value;
      var items = _this.state.items;
      var editedItem = _objectSpread2({}, items[index]);
      editedItem[key] = value.trim();
      items[index] = editedItem;
      _this.setState({
        items: items,
        changed: true
      });
    });
    _defineProperty(_this, "_addItem", function (i) {
      if (_this.state.itemCount + 1 > LIMITS.MAX_SECTION_ITEMS) {
        _this.props.activateToastMessage("You can't have more than ".concat(LIMITS.MAX_SECTION_ITEMS, " items across all sections"));
      } else {
        var sections = JSON.parse(JSON.stringify(_toConsumableArray(_this.state.sections)));
        sections[i].product_items.push(buttonObj$1);
        _this.setState({
          sections: sections,
          itemCount: _this.state.itemCount + 1
        });
      }
    });
    _defineProperty(_this, "_addSection", function () {
      if (_this.state.itemCount + 1 > LIMITS.MAX_SECTION_ITEMS) {
        _this.props.activateToastMessage("You can't have more than ".concat(LIMITS.MAX_SECTION_ITEMS, " items across all sections"));
        return;
      }
      if (_this.state.sections.length + 1 > LIMITS.MAX_LIST_ITEMS) {
        _this.props.activateToastMessage("You can't have more than ".concat(LIMITS.MAX_LIST_ITEMS, " sections"));
      } else {
        var sections = JSON.parse(JSON.stringify(_toConsumableArray(_this.state.sections)));
        sections.push(sectionObj$1);
        var activeSections = _objectSpread2({}, _this.state.activeSections);
        activeSections[_this.state.sections.length] = true;
        _this.setState({
          activeSections: activeSections,
          sections: sections,
          itemCount: _this.state.itemCount + 1
        });
      }
    });
    _defineProperty(_this, "_deleteSection", function (i, e) {
      if (e) e.stopPropagation();
      if (_this.state.sections.length - 1 === 0) {
        _this.props.activateToastMessage("You need to have at least 1 section");
      } else {
        var sections = _this.state.sections;
        var items = _this.state.sections[i].product_items;
        sections = sections.filter(function (_, k) {
          return k !== i;
        });
        _this.setState({
          sections: sections,
          itemCount: _this.state.itemCount - items.length
        });
      }
    });
    _defineProperty(_this, "_renderBody", function () {
      var sectionCount = _this.state.sections && _this.state.sections.length > 1 ? "".concat(_this.state.sections.length, " sections") : "".concat(_this.state.sections.length, " section");
      var itemCount = _this.state.itemCount > 1 ? "".concat(_this.state.itemCount, " items") : "".concat(_this.state.itemCount, " item");
      return _this.props.isPopupElement ? /*#__PURE__*/React.createElement("img", {
        src: WHATSAPP_PREVIEWS.multi_plm,
        style: {
          width: "100%",
          height: "auto"
        }
      }) : /*#__PURE__*/React.createElement(WhatsappActionable, {
        icon: /*#__PURE__*/React.createElement(MultiPLM, null),
        title: "Whatsapp Multiple PLM",
        text: _this.state.text,
        data: [sectionCount, itemCount]
      });
    });
    _defineProperty(_this, "_renderAccordionHeader", function (i) {
      return /*#__PURE__*/React.createElement(Box, {
        padding: "16px",
        position: "relative",
        paddingBottom: "0",
        backgroundColor: "none",
        justifyContent: "space-between",
        alignItems: "center"
      }, /*#__PURE__*/React.createElement(SectionTitleWrapper, {
        top: _this.state.activeSections[i] ? 15 : 0
      }, /*#__PURE__*/React.createElement(Text$1, {
        variant: "h3.semi-bold"
      }, "Section Title")), i > 0 && /*#__PURE__*/React.createElement(DeleteBtn, {
        onClick: function onClick(e) {
          return _this._deleteSection(i, e);
        },
        href: "javascript:void(0)",
        top: 20,
        right: 50
      }, /*#__PURE__*/React.createElement("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React.createElement("path", {
        d: "M4.83329 8.1665V9.83317H13.1666V8.1665H4.83329ZM8.99996 0.666504C4.39996 0.666504 0.666626 4.39984 0.666626 8.99984C0.666626 13.5998 4.39996 17.3332 8.99996 17.3332C13.6 17.3332 17.3333 13.5998 17.3333 8.99984C17.3333 4.39984 13.6 0.666504 8.99996 0.666504ZM8.99996 15.6665C5.32496 15.6665 2.33329 12.6748 2.33329 8.99984C2.33329 5.32484 5.32496 2.33317 8.99996 2.33317C12.675 2.33317 15.6666 5.32484 15.6666 8.99984C15.6666 12.6748 12.675 15.6665 8.99996 15.6665Z",
        fill: "#858585"
      }))), /*#__PURE__*/React.createElement(Icon, {
        src: "angle-down"
      }));
    });
    _defineProperty(_this, "_handleTextBlur", function (e, key) {
      var value = e.target.value;
      _this.setState(_defineProperty({}, key, value.trim()));
    });
    _defineProperty(_this, "_renderDrawer", function () {
      var _this$state$errors, _this$state$errors2, _this$state$errors3, _this$state$errors4;
      if (_this.props.state) return null;
      var placeholderText = "Enter body text";
      return /*#__PURE__*/React.createElement(Drawer, {
        themed: true,
        zIndex: 10001,
        placement: "RIGHT",
        active: _this.props.drawerActive,
        onClose: _this._save,
        width: 400
      }, /*#__PURE__*/React.createElement(DrawerHeader$1, {
        onCopy: _this._copy,
        label: "Multi-Product Messages",
        onDone: _this._save,
        onClose: _this._closeDrawer
      }), /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(FormContainer, null, /*#__PURE__*/React.createElement(FormTextInput, {
        themed: true,
        value: _this.state.header,
        onChange: function onChange(val) {
          return _this.setState({
            header: val
          });
        },
        onBlur: function onBlur(e) {
          return _this._handleTextBlur(e, "header");
        },
        placeholder: "Enter header text",
        error: ((_this$state$errors = _this.state.errors) === null || _this$state$errors === void 0 ? void 0 : _this$state$errors.header) || null,
        label: "Header text"
      }), /*#__PURE__*/React.createElement(FormTextArea, {
        themed: true,
        label: "Body Text",
        value: _this.state.text,
        placeholder: placeholderText,
        onChange: function onChange(val) {
          return _this.setState({
            text: val
          });
        },
        onBlur: function onBlur(e) {
          return _this._handleTextBlur(e, "text");
        },
        error: ((_this$state$errors2 = _this.state.errors) === null || _this$state$errors2 === void 0 ? void 0 : _this$state$errors2.text) || null,
        multiline: true
      }), _this.props.isRephraseEnabled && /*#__PURE__*/React.createElement(RephraseBotResponses, {
        baseUrl: _this.props.baseUrl,
        botResponse: _this.state.text,
        onChange: function onChange(val) {
          return _this.setState({
            text: val
          });
        },
        isSeparate: true
      }), /*#__PURE__*/React.createElement(FormTextInput, {
        themed: true,
        value: _this.state.footer,
        onChange: function onChange(val) {
          return _this.setState({
            footer: val
          });
        },
        onBlur: function onBlur(e) {
          return _this._handleTextBlur(e, "footer");
        },
        placeholder: "Enter footer text (optional)",
        error: ((_this$state$errors3 = _this.state.errors) === null || _this$state$errors3 === void 0 ? void 0 : _this$state$errors3.footer) || null,
        label: "Footer text"
      }), /*#__PURE__*/React.createElement(FormTextInput, {
        themed: true,
        value: _this.state.catalog_id,
        onChange: function onChange(val) {
          return _this.setState({
            catalog_id: val
          });
        },
        onBlur: function onBlur(e) {
          return _this._handleTextBlur(e, "catalog_id");
        },
        placeholder: "Enter Catalog ID",
        error: ((_this$state$errors4 = _this.state.errors) === null || _this$state$errors4 === void 0 ? void 0 : _this$state$errors4.catalog_id) || null,
        label: "Catalog ID"
      }), /*#__PURE__*/React.createElement(Box, {
        padding: "0",
        marginTop: 20,
        backgroundColor: "none",
        alignItems: "center"
      }, /*#__PURE__*/React.createElement(Text$1, {
        variant: "h3.semi-bold"
      }, "Section(s)"), /*#__PURE__*/React.createElement(Tooltip, {
        themed: true,
        tooltip: "You can add maximum up to ".concat(LIMITS.MAX_LIST_ITEMS, " sections"),
        position: "TOP",
        size: "large"
      }, /*#__PURE__*/React.createElement(InfoIconWrapper, {
        size: Icon.SIZES.SMALL,
        src: InfoIcon
      }))), _this.state.sections.map(function (section, i) {
        var _this$state$errors5, _this$state$errors6;
        return /*#__PURE__*/React.createElement(StyledAccordionItem, {
          key: i,
          active: _this.state.activeSections[i],
          onChange: function onChange() {
            return _this._toggleSection(i);
          },
          renderHeader: _this._renderAccordionHeader(i),
          prefixClassName: "accordion-padding"
        }, /*#__PURE__*/React.createElement(FormTextInput, {
          themed: true,
          value: section.title,
          onChange: function onChange(val) {
            return _this._onSectionDataChange(i, val, "title");
          },
          onBlur: function onBlur(e) {
            return _this._onSectionDataBlur(i, e, "title");
          },
          placeholder: "Enter section title here",
          error: ((_this$state$errors5 = _this.state.errors) === null || _this$state$errors5 === void 0 ? void 0 : _this$state$errors5.sections) && ((_this$state$errors6 = _this.state.errors) === null || _this$state$errors6 === void 0 || (_this$state$errors6 = _this$state$errors6.sections[i]) === null || _this$state$errors6 === void 0 ? void 0 : _this$state$errors6.title) || null
        }), /*#__PURE__*/React.createElement(SectionItemsWrapper, null, section.product_items.map(function (button, j) {
          var _this$state$errors7, _this$state$errors8, _this$state$errors9;
          return /*#__PURE__*/React.createElement("div", {
            key: j
          }, /*#__PURE__*/React.createElement(SectionItemTitleWrapper, null, /*#__PURE__*/React.createElement(Text$1, {
            variant: "h3.semi-bold"
          }, "Item ", j + 1), j > 0 && /*#__PURE__*/React.createElement(DeleteBtn, {
            onClick: function onClick(e) {
              return _this._deleteItem(i, j, e);
            },
            href: "javascript:void(0)"
          }, /*#__PURE__*/React.createElement("svg", {
            width: "18",
            height: "18",
            viewBox: "0 0 18 18",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, /*#__PURE__*/React.createElement("path", {
            d: "M4.83329 8.1665V9.83317H13.1666V8.1665H4.83329ZM8.99996 0.666504C4.39996 0.666504 0.666626 4.39984 0.666626 8.99984C0.666626 13.5998 4.39996 17.3332 8.99996 17.3332C13.6 17.3332 17.3333 13.5998 17.3333 8.99984C17.3333 4.39984 13.6 0.666504 8.99996 0.666504ZM8.99996 15.6665C5.32496 15.6665 2.33329 12.6748 2.33329 8.99984C2.33329 5.32484 5.32496 2.33317 8.99996 2.33317C12.675 2.33317 15.6666 5.32484 15.6666 8.99984C15.6666 12.6748 12.675 15.6665 8.99996 15.6665Z",
            fill: "#858585"
          })))), /*#__PURE__*/React.createElement(FormTextInput, {
            themed: true,
            value: button.product_retailer_id,
            onChange: function onChange(val) {
              return _this._onItemFieldChange(i, j, val, "product_retailer_id");
            },
            onBlur: function onBlur(e) {
              return _this._onItemFieldBlur(i, j, e, "product_retailer_id");
            },
            placeholder: "Enter item ID here",
            error: ((_this$state$errors7 = _this.state.errors) === null || _this$state$errors7 === void 0 ? void 0 : _this$state$errors7.sections) && ((_this$state$errors8 = _this.state.errors) === null || _this$state$errors8 === void 0 || (_this$state$errors8 = _this$state$errors8.sections[i]) === null || _this$state$errors8 === void 0 ? void 0 : _this$state$errors8.product_items) && ((_this$state$errors9 = _this.state.errors) === null || _this$state$errors9 === void 0 || (_this$state$errors9 = _this$state$errors9.sections[i]) === null || _this$state$errors9 === void 0 || (_this$state$errors9 = _this$state$errors9.product_items[j]) === null || _this$state$errors9 === void 0 ? void 0 : _this$state$errors9.product_retailer_id) || null
          }));
        }), /*#__PURE__*/React.createElement(AddButton, {
          isV2: true,
          onClick: function onClick() {
            return _this._addItem(i);
          }
        }, /*#__PURE__*/React.createElement(Box, {
          padding: "0",
          backgroundColor: "none",
          alignItems: "center"
        }, /*#__PURE__*/React.createElement(Text$1, {
          color: "blue.haptik",
          variant: "h3.semi-bold"
        }, "Add item"), /*#__PURE__*/React.createElement(Tooltip, {
          themed: true,
          tooltip: "You can add maximum up to ".concat(LIMITS.MAX_SECTION_ITEMS, " items"),
          position: "TOP",
          size: "large"
        }, /*#__PURE__*/React.createElement(InfoIconWrapper, {
          size: Icon.SIZES.SMALL,
          src: InfoIcon
        }))))));
      }), /*#__PURE__*/React.createElement(AddButton, {
        isV2: true,
        onClick: function onClick() {
          return _this._addSection();
        }
      }, /*#__PURE__*/React.createElement(Box, {
        padding: "0",
        backgroundColor: "none",
        alignItems: "center"
      }, /*#__PURE__*/React.createElement(Text$1, {
        color: "blue.haptik",
        variant: "h3.semi-bold"
      }, "Add section"))))));
    });
    _this.state = _objectSpread2({}, _this.initialState);
    if (_props.state) _this.state = _props.state;else _this.reset(_props, true);
    return _this;
  }
  _inherits(WhatsAppPLM, _React$Component);
  return _createClass(WhatsAppPLM, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.state) this.setState(nextProps.state);
      if (!this.props.value && nextProps.value) this.reset(nextProps);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(ButtonWrapper, null, /*#__PURE__*/React.createElement("div", {
        onClick: this._openDrawer
      }, this._renderBody()), this._renderDrawer());
    }
  }]);
}(React.Component)) || _class$3) || _class$3) || _class$3) || _class$3);
WhatsAppPLM.propTypes = {
  activateDrawer: PropTypes.func,
  activateToastMessage: PropTypes.func,
  drawerActive: PropTypes.bool,
  onSave: PropTypes.func,
  onStateChange: PropTypes.func,
  state: PropTypes.object,
  value: PropTypes.object,
  isPopupElement: PropTypes.bool,
  isRephraseEnabled: PropTypes.bool,
  baseUrl: PropTypes.string
};
WhatsAppPLM.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "reset",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "nextProps",
      "type": null
    }, {
      "name": "shouldAssignStateDirectly",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_save",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "e",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_openDrawer",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_closeDrawer",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_copy",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_toggleSection",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "i",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_onSectionDataChange",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "i",
      "type": null
    }, {
      "name": "val",
      "type": null
    }, {
      "name": "id",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_onSectionDataBlur",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "i",
      "type": null
    }, {
      "name": "e",
      "type": null
    }, {
      "name": "id",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_onItemFieldChange",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "i",
      "type": null
    }, {
      "name": "j",
      "type": null
    }, {
      "name": "val",
      "type": null
    }, {
      "name": "id",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_onItemFieldBlur",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "i",
      "type": null
    }, {
      "name": "j",
      "type": null
    }, {
      "name": "e",
      "type": null
    }, {
      "name": "id",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_deleteItem",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "i",
      "type": null
    }, {
      "name": "j",
      "type": null
    }, {
      "name": "e",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_editItemText",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "index",
      "type": null
    }, {
      "name": "value",
      "type": null
    }, {
      "name": "key",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_blurItemText",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "index",
      "type": null
    }, {
      "name": "e",
      "type": null
    }, {
      "name": "key",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_addItem",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "i",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_addSection",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_deleteSection",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "i",
      "type": null
    }, {
      "name": "e",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_renderBody",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_renderAccordionHeader",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "i",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_handleTextBlur",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "e",
      "type": null
    }, {
      "name": "key",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_renderDrawer",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "WhatsAppPLM",
  "props": {
    "activateDrawer": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "activateToastMessage": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "drawerActive": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "onSave": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onStateChange": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "state": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    },
    "value": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    },
    "isPopupElement": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "isRephraseEnabled": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "baseUrl": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};

function _extends$b() { _extends$b = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b.apply(this, arguments); }
var SinglePLM = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$b({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("rect", {
  x: "1.5",
  y: "1.5",
  width: "21",
  height: "21",
  rx: "1.5",
  stroke: "#BFEFD3",
  strokeWidth: "3"
}), /*#__PURE__*/React.createElement("rect", {
  x: "9.5",
  y: "6.5",
  width: "5",
  height: "5",
  rx: "1",
  fill: "#6ECD95"
})));

var convertFromHSL$6 = function convertFromHSL(HSL) {
  var component = {
    type: "WHATSAPP_INTERACTIVE_SINGLE_PRODUCT",
    text: HSL.text,
    footer: HSL.footer,
    catalog_id: HSL.catalog_id,
    product_retailer_id: HSL.product_retailer_id,
    errors: {},
    _originalHSL: HSL
  };
  return component;
};
var convertToHSL$6 = function convertToHSL(component) {
  var HSL = {
    type: "WHATSAPP_INTERACTIVE_SINGLE_PRODUCT",
    text: component.text,
    footer: component.footer,
    catalog_id: component.catalog_id,
    product_retailer_id: component.product_retailer_id
  };
  return HSL;
};

var _dec$4, _dec2$4, _dec3$4, _dec4$3, _class$4;
var IconWrapper$1 = styled.div({
  textAlign: "center"
});
var ListIcon = styled.svg({
  width: 46,
  height: 48,
  marginBottom: 22
});
var ListText = styled(Text$1)({
  display: "block"
});
var StyledText = styled(Text$1)({
  fontFamily: "Proxima Nova",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: "600",
  lineHeight: "20px",
  letterSpacing: "0px"
});
var SingleProductMessage = (_dec$4 = ToastMessage(), _dec2$4 = EmojiPicker(), _dec3$4 = ConfirmationDialog(), _dec4$3 = HSLWrapper(), _dec$4(_class$4 = _dec2$4(_class$4 = _dec3$4(_class$4 = _dec4$3(_class$4 = /*#__PURE__*/function (_React$Component) {
  function SingleProductMessage(_props) {
    var _this;
    _classCallCheck(this, SingleProductMessage);
    _this = _callSuper(this, SingleProductMessage, [_props]);
    _defineProperty(_this, "initialState", {
      type: "WHATSAPP_INTERACTIVE_SINGLE_PRODUCT",
      text: "",
      catalog_id: "",
      footer: "",
      product_retailer_id: ""
    });
    _defineProperty(_this, "reset", function (nextProps, shouldAssignStateDirectly) {
      var props = nextProps || _this.props || {};
      var value = props.value && !props.value.isNew ? convertFromHSL$6(props.value) : _objectSpread2({}, _this.initialState);
      if (shouldAssignStateDirectly) {
        _this.state = value;
        _this.props.onStateChange();
      } else {
        _this._setState(value);
      }
    });
    _defineProperty(_this, "_save", function (e) {
      var _this$props;
      var _this$state = _this.state,
        text = _this$state.text,
        footer = _this$state.footer,
        catalog_id = _this$state.catalog_id,
        product_retailer_id = _this$state.product_retailer_id;
      var errors = {};
      if (!product_retailer_id) {
        errors.product_retailer_id = "Please enter Item ID";
      } else if (product_retailer_id.length > LIMITS.ITEM_ID) {
        errors.product_retailer_id = "Exceeding character limit. Max limit is ".concat(LIMITS.ITEM_ID);
      }
      if (!catalog_id) {
        errors.catalog_id = "Please enter Catalog ID";
      } else if (catalog_id.length > LIMITS.CATALOG_ID) {
        errors.catalog_id = "Exceeding character limit. Max limit is ".concat(LIMITS.CATALOG_ID);
      }
      if (!text) {
        errors.text = "Please enter body text";
      } else if (text.length > LIMITS.BODY_TEXT) {
        errors.text = "Exceeding character limit. Max limit is ".concat(LIMITS.BODY_TEXT);
      }
      if (footer && footer.length > LIMITS.HEADER_TEXT) {
        errors.footer = "Exceeding character limit. Max limit is ".concat(LIMITS.HEADER_TEXT);
      }
      _this.setState({
        errors: errors
      });
      if (Object.values(errors).length === 0) {
        _this.props.onSave(convertToHSL$6(_this.state), e);
      }
      var hslElementAction = (_this$props = _this.props) !== null && _this$props !== void 0 && _this$props.isNew ? "Create" : "Edit";
      triggerMixPanelEvent("Whatsapp Interactive Single Product", hslElementAction);
    });
    _defineProperty(_this, "_openDrawer", function () {
      _this.props.activateDrawer();
    });
    _defineProperty(_this, "_closeDrawer", function () {
      _this.props.deactivateDrawer();
    });
    _defineProperty(_this, "_copy", function () {
      _this.props.copyToClipboard(convertToHSL$6(_this.state));
    });
    _defineProperty(_this, "_toggleSection", function (i) {
      var activeSections = _objectSpread2({}, _this.state.activeSections);
      activeSections[i] = !activeSections[i];
      _this.setState({
        activeSections: activeSections
      });
    });
    _defineProperty(_this, "_onSectionDataChange", function (i, val, id) {
      var sections = JSON.parse(JSON.stringify(_toConsumableArray(_this.state.sections)));
      sections[i][id] = val;
      _this.setState({
        sections: sections
      });
    });
    _defineProperty(_this, "_onSectionDataBlur", function (i, e, id) {
      var value = e.target.value;
      var sections = JSON.parse(JSON.stringify(_toConsumableArray(_this.state.sections)));
      sections[i][id] = value.trim();
      _this.setState({
        sections: sections
      });
    });
    _defineProperty(_this, "_onItemFieldChange", function (i, j, val, id) {
      var sections = JSON.parse(JSON.stringify(_toConsumableArray(_this.state.sections)));
      var buttons = sections[i].buttons;
      buttons[j][id] = val;
      sections[i].buttons = buttons;
      _this.setState({
        sections: sections
      });
    });
    _defineProperty(_this, "_onItemFieldBlur", function (i, j, e, id) {
      var value = e.target.value;
      var sections = JSON.parse(JSON.stringify(_toConsumableArray(_this.state.sections)));
      var buttons = sections[i].buttons;
      buttons[j][id] = value.trim();
      sections[i].buttons = buttons;
      _this.setState({
        sections: sections
      });
    });
    _defineProperty(_this, "_deleteItem", function (i, j, e) {
      if (e) e.stopPropagation();
      if (_this.state.sections[i].buttons.length - 1 === 0) {
        _this.props.activateToastMessage("You need to have at least 1 button");
      } else {
        var sections = _this.state.sections;
        var buttons = _this.state.sections[i].buttons;
        buttons = buttons.filter(function (_, k) {
          return k !== j;
        });
        sections[i].buttons = buttons;
        _this.setState({
          sections: sections
        });
      }
    });
    _defineProperty(_this, "_editItemText", function (index, value, key) {
      var items = _this.state.items;
      var editedItem = _objectSpread2({}, items[index]);
      editedItem[key] = value;
      items[index] = editedItem;
      _this.setState({
        items: items,
        changed: true
      });
    });
    _defineProperty(_this, "_blurItemText", function (index, e, key) {
      var value = e.target.value;
      var items = _this.state.items;
      var editedItem = _objectSpread2({}, items[index]);
      editedItem[key] = value.trim();
      items[index] = editedItem;
      _this.setState({
        items: items,
        changed: true
      });
    });
    _defineProperty(_this, "_renderBody", function () {
      return _this.props.isPopupElement ? /*#__PURE__*/React.createElement("img", {
        src: WHATSAPP_PREVIEWS.single_plm,
        style: {
          width: "100%",
          height: "auto"
        }
      }) : /*#__PURE__*/React.createElement(WhatsappActionable, {
        icon: /*#__PURE__*/React.createElement(SinglePLM, null),
        title: "Whatsapp Single PLM",
        text: _this.state.text,
        data: []
      });
    });
    _defineProperty(_this, "_renderAccordionHeader", function (i) {
      return /*#__PURE__*/React.createElement(Box, {
        padding: "16px",
        position: "relative",
        paddingBottom: "0",
        backgroundColor: "none",
        justifyContent: "space-between",
        alignItems: "center"
      }, /*#__PURE__*/React.createElement(SectionTitleWrapper, {
        top: _this.state.activeSections[i] ? 15 : 0
      }, /*#__PURE__*/React.createElement(Text$1, {
        variant: "h3.semi-bold"
      }, "Section Title")), i > 0 && /*#__PURE__*/React.createElement(DeleteBtn, {
        onClick: function onClick(e) {
          return _this._deleteSection(i, e);
        },
        href: "javascript:void(0)",
        top: 20,
        right: 50
      }, /*#__PURE__*/React.createElement("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React.createElement("path", {
        d: "M4.83329 8.1665V9.83317H13.1666V8.1665H4.83329ZM8.99996 0.666504C4.39996 0.666504 0.666626 4.39984 0.666626 8.99984C0.666626 13.5998 4.39996 17.3332 8.99996 17.3332C13.6 17.3332 17.3333 13.5998 17.3333 8.99984C17.3333 4.39984 13.6 0.666504 8.99996 0.666504ZM8.99996 15.6665C5.32496 15.6665 2.33329 12.6748 2.33329 8.99984C2.33329 5.32484 5.32496 2.33317 8.99996 2.33317C12.675 2.33317 15.6666 5.32484 15.6666 8.99984C15.6666 12.6748 12.675 15.6665 8.99996 15.6665Z",
        fill: "#858585"
      }))), /*#__PURE__*/React.createElement(Icon, {
        src: "angle-down"
      }));
    });
    _defineProperty(_this, "_handleTextBlur", function (e, key) {
      var value = e.target.value;
      _this.setState(_defineProperty({}, key, value.trim()));
    });
    _defineProperty(_this, "_renderDrawer", function () {
      var _this$state$errors, _this$state$errors2, _this$state$errors3, _this$state$errors4;
      if (_this.props.state) return null;
      var placeholderText = "Enter body text";
      return /*#__PURE__*/React.createElement(Drawer, {
        themed: true,
        zIndex: 10001,
        placement: "RIGHT",
        active: _this.props.drawerActive,
        onClose: _this._save,
        width: 400
      }, /*#__PURE__*/React.createElement(DrawerHeader$1, {
        onCopy: _this._copy,
        label: "Single Product Messages",
        onDone: _this._save,
        onClose: _this._closeDrawer
      }), /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(FormContainer, null, /*#__PURE__*/React.createElement(FormTextArea, {
        themed: true,
        label: "Body Text",
        value: _this.state.text,
        placeholder: placeholderText,
        onChange: function onChange(val) {
          return _this.setState({
            text: val
          });
        },
        onBlur: function onBlur(e) {
          return _this._handleTextBlur(e, "text");
        },
        error: ((_this$state$errors = _this.state.errors) === null || _this$state$errors === void 0 ? void 0 : _this$state$errors.text) || null,
        multiline: true
      }), _this.props.isRephraseEnabled && /*#__PURE__*/React.createElement(RephraseBotResponses, {
        baseUrl: _this.props.baseUrl,
        botResponse: _this.state.text,
        onChange: function onChange(val) {
          return _this.setState({
            text: val
          });
        },
        isSeparate: true
      }), /*#__PURE__*/React.createElement(FormTextInput, {
        themed: true,
        value: _this.state.footer,
        onChange: function onChange(val) {
          return _this.setState({
            footer: val
          });
        },
        onBlur: function onBlur(e) {
          return _this._handleTextBlur(e, "footer");
        },
        placeholder: "Enter footer text (optional)",
        error: ((_this$state$errors2 = _this.state.errors) === null || _this$state$errors2 === void 0 ? void 0 : _this$state$errors2.footer) || null,
        label: "Footer text"
      }), /*#__PURE__*/React.createElement(FormTextInput, {
        themed: true,
        value: _this.state.catalog_id,
        onChange: function onChange(val) {
          return _this.setState({
            catalog_id: val
          });
        },
        onBlur: function onBlur(e) {
          return _this._handleTextBlur(e, "catalog_id");
        },
        placeholder: "Enter Catalog ID",
        error: ((_this$state$errors3 = _this.state.errors) === null || _this$state$errors3 === void 0 ? void 0 : _this$state$errors3.catalog_id) || null,
        label: "Catalog ID"
      }), /*#__PURE__*/React.createElement(FormTextInput, {
        themed: true,
        value: _this.state.product_retailer_id,
        onChange: function onChange(val) {
          return _this.setState({
            product_retailer_id: val
          });
        },
        onBlur: function onBlur(e) {
          return _this._handleTextBlur(e, "product_retailer_id");
        },
        placeholder: "Enter Item ID",
        error: ((_this$state$errors4 = _this.state.errors) === null || _this$state$errors4 === void 0 ? void 0 : _this$state$errors4.product_retailer_id) || null,
        label: "Item ID"
      }))));
    });
    _this.state = _objectSpread2(_objectSpread2({}, _this.initialState), {}, {
      errors: {},
      accordionActive: true
    });
    if (_props.state) _this.state = _props.state;else _this.reset(_props, true);
    return _this;
  }
  _inherits(SingleProductMessage, _React$Component);
  return _createClass(SingleProductMessage, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.state) this.setState(nextProps.state);
      if (!this.props.value && nextProps.value) this.reset(nextProps);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(ButtonWrapper, null, /*#__PURE__*/React.createElement("div", {
        onClick: this._openDrawer
      }, this._renderBody()), this._renderDrawer());
    }
  }]);
}(React.Component)) || _class$4) || _class$4) || _class$4) || _class$4);
SingleProductMessage.propTypes = {
  activateDrawer: PropTypes.func,
  activateToastMessage: PropTypes.func,
  drawerActive: PropTypes.bool,
  onSave: PropTypes.func,
  onStateChange: PropTypes.func,
  state: PropTypes.object,
  value: PropTypes.object,
  isPopupElement: PropTypes.bool,
  isRephraseEnabled: PropTypes.bool,
  baseUrl: PropTypes.string
};
SingleProductMessage.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "reset",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "nextProps",
      "type": null
    }, {
      "name": "shouldAssignStateDirectly",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_save",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "e",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_openDrawer",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_closeDrawer",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_copy",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_toggleSection",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "i",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_onSectionDataChange",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "i",
      "type": null
    }, {
      "name": "val",
      "type": null
    }, {
      "name": "id",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_onSectionDataBlur",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "i",
      "type": null
    }, {
      "name": "e",
      "type": null
    }, {
      "name": "id",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_onItemFieldChange",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "i",
      "type": null
    }, {
      "name": "j",
      "type": null
    }, {
      "name": "val",
      "type": null
    }, {
      "name": "id",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_onItemFieldBlur",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "i",
      "type": null
    }, {
      "name": "j",
      "type": null
    }, {
      "name": "e",
      "type": null
    }, {
      "name": "id",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_deleteItem",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "i",
      "type": null
    }, {
      "name": "j",
      "type": null
    }, {
      "name": "e",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_editItemText",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "index",
      "type": null
    }, {
      "name": "value",
      "type": null
    }, {
      "name": "key",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_blurItemText",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "index",
      "type": null
    }, {
      "name": "e",
      "type": null
    }, {
      "name": "key",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_renderBody",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "_renderAccordionHeader",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "i",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_handleTextBlur",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "e",
      "type": null
    }, {
      "name": "key",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_renderDrawer",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "SingleProductMessage",
  "props": {
    "activateDrawer": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "activateToastMessage": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "drawerActive": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "onSave": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onStateChange": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "state": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    },
    "value": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    },
    "isPopupElement": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "isRephraseEnabled": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "baseUrl": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};

var css_248z$7 = ".CarouselElement-display_carouselElement__Jgmx9 {\n  position: relative;\n  border-radius: 8px;\n  overflow: hidden;\n  margin-right: 8px;\n  width: 200px; }\n  .CarouselElement-display_carouselElement__Jgmx9:last-child {\n    margin-right: 0; }\n  .CarouselElement-display_carouselElementImage__29WaV {\n    width: 100%;\n    min-height: 100px;\n    height: 150px;\n    object-fit: cover;\n    border-bottom: 1px solid #ddd;\n    border: 1px solid #ddd;\n    margin-bottom: -4px;\n    border-top-left-radius: 8px;\n    border-top-right-radius: 8px; }\n    .CarouselElement-display_carouselElementImage__29WaV:not(:empty) {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      flex-direction: column;\n      font-size: 12px;\n      background-color: #fff;\n      margin-bottom: 0; }\n    .CarouselElement-display_carouselElementImage__29WaV.CarouselElement-display_darkMode__1G4XM {\n      border-bottom: none; }\n  .CarouselElement-display_carouselElementText__tGGsf {\n    overflow: hidden;\n    background-color: #fff;\n    border-left: 1px solid #ddd;\n    border-right: 1px solid #ddd;\n    border-bottom: 1px solid #ddd;\n    text-align: left;\n    padding: 8px;\n    line-height: 1.5;\n    border-bottom-left-radius: 8px;\n    border-bottom-right-radius: 8px; }\n    .CarouselElement-display_carouselElementText__tGGsf:empty {\n      padding: 0;\n      border: none; }\n    .CarouselElement-display_carouselElementText__tGGsf.CarouselElement-display_withActionables__i-Dri {\n      border-bottom-left-radius: 0;\n      border-bottom-right-radius: 0; }\n    .CarouselElement-display_carouselElementTextTitleWrapper__Rzgl9 {\n      display: flex;\n      align-items: center;\n      justify-content: space-between; }\n    .CarouselElement-display_carouselElementTextTitle__2BjAi {\n      font-size: 13px;\n      flex: 2;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      padding: 0; }\n    .CarouselElement-display_carouselElementTextMetadata__3HXI- {\n      text-align: right;\n      font-size: 12px;\n      opacity: 0.7;\n      flex: 1;\n      padding-left: 12px; }\n      .CarouselElement-display_carouselElementTextMetadata__3HXI-:empty {\n        padding-left: 0; }\n    .CarouselElement-display_carouselElementTextSubtitle__2P6km {\n      font-weight: 700;\n      margin-bottom: 6px;\n      font-size: 12px;\n      display: block; }\n      .CarouselElement-display_carouselElementTextSubtitle__2P6km:last-child {\n        margin-bottom: 0; }\n    .CarouselElement-display_carouselElementTextDescription__1rjcJ {\n      display: block;\n      font-size: 12px;\n      opacity: 0.7;\n      position: relative;\n      left: -1px;\n      padding: 0 !important;\n      box-shadow: none !important;\n      white-space: pre-wrap; }\n  .CarouselElement-display_carouselElementActionables__2zbXg {\n    border: 1px solid #ddd;\n    border-top: none;\n    border-bottom-left-radius: 8px;\n    border-bottom-right-radius: 8px;\n    overflow: hidden; }\n    .CarouselElement-display_carouselElementActionables__2zbXg:empty {\n      padding: 0;\n      border: none; }\n  .CarouselElement-display_carouselElementActionable__1_guw {\n    padding: 8px;\n    margin-right: 0;\n    background-color: #fff;\n    color: #0e4498;\n    font-size: 12px;\n    line-height: 16px;\n    white-space: nowrap;\n    border-bottom: 1px solid #ddd;\n    text-align: center; }\n    .CarouselElement-display_carouselElementActionable__1_guw:last-child {\n      border-bottom: none; }\n    .CarouselElement-display_carouselElementActionableTitle__2vR2t {\n      font-size: 12px; }\n    .CarouselElement-display_carouselElementActionableSubtitle__llVEz {\n      color: #666;\n      font-size: 10px;\n      max-width: 100%;\n      overflow: hidden;\n      text-overflow: ellipsis; }\n  .CarouselElement-display_carouselElement__Jgmx9 .CarouselElement-display_miniActionable__1CiCD {\n    position: relative;\n    margin-left: -8px;\n    transform: translateY(-50%); }\n    .CarouselElement-display_carouselElement__Jgmx9 .CarouselElement-display_miniActionable__1CiCD button {\n      margin: 0 auto;\n      font-size: 14px;\n      font-weight: 500; }\n";
var styles$7 = {"carouselElement":"CarouselElement-display_carouselElement__Jgmx9","carouselElementImage":"CarouselElement-display_carouselElementImage__29WaV","darkMode":"CarouselElement-display_darkMode__1G4XM","carouselElementText":"CarouselElement-display_carouselElementText__tGGsf","withActionables":"CarouselElement-display_withActionables__i-Dri","carouselElementTextTitleWrapper":"CarouselElement-display_carouselElementTextTitleWrapper__Rzgl9","carouselElementTextTitle":"CarouselElement-display_carouselElementTextTitle__2BjAi","carouselElementTextMetadata":"CarouselElement-display_carouselElementTextMetadata__3HXI-","carouselElementTextSubtitle":"CarouselElement-display_carouselElementTextSubtitle__2P6km","carouselElementTextDescription":"CarouselElement-display_carouselElementTextDescription__1rjcJ","carouselElementActionables":"CarouselElement-display_carouselElementActionables__2zbXg","carouselElementActionable":"CarouselElement-display_carouselElementActionable__1_guw","carouselElementActionableTitle":"CarouselElement-display_carouselElementActionableTitle__2vR2t","carouselElementActionableSubtitle":"CarouselElement-display_carouselElementActionableSubtitle__llVEz","miniActionable":"CarouselElement-display_miniActionable__1CiCD"};
styleInject(css_248z$7);

var CarouselElement = /*#__PURE__*/function (_React$Component) {
  function CarouselElement() {
    var _this;
    _classCallCheck(this, CarouselElement);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, CarouselElement, [].concat(args));
    _defineProperty(_this, "_renderImage", function () {
      var _this$props = _this.props,
        thumbnail = _this$props.thumbnail,
        aspectRatio = _this$props.aspectRatio,
        darkMode = _this$props.darkMode;
      var darkModeClassName = darkMode ? styles$7.darkMode : "";
      var width = 200;
      var height = width / aspectRatio.value;
      if (thumbnail && isValidURL(thumbnail) && !isVideo(thumbnail)) {
        return /*#__PURE__*/React.createElement("img", {
          src: thumbnail,
          className: "".concat(styles$7.carouselElementImage, " ").concat(darkModeClassName),
          style: {
            width: width - 2,
            height: height
          }
        });
      }
      if (thumbnail && isValidURL(thumbnail) && isVideo(thumbnail)) {
        return /*#__PURE__*/React.createElement("iframe", {
          title: "".concat(thumbnail),
          className: "".concat(styles$7.carouselElementImage, " ").concat(darkModeClassName),
          allowFullScreen: "allowfullscreen",
          mozAllowFullScreen: "mozallowfullscreen",
          msAllowFullScreen: "msallowfullscreen",
          oAllowFullScreen: "oallowfullscreen",
          webkitAllowFullScreen: "webkitallowfullscreen",
          frameBorder: "0",
          src: thumbnail,
          width: width,
          height: height
        });
      }
      return /*#__PURE__*/React.createElement("div", {
        style: {
          width: width - 2,
          height: height
        },
        className: styles$7.carouselElementImage
      }, /*#__PURE__*/React.createElement(Icon, {
        className: styles$7.carouselElementImagePlaceholderIcon,
        src: PlaceholderIcon
      }), thumbnail);
    });
    return _this;
  }
  _inherits(CarouselElement, _React$Component);
  return _createClass(CarouselElement, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        title = _this$props2.title,
        subtitle = _this$props2.subtitle,
        description = _this$props2.description,
        metadata = _this$props2.metadata,
        actionables = _this$props2.actionables,
        darkMode = _this$props2.darkMode,
        errorClass = _this$props2.errorClass;
      var darkModeClassName = darkMode ? styles$7.darkMode : "";
      var withActionablesClassName = actionables.length ? styles$7.withActionables : "";
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(errorClass, " ").concat(styles$7.carouselElement)
      }, this._renderImage(), /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles$7.carouselElementText, " ").concat(withActionablesClassName, " ").concat(darkModeClassName)
      }, title || metadata ? /*#__PURE__*/React.createElement("div", {
        className: styles$7.carouselElementTextTitleWrapper
      }, /*#__PURE__*/React.createElement("span", {
        className: styles$7.carouselElementTextTitle
      }, title), metadata ? /*#__PURE__*/React.createElement("span", {
        className: styles$7.carouselElementTextMetadata
      }, metadata) : null) : null, subtitle ? /*#__PURE__*/React.createElement("span", {
        className: styles$7.carouselElementTextSubtitle
      }, subtitle) : null, description ? /*#__PURE__*/React.createElement("span", {
        className: styles$7.carouselElementTextDescription
      }, description) : null), !actionables[KEYS.MINI_ACTIONABLE_INDEX] ? /*#__PURE__*/React.createElement("div", {
        className: styles$7.carouselElementActionables
      }, actionables.map(function (actionable, i) {
        return /*#__PURE__*/React.createElement("div", {
          key: i,
          className: styles$7.carouselElementActionable
        }, /*#__PURE__*/React.createElement("div", {
          key: i,
          className: styles$7.carouselElementActionableTitle
        }, actionable.text), /*#__PURE__*/React.createElement("div", {
          key: i,
          className: styles$7.carouselElementActionableSubtitle
        }, getActionableSubtitle(actionable)));
      })) : null, actionables[KEYS.MINI_ACTIONABLE_INDEX] ? /*#__PURE__*/React.createElement("div", {
        className: styles$7.miniActionable
      }, /*#__PURE__*/React.createElement(Button, {
        primary: true,
        big: true,
        className: errorClass
      }, actionables[KEYS.MINI_ACTIONABLE_INDEX].text)) : null);
    }
  }]);
}(React.Component);
CarouselElement.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  description: PropTypes.string,
  metadata: PropTypes.string,
  thumbnail: PropTypes.string,
  aspectRatio: PropTypes.string,
  darkMode: PropTypes.bool,
  actionables: PropTypes.arrayOf(PropTypes.shape({}))
};
CarouselElement.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "_renderImage",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "CarouselElement",
  "props": {
    "title": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "subtitle": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "description": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "metadata": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "thumbnail": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "aspectRatio": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "darkMode": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "actionables": {
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {}
        }
      },
      "required": false,
      "description": ""
    }
  }
};

var css_248z$8 = ".Carousel-display_carouselHSL__3Zfux {\n  display: flex;\n  flex-direction: column;\n  max-width: 300px; }\n  .Carousel-display_carouselHSLSlider__3Brk2-item:not(:last-child) {\n    margin-right: 8px; }\n  .Carousel-display_carouselHSLSlider__3Brk2-items {\n    min-width: 0; }\n  .Carousel-display_carouselHSLError__3CR32 {\n    border: 1px solid #ef8b93;\n    cursor: not-allowed; }\n";
var styles$8 = {"carouselHSL":"Carousel-display_carouselHSL__3Zfux","carouselHSLSlider":"Carousel-display_carouselHSLSlider__3Brk2","carouselHSLError":"Carousel-display_carouselHSLError__3CR32"};
styleInject(css_248z$8);

/**
 * Display only component for the Carousel HSL. Renders the UI
 * for it based on the HSL value passed down. It's non-interactive
 * @param {Object} props the props for the component
 * @param {string} props.value the HSL string
 * @param {boolean} props.darkMode alternative styling when showing to the agent and not to the user
 */
function CarouselDisplay(_ref) {
  var value = _ref.value,
    darkMode = _ref.darkMode;
  var _convertFromHSL = convertFromHSL$1(value),
    items = _convertFromHSL.items,
    aspectRatio = _convertFromHSL.aspectRatio;
  var errorClass = "";
  if ((value === null || value === void 0 ? void 0 : value.supported_response) === false) {
    errorClass = styles$8.carouselHSLError;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles$8.carouselHSL
  }, /*#__PURE__*/React.createElement(Slider, {
    prefixClassName: styles$8.carouselHSLSlider
  }, items.map(function (_ref2, i) {
    var title = _ref2.title,
      subtitle = _ref2.subtitle,
      metadata = _ref2.metadata,
      description = _ref2.description,
      actionables = _ref2.actionables,
      children = _ref2.children,
      thumbnail = _ref2.thumbnail;
    return /*#__PURE__*/React.createElement(CarouselElement, {
      key: i,
      title: title,
      subtitle: subtitle,
      description: description,
      metadata: metadata,
      actionables: actionables,
      thumbnail: thumbnail,
      aspectRatio: aspectRatio,
      darkMode: darkMode,
      errorClass: errorClass
    }, children);
  })));
}
CarouselDisplay.propTypes = {
  value: PropTypes.string,
  darkMode: PropTypes.bool
};
CarouselDisplay.defaultProps = {
  value: {},
  darkMode: false
};

var css_248z$9 = ".DisplayWrapper_hsl__LRmf- {\n  display: inline-flex;\n  flex-direction: column;\n  min-width: 120px;\n  max-width: 300px;\n  border-radius: 8px;\n  overflow: hidden;\n  border-top-left-radius: 4px;\n  padding: 8px;\n  font-size: 14px;\n  box-sizing: border-box;\n  line-height: 1.2;\n  text-align: left;\n  border: 1px solid #ddd;\n  background-color: #fff;\n  color: #333; }\n  .DisplayWrapper_hsl__LRmf-.DisplayWrapper_darkMode__2XPKR {\n    border: 1px solid #0a2f69;\n    background-color: #0e4498;\n    color: #fff;\n    -webkit-font-smoothing: antialiased; }\n  .DisplayWrapper_hsl__LRmf-:hover .DisplayWrapper_hslMeta__2Q8QV {\n    opacity: 0.5;\n    height: 14px;\n    margin-top: 6px; }\n  .DisplayWrapper_hsl__LRmf- .DisplayWrapper_hslMeta__2Q8QV {\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    font-size: 12px;\n    font-weight: 600;\n    height: 0;\n    opacity: 0;\n    transition: 0.1s ease-out; }\n    .DisplayWrapper_hsl__LRmf- .DisplayWrapper_hslMeta__2Q8QV > div:last-child {\n      margin-left: 12px; }\n";
var styles$9 = {"hsl":"DisplayWrapper_hsl__LRmf-","darkMode":"DisplayWrapper_darkMode__2XPKR","hslMeta":"DisplayWrapper_hslMeta__2Q8QV"};
styleInject(css_248z$9);

/**
 * Wraps the hsl display component with basic data such as the
 * date of the message and the user who sent is
 * @param {Object} props
 * @param {Object} props.children HSL content
 * @param {string} props.date The date of the HSL message
 * @param {string} props.user The sender of the HSL message
 * @param {string} props.className An optional className to be appended to the outermost div
 * @param {boolean} props.darkMode alternative styling when showing to the agent and not to the user
 */
function DisplayWrapper(_ref) {
  var children = _ref.children,
    date = _ref.date,
    user = _ref.user,
    className = _ref.className,
    darkMode = _ref.darkMode;
  var darkModeClassName = darkMode ? styles$9.darkMode : "";
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles$9.hsl, " ").concat(className, " ").concat(darkModeClassName)
  }, children, date ? /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles$9.hslMeta)
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles$9.hslDate)
  }, date), /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles$9.hslUser)
  }, user)) : null);
}
DisplayWrapper.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  date: PropTypes.string,
  user: PropTypes.string,
  darkMode: PropTypes.bool
};
DisplayWrapper.defaultProps = {
  children: null,
  className: "",
  date: "",
  user: "",
  darkMode: false
};
DisplayWrapper.__docgenInfo = {
  "description": "Wraps the hsl display component with basic data such as the\ndate of the message and the user who sent is\n@param {Object} props\n@param {Object} props.children HSL content\n@param {string} props.date The date of the HSL message\n@param {string} props.user The sender of the HSL message\n@param {string} props.className An optional className to be appended to the outermost div\n@param {boolean} props.darkMode alternative styling when showing to the agent and not to the user",
  "methods": [],
  "displayName": "DisplayWrapper",
  "props": {
    "children": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "className": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "date": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "user": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "darkMode": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    }
  }
};

var css_248z$a = ".Button-display_buttonHSL__v6HhH {\n  display: flex;\n  flex-direction: column;\n  min-width: 120px;\n  max-width: 300px; }\n  .Button-display_buttonHSLDisplayWrapper__2v23M {\n    border-bottom: 1px solid #ddd;\n    border-bottom-left-radius: 0 !important;\n    border-bottom-right-radius: 0 !important; }\n  .Button-display_buttonHSLText__27xB2 {\n    overflow-wrap: break-word;\n    white-space: pre-wrap; }\n  .Button-display_buttonHSLActionables__2sI19 {\n    border: 1px solid #ddd;\n    border-top: none;\n    border-bottom-left-radius: 8px;\n    border-bottom-right-radius: 8px;\n    overflow: hidden; }\n  .Button-display_buttonHSLActionable__33VT0 {\n    padding: 8px;\n    margin-right: 0;\n    background-color: #fff;\n    color: #0e4498;\n    font-size: 12px;\n    line-height: 16px;\n    white-space: nowrap;\n    border-bottom: 1px solid #ddd;\n    text-align: center; }\n    .Button-display_buttonHSLActionable__33VT0:last-child {\n      border-bottom: none; }\n    .Button-display_buttonHSLActionableTitle__3XW6L {\n      font-size: 12px; }\n    .Button-display_buttonHSLActionableSubtitle__3sigl {\n      color: #666;\n      font-size: 10px; }\n  .Button-display_buttonHSLError__1_A2U {\n    border: 1px solid #ef8b93;\n    cursor: not-allowed; }\n";
var styles$a = {"buttonHSL":"Button-display_buttonHSL__v6HhH","buttonHSLDisplayWrapper":"Button-display_buttonHSLDisplayWrapper__2v23M","buttonHSLText":"Button-display_buttonHSLText__27xB2","buttonHSLActionables":"Button-display_buttonHSLActionables__2sI19","buttonHSLActionable":"Button-display_buttonHSLActionable__33VT0","buttonHSLActionableTitle":"Button-display_buttonHSLActionableTitle__3XW6L","buttonHSLActionableSubtitle":"Button-display_buttonHSLActionableSubtitle__3sigl","buttonHSLError":"Button-display_buttonHSLError__1_A2U"};
styleInject(css_248z$a);

/**
 * Display only component for the Button HSL. Renders the UI
 * for it based on the HSL value passed down. It's non-interactive
 * @param {Object} props the props for the component
 * @param {string} props.value the HSL string
 * @param {string} props.date the date the HSL was sent
 * @param {string} props.user the user who sent the HSL
 * @param {boolean} props.darkMode alternative styling when showing to the agent and not to the user
 */
function ButtonDisplay(_ref) {
  var value = _ref.value,
    date = _ref.date,
    user = _ref.user,
    darkMode = _ref.darkMode;
  var _convertFromHSL = convertFromHSL(value),
    botSays = _convertFromHSL.botSays,
    actionables = _convertFromHSL.actionables;
  var errorClass = "";
  if (value.supported_response === false && !botSays) {
    errorClass = styles$a.buttonHSLError;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles$a.buttonHSL, " ").concat(errorClass)
  }, /*#__PURE__*/React.createElement(DisplayWrapper, {
    className: styles$a.buttonHSLDisplayWrapper,
    date: date,
    user: user,
    darkMode: darkMode
  }, /*#__PURE__*/React.createElement("span", {
    className: "".concat(styles$a.buttonHSLText)
  }, botSays || "No Text")), /*#__PURE__*/React.createElement("div", {
    className: styles$a.buttonHSLActionables
  }, actionables.map(function (actionable, i) {
    return /*#__PURE__*/React.createElement("div", {
      key: i,
      className: styles$a.buttonHSLActionable
    }, /*#__PURE__*/React.createElement("div", {
      key: i,
      className: styles$a.buttonHSLActionableTitle
    }, actionable.text), /*#__PURE__*/React.createElement("div", {
      key: i,
      className: styles$a.buttonHSLActionableSubtitle
    }, getActionableSubtitle(actionable)));
  })));
}
ButtonDisplay.propTypes = {
  value: PropTypes.string,
  date: PropTypes.string,
  user: PropTypes.string,
  darkMode: PropTypes.bool
};
ButtonDisplay.defaultProps = {
  value: "No Text",
  darkMode: false
};
ButtonDisplay.__docgenInfo = {
  "description": "Display only component for the Button HSL. Renders the UI\nfor it based on the HSL value passed down. It's non-interactive\n@param {Object} props the props for the component\n@param {string} props.value the HSL string\n@param {string} props.date the date the HSL was sent\n@param {string} props.user the user who sent the HSL\n@param {boolean} props.darkMode alternative styling when showing to the agent and not to the user",
  "methods": [],
  "displayName": "ButtonDisplay",
  "props": {
    "value": {
      "defaultValue": {
        "value": "\"No Text\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "darkMode": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "date": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "user": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};

var css_248z$b = ".Text-display_textHSL__21Nc1 {\n  display: flex;\n  flex-direction: column;\n  min-width: 240px;\n  max-width: 300px; }\n  .Text-display_textHSLText__1_kgr {\n    overflow-wrap: break-word;\n    white-space: pre-wrap; }\n  .Text-display_textHSLQuickReplies__3PkRs {\n    margin-top: 8px;\n    margin-bottom: 8px; }\n  .Text-display_textHSLQuickReply__2lHeP {\n    padding: 8px;\n    background-color: #fff;\n    border: 1px solid #0e4498;\n    margin-right: 8px;\n    color: #0e4498;\n    font-size: 12px;\n    border-radius: 8px;\n    line-height: 16px;\n    white-space: nowrap; }\n  .Text-display_textHSLError__15yPf {\n    border: 1px solid #ef8b93 !important;\n    cursor: not-allowed; }\n";
var styles$b = {"textHSL":"Text-display_textHSL__21Nc1","textHSLText":"Text-display_textHSLText__1_kgr","textHSLQuickReplies":"Text-display_textHSLQuickReplies__3PkRs","textHSLQuickReply":"Text-display_textHSLQuickReply__2lHeP","textHSLError":"Text-display_textHSLError__15yPf"};
styleInject(css_248z$b);

var _templateObject;
var Divider = styled(Box)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: 0;\n  height: 1px;\n  width: 100%;\n  background-color: ", ";\n  margin: 8px 0;\n  border: 0;\n"])), function (props) {
  return props.theme.colors.grey.haptik;
});

/**
 * Display only component for the Text HSL (includes quick replies).
 * Renders the UI for it based on the HSL value passed down. It's non-interactive
 * @param {Object} props the props for the component
 * @param {string} props.value the HSL string
 * @param {string} props.date the date the HSL was sent
 * @param {string} props.user the user who sent the HSL
 * @param {boolean} props.darkMode alternative styling when showing to the agent and not to the user
 */
function TextDisplay(_ref) {
  var value = _ref.value,
    date = _ref.date,
    user = _ref.user,
    darkMode = _ref.darkMode,
    translatedValue = _ref.translatedValue,
    showTranslatedValue = _ref.showTranslatedValue;
  var _convertFromHSL = convertFromHSL$7(value),
    botSays = _convertFromHSL.botSays,
    quickReplies = _convertFromHSL.quickReplies;
  var translatedBotSays;
  if (translatedValue) {
    var _convertFromHSL2 = convertFromHSL$7(translatedValue),
      _botSays = _convertFromHSL2.botSays,
      _quickReplies = _convertFromHSL2.quickReplies;
    translatedBotSays = _botSays;
  }
  var errorClass = "";
  if (value.supported_response === false && !botSays) {
    errorClass = styles$b.textHSLError;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles$b.textHSL, " ")
  }, /*#__PURE__*/React.createElement(DisplayWrapper, {
    darkMode: darkMode,
    date: date,
    user: user,
    className: errorClass
  }, /*#__PURE__*/React.createElement("span", {
    className: "".concat(styles$b.textHSLText)
  }, botSays || "No Text"), translatedBotSays && showTranslatedValue && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement("span", {
    className: "".concat(styles$b.textHSLText)
  }, translatedBotSays))), quickReplies.length ? /*#__PURE__*/React.createElement("div", {
    className: styles$b.textHSLQuickReplies
  }, /*#__PURE__*/React.createElement(Slider, null, quickReplies.map(function (quickReply, i) {
    return /*#__PURE__*/React.createElement("div", {
      key: i,
      className: "".concat(styles$b.textHSLQuickReply, " ").concat(errorClass)
    }, quickReply.text);
  }))) : null);
}
TextDisplay.propTypes = {
  value: PropTypes.string,
  date: PropTypes.string,
  user: PropTypes.string,
  darkMode: PropTypes.bool
};
TextDisplay.defaultProps = {
  value: "No Text",
  darkMode: false
};
TextDisplay.__docgenInfo = {
  "description": "Display only component for the Text HSL (includes quick replies).\nRenders the UI for it based on the HSL value passed down. It's non-interactive\n@param {Object} props the props for the component\n@param {string} props.value the HSL string\n@param {string} props.date the date the HSL was sent\n@param {string} props.user the user who sent the HSL\n@param {boolean} props.darkMode alternative styling when showing to the agent and not to the user",
  "methods": [],
  "displayName": "TextDisplay",
  "props": {
    "value": {
      "defaultValue": {
        "value": "\"No Text\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "darkMode": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "date": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "user": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};

var css_248z$c = ".RawText-display_rawHSLText__24hTW {\n  overflow-wrap: break-word;\n  white-space: pre-wrap; }\n";
var styles$c = {"rawHSLText":"RawText-display_rawHSLText__24hTW"};
styleInject(css_248z$c);

var _templateObject$1;
var Divider$1 = styled(Box)(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n  padding: 0;\n  height: 1px;\n  width: 100%;\n  background-color: ", ";\n  margin: 8px 0;\n  border: 0;\n"])), function (props) {
  return props.theme.colors.grey.haptik;
});

/**
 * Display only component for the Raw HSL. Renders the UI
 * for it based on the HSL value passed down. It's non-interactive
 * @param {Object} props the props for the component
 * @param {string} props.value the HSL string
 * @param {string} props.date the date the HSL was sent
 * @param {string} props.user the user who sent the HSL
 * @param {boolean} props.darkMode alternative styling when showing to the agent and not to the user
 */
function RawTextDisplay(_ref) {
  var value = _ref.value,
    date = _ref.date,
    user = _ref.user,
    darkMode = _ref.darkMode,
    translatedValue = _ref.translatedValue,
    showTranslatedValue = _ref.showTranslatedValue;
  return /*#__PURE__*/React.createElement(DisplayWrapper, {
    className: styles$c.rawHSL,
    date: date,
    user: user,
    darkMode: darkMode
  }, /*#__PURE__*/React.createElement("span", {
    className: "".concat(styles$c.rawHSLText)
  }, value), translatedValue && showTranslatedValue && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Divider$1, null), /*#__PURE__*/React.createElement("span", {
    className: "".concat(styles$c.rawHSLText)
  }, translatedValue)));
}
RawTextDisplay.propTypes = {
  value: PropTypes.string,
  date: PropTypes.string,
  user: PropTypes.string,
  darkMode: PropTypes.bool
};
RawTextDisplay.defaultProps = {
  value: "No Text",
  darkMode: false
};
RawTextDisplay.__docgenInfo = {
  "description": "Display only component for the Raw HSL. Renders the UI\nfor it based on the HSL value passed down. It's non-interactive\n@param {Object} props the props for the component\n@param {string} props.value the HSL string\n@param {string} props.date the date the HSL was sent\n@param {string} props.user the user who sent the HSL\n@param {boolean} props.darkMode alternative styling when showing to the agent and not to the user",
  "methods": [],
  "displayName": "RawTextDisplay",
  "props": {
    "value": {
      "defaultValue": {
        "value": "\"No Text\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "darkMode": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "date": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "user": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};

var _templateObject$2;
var Wrapper = styled(Text$1)(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral(["\n  font-family: \"Roboto\", sans-serif;\n"])));
var ErrorCatcher = /*#__PURE__*/function (_React$Component) {
  function ErrorCatcher() {
    var _this;
    _classCallCheck(this, ErrorCatcher);
    _this = _callSuper(this, ErrorCatcher);
    _this.state = {
      hasError: false
    };
    return _this;
  }
  _inherits(ErrorCatcher, _React$Component);
  return _createClass(ErrorCatcher, [{
    key: "fallbackComponent",
    value: function fallbackComponent() {
      return /*#__PURE__*/React.createElement(Box, {
        borderRadius: 8,
        borderTopRadius: 4,
        backgroundColor: "grey.haptik",
        borderWidth: 1,
        borderColor: "grey.haptik"
      }, /*#__PURE__*/React.createElement(Wrapper, {
        variant: "body.md",
        color: "grey.dark"
      }, "Sorry, unable to display this message."));
    }
  }, {
    key: "render",
    value: function render() {
      var hasError = this.state.hasError;
      var children = this.props.children;
      if (hasError) return this.fallbackComponent();
      return children;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError() {
      return {
        hasError: true
      };
    }
  }]);
}(React.Component);
ErrorCatcher.propTypes = {
  children: PropTypes.node
};
ErrorCatcher.defaultProps = {
  children: null
};
ErrorCatcher.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "fallbackComponent",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "ErrorCatcher",
  "props": {
    "children": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    }
  }
};

var HSLDisplay = /*#__PURE__*/function (_React$Component) {
  function HSLDisplay() {
    var _this;
    _classCallCheck(this, HSLDisplay);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, HSLDisplay, [].concat(args));
    _defineProperty(_this, "_parse", function (value, type) {
      if (type === "RAW") return value;
      try {
        return JSON.parse(value);
      } catch (e) {
        return value;
      }
    });
    _defineProperty(_this, "_getType", function (value) {
      try {
        var _JSON$parse = JSON.parse(value),
          type = _JSON$parse.type;
        switch (type) {
          case "CAROUSEL":
          case "IMAGE":
          case "VIDEO":
          case "BUTTON":
          case "TEXT":
          case "WHATSAPP_INTERACTIVE_BUTTON":
          case "WHATSAPP_INTERACTIVE_LIST":
          case "WHATSAPP_INTERACTIVE_PRODUCT_LIST":
          case "WHATSAPP_INTERACTIVE_SINGLE_PRODUCT":
          case "FORM":
            return type;
          default:
            return "RAW";
        }
      } catch (e) {
        return "RAW";
      }
    });
    _defineProperty(_this, "_getComponent", function (type) {
      switch (type) {
        case "BUTTON":
          return ButtonDisplay;
        case "TEXT":
          return TextDisplay;
        case "CAROUSEL":
        case "IMAGE":
        case "VIDEO":
          return CarouselDisplay;
        case "WHATSAPP_INTERACTIVE_BUTTON":
          return ReplyButton;
        case "WHATSAPP_INTERACTIVE_LIST":
          return List;
        case "WHATSAPP_INTERACTIVE_SINGLE_PRODUCT":
          return SingleProductMessage;
        case "WHATSAPP_INTERACTIVE_PRODUCT_LIST":
          return WhatsAppPLM;
        case "FORM":
          return HSLForms;
        default:
          return RawTextDisplay;
      }
    });
    return _this;
  }
  _inherits(HSLDisplay, _React$Component);
  return _createClass(HSLDisplay, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      // when variants are enabled, the value is an array by default
      // if not enabled, then if the value exists, we convert it into an array with a single
      // value, otherwise it's an empty array
      var value = this.props.value;
      if (!this.props.withVariants) {
        if (typeof value === "string" && value.length === 0) {
          value = [value];
        } else {
          value = value ? [value] : [];
        }
      }
      if (value.length === 0) return null;
      return /*#__PURE__*/React.createElement(React.Fragment, null, value.map(function (HSLString) {
        if (!HSLString && HSLString !== "") return null;
        return HSLString.split("<m>").map(function (HSLElementString, i) {
          var HSLType = _this2._getType(HSLElementString);
          var JSONValue = _this2._parse(HSLElementString, HSLType);
          var HSLComponent = _this2._getComponent(HSLType);
          return /*#__PURE__*/React.createElement(ErrorCatcher, null, /*#__PURE__*/React.createElement(HSLComponent, _extends$c({}, _this2.props, {
            key: "".concat(HSLElementString, "-").concat(i),
            type: HSLType,
            value: JSONValue
          })), JSONValue.supported_response === false && /*#__PURE__*/React.createElement("div", {
            className: styles$6.unsupported,
            style: {
              marginTop: "4px"
            }
          }, /*#__PURE__*/React.createElement("span", {
            className: styles$6.unsupported_icon
          }, /*#__PURE__*/React.createElement(ErrorCross, null)), /*#__PURE__*/React.createElement("span", {
            className: styles$6.unsupported_text
          }, "This element cannot be auto generated for Whatsapp")));
        });
      }));
    }
  }]);
}(React.Component);
HSLDisplay.propTypes = {
  className: PropTypes.string,
  value: PropTypes.string,
  withReplies: PropTypes.bool,
  withVariants: PropTypes.bool
};
HSLDisplay.defaultProps = {};
HSLDisplay.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "_parse",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "value",
      "type": null
    }, {
      "name": "type",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_getType",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "value",
      "type": null
    }],
    "returns": null
  }, {
    "name": "_getComponent",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "type",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "HSLDisplay",
  "props": {
    "className": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "value": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "withReplies": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "withVariants": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    }
  }
};

export { ErrorCross as E, HSLForms as H, List as L, PlaceholderIcon as P, ReplyButton as R, SingleProductMessage as S, WhatsAppPLM as W, convertToHSL as a, convertFromHSL$1 as b, convertFromHSL as c, convertToHSL$1 as d, HSLDisplay as e, styles$6 as s };
